/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.

export type UpdateMenuNameInput = {
  language: Language,
  name?: string | null,
  menuId: string,
  schemaId: string,
  tenant: string,
  landscape: string,
};

export enum Language {
  ja = "ja",
  en = "en",
}


export type ModelMenuNameConditionInput = {
  name?: ModelStringInput | null,
  and?: Array< ModelMenuNameConditionInput | null > | null,
  or?: Array< ModelMenuNameConditionInput | null > | null,
  not?: ModelMenuNameConditionInput | null,
};

export type ModelStringInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  size?: ModelSizeInput | null,
};

export enum ModelAttributeTypes {
  binary = "binary",
  binarySet = "binarySet",
  bool = "bool",
  list = "list",
  map = "map",
  number = "number",
  numberSet = "numberSet",
  string = "string",
  stringSet = "stringSet",
  _null = "_null",
}


export type ModelSizeInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
};

export type MenuName = {
  __typename: "MenuName",
  language: Language,
  name?: string | null,
  menuId: string,
  schemaId: string,
  tenant: string,
  landscape: string,
  createdAt: string,
  updatedAt: string,
};

export type UpdateMenuDescriptionInput = {
  language: Language,
  description?: string | null,
  menuId: string,
  schemaId: string,
  tenant: string,
  landscape: string,
};

export type ModelMenuDescriptionConditionInput = {
  description?: ModelStringInput | null,
  and?: Array< ModelMenuDescriptionConditionInput | null > | null,
  or?: Array< ModelMenuDescriptionConditionInput | null > | null,
  not?: ModelMenuDescriptionConditionInput | null,
};

export type MenuDescription = {
  __typename: "MenuDescription",
  language: Language,
  description?: string | null,
  menuId: string,
  schemaId: string,
  tenant: string,
  landscape: string,
  createdAt: string,
  updatedAt: string,
};

export type UpdateCountTableInput = {
  loginName: string,
  tenant: string,
  landscape: string,
  tableName: string,
  totalCount?: number | null,
  isUnRead?: number | null,
  isExpired?: number | null,
};

export type ModelCountTableConditionInput = {
  totalCount?: ModelSizeInput | null,
  isUnRead?: ModelSizeInput | null,
  isExpired?: ModelSizeInput | null,
  and?: Array< ModelCountTableConditionInput | null > | null,
  or?: Array< ModelCountTableConditionInput | null > | null,
  not?: Array< ModelCountTableConditionInput | null > | null,
};

export type CountTable = {
  __typename: "CountTable",
  loginName: string,
  tenant: string,
  landscape: string,
  tableName: TableName,
  totalCount: number,
  isUnRead?: number | null,
  isExpired?: number | null,
  createdAt: string,
  updatedAt: string,
};

export enum TableName {
  Notification = "Notification",
  UserAnnouncement = "UserAnnouncement",
}


export type CreateEventInput = {
  html?: string | null,
  loginName: string,
  tenant: string,
  landscape: string,
};

export type ModelEventConditionInput = {
  html?: ModelStringInput | null,
  and?: Array< ModelEventConditionInput | null > | null,
  or?: Array< ModelEventConditionInput | null > | null,
  not?: ModelEventConditionInput | null,
};

export type Event = {
  __typename: "Event",
  html?: string | null,
  loginName: string,
  tenant: string,
  landscape: string,
  createdAt: string,
  updatedAt: string,
};

export type UpdateEventInput = {
  html?: string | null,
  loginName: string,
  tenant: string,
  landscape: string,
};

export type DeleteEventInput = {
  loginName: string,
  tenant: string,
  landscape: string,
};

export type CreateLinkInput = {
  id?: string | null,
  url: string,
  tenant: string,
  landscape: string,
  sort: number,
};

export type ModelLinkConditionInput = {
  url?: ModelStringInput | null,
  tenant?: ModelStringInput | null,
  landscape?: ModelStringInput | null,
  sort?: ModelIntInput | null,
  and?: Array< ModelLinkConditionInput | null > | null,
  or?: Array< ModelLinkConditionInput | null > | null,
  not?: ModelLinkConditionInput | null,
};

export type ModelIntInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
};

export type Link = {
  __typename: "Link",
  id: string,
  menuDescriptions?: ModelLinkMenuDescriptionConnection | null,
  url: string,
  tenant: string,
  landscape: string,
  sort: number,
  createdAt: string,
  updatedAt: string,
};

export type ModelLinkMenuDescriptionConnection = {
  __typename: "ModelLinkMenuDescriptionConnection",
  items?:  Array<LinkMenuDescription | null > | null,
  nextToken?: string | null,
};

export type LinkMenuDescription = {
  __typename: "LinkMenuDescription",
  language: Language,
  description: string,
  menuId: string,
  tenant: string,
  landscape: string,
  createdAt: string,
  updatedAt: string,
};

export type UpdateLinkInput = {
  id: string,
  url?: string | null,
  tenant?: string | null,
  landscape?: string | null,
  sort?: number | null,
};

export type DeleteLinkInput = {
  id?: string | null,
};

export type CreateMenuInput = {
  menuId: string,
  parentMenuId: string,
  url?: string | null,
  isCategory: _Boolean,
  product: Product,
  schemaId: string,
  loginName: string,
  tenant: string,
  landscape: string,
  tenantLandscapeLoginName: string,
  accessedTimeStamp?: number | null,
  sort: number,
  canUseFromExtra: _Boolean,
  menuIconFont?: string | null,
};

export enum _Boolean {
  _true = "_true",
  _false = "_false",
}


export enum Product {
  CSR = "CSR",
  CWS = "CWS",
  CJK = "CJK",
  CTM = "CTM",
}


export type ModelMenuConditionInput = {
  parentMenuId?: ModelStringInput | null,
  url?: ModelStringInput | null,
  isCategory?: Model_BooleanInput | null,
  product?: ModelProductInput | null,
  schemaId?: ModelStringInput | null,
  tenantLandscapeLoginName?: ModelStringInput | null,
  accessedTimeStamp?: ModelIntInput | null,
  sort?: ModelIntInput | null,
  canUseFromExtra?: Model_BooleanInput | null,
  menuIconFont?: ModelStringInput | null,
  and?: Array< ModelMenuConditionInput | null > | null,
  or?: Array< ModelMenuConditionInput | null > | null,
  not?: ModelMenuConditionInput | null,
};

export type Model_BooleanInput = {
  eq?: _Boolean | null,
  ne?: _Boolean | null,
};

export type ModelProductInput = {
  eq?: Product | null,
  ne?: Product | null,
};

export type Menu = {
  __typename: "Menu",
  menuId: string,
  parentMenuId: string,
  menuNames?: ModelMenuNameConnection | null,
  menuDescriptions?: ModelMenuDescriptionConnection | null,
  url?: string | null,
  isCategory: _Boolean,
  product: Product,
  schemaId: string,
  loginName: string,
  tenant: string,
  landscape: string,
  tenantLandscapeLoginName: string,
  accessedTimeStamp?: number | null,
  sort: number,
  canUseFromExtra: _Boolean,
  menuIconFont?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type ModelMenuNameConnection = {
  __typename: "ModelMenuNameConnection",
  items?:  Array<MenuName | null > | null,
  nextToken?: string | null,
};

export type ModelMenuDescriptionConnection = {
  __typename: "ModelMenuDescriptionConnection",
  items?:  Array<MenuDescription | null > | null,
  nextToken?: string | null,
};

export type UpdateMenuInput = {
  menuId: string,
  parentMenuId?: string | null,
  url?: string | null,
  isCategory?: _Boolean | null,
  product?: Product | null,
  schemaId?: string | null,
  loginName: string,
  tenant: string,
  landscape: string,
  tenantLandscapeLoginName?: string | null,
  accessedTimeStamp?: number | null,
  sort?: number | null,
  canUseFromExtra?: _Boolean | null,
  menuIconFont?: string | null,
};

export type DeleteMenuInput = {
  menuId: string,
  loginName: string,
  tenant: string,
  landscape: string,
};

export type CreateMenuDescriptionInput = {
  language: Language,
  description?: string | null,
  menuId: string,
  schemaId: string,
  tenant: string,
  landscape: string,
};

export type DeleteMenuDescriptionInput = {
  menuId: string,
  language: Language,
  tenant: string,
  landscape: string,
  schemaId: string,
};

export type CreateLinkMenuDescriptionInput = {
  language: Language,
  description: string,
  menuId: string,
  tenant: string,
  landscape: string,
};

export type ModelLinkMenuDescriptionConditionInput = {
  description?: ModelStringInput | null,
  and?: Array< ModelLinkMenuDescriptionConditionInput | null > | null,
  or?: Array< ModelLinkMenuDescriptionConditionInput | null > | null,
  not?: ModelLinkMenuDescriptionConditionInput | null,
};

export type UpdateLinkMenuDescriptionInput = {
  language: Language,
  description?: string | null,
  menuId: string,
  tenant: string,
  landscape: string,
};

export type DeleteLinkMenuDescriptionInput = {
  menuId: string,
  tenant: string,
  landscape: string,
  language: Language,
};

export type CreateMenuNameInput = {
  language: Language,
  name?: string | null,
  menuId: string,
  schemaId: string,
  tenant: string,
  landscape: string,
};

export type DeleteMenuNameInput = {
  menuId: string,
  language: Language,
  tenant: string,
  landscape: string,
  schemaId: string,
};

export type CreateProductMenuNameInput = {
  language: Language,
  name: string,
  menuId: string,
  loginName: string,
  tenant: string,
  landscape: string,
};

export type ModelProductMenuNameConditionInput = {
  name?: ModelStringInput | null,
  and?: Array< ModelProductMenuNameConditionInput | null > | null,
  or?: Array< ModelProductMenuNameConditionInput | null > | null,
  not?: ModelProductMenuNameConditionInput | null,
};

export type ProductMenuName = {
  __typename: "ProductMenuName",
  language: Language,
  name: string,
  menuId: string,
  loginName: string,
  tenant: string,
  landscape: string,
  createdAt: string,
  updatedAt: string,
};

export type UpdateProductMenuNameInput = {
  language: Language,
  name?: string | null,
  menuId: string,
  loginName: string,
  tenant: string,
  landscape: string,
};

export type DeleteProductMenuNameInput = {
  menuId: string,
  loginName: string,
  tenant: string,
  landscape: string,
  language: Language,
};

export type CreateNoticeInput = {
  html?: string | null,
  loginName: string,
  tenant: string,
  landscape: string,
};

export type ModelNoticeConditionInput = {
  html?: ModelStringInput | null,
  and?: Array< ModelNoticeConditionInput | null > | null,
  or?: Array< ModelNoticeConditionInput | null > | null,
  not?: ModelNoticeConditionInput | null,
};

export type Notice = {
  __typename: "Notice",
  html?: string | null,
  loginName: string,
  tenant: string,
  landscape: string,
  createdAt: string,
  updatedAt: string,
};

export type UpdateNoticeInput = {
  html?: string | null,
  loginName: string,
  tenant: string,
  landscape: string,
};

export type DeleteNoticeInput = {
  loginName: string,
  tenant: string,
  landscape: string,
};

export type CreateFlagInput = {
  flag: Target,
  loginName: string,
  tenant: string,
  landscape: string,
};

export enum Target {
  CSR = "CSR",
  CWS = "CWS",
  CJK = "CJK",
  CTM = "CTM",
}


export type ModelFlagConditionInput = {
  and?: Array< ModelFlagConditionInput | null > | null,
  or?: Array< ModelFlagConditionInput | null > | null,
  not?: ModelFlagConditionInput | null,
};

export type Flag = {
  __typename: "Flag",
  flag: Target,
  loginName: string,
  tenant: string,
  landscape: string,
  createdAt: string,
  updatedAt: string,
};

export type UpdateFlagInput = {
  flag: Target,
  loginName: string,
  tenant: string,
  landscape: string,
};

export type DeleteFlagInput = {
  loginName: string,
  tenant: string,
  landscape: string,
  flag: Target,
};

export type CreateUserInput = {
  loginName: string,
  tenant: string,
  landscape: string,
  displaysFavoritePanel: _Boolean,
  isAdmin: _Boolean,
  language: Language,
  name?: string | null,
  affiliation?: string | null,
  csrSchema?: string | null,
  cwsSchema?: string | null,
  cjkSchema?: string | null,
  ctmSchema?: string | null,
  roleId?: string | null,
};

export type ModelUserConditionInput = {
  displaysFavoritePanel?: Model_BooleanInput | null,
  isAdmin?: Model_BooleanInput | null,
  language?: ModelLanguageInput | null,
  name?: ModelStringInput | null,
  affiliation?: ModelStringInput | null,
  csrSchema?: ModelStringInput | null,
  cwsSchema?: ModelStringInput | null,
  cjkSchema?: ModelStringInput | null,
  ctmSchema?: ModelStringInput | null,
  roleId?: ModelIDInput | null,
  and?: Array< ModelUserConditionInput | null > | null,
  or?: Array< ModelUserConditionInput | null > | null,
  not?: ModelUserConditionInput | null,
};

export type ModelLanguageInput = {
  eq?: Language | null,
  ne?: Language | null,
};

export type ModelIDInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  size?: ModelSizeInput | null,
};

export type User = {
  __typename: "User",
  loginName: string,
  tenant: string,
  landscape: string,
  displaysFavoritePanel: _Boolean,
  isAdmin: _Boolean,
  language: Language,
  name?: string | null,
  affiliation?: string | null,
  csrSchema?: string | null,
  cwsSchema?: string | null,
  cjkSchema?: string | null,
  ctmSchema?: string | null,
  event?: Event | null,
  notice?: Notice | null,
  menus?: ModelMenuConnection | null,
  productMenus?: ModelProductMenuConnection | null,
  flags?: ModelFlagConnection | null,
  favorites?: ModelFavoriteConnection | null,
  notifications?: ModelNotificationConnection | null,
  announcements?: ModelUserAnnouncementConnection | null,
  scheduledEventMetadatasByCreatedBy?: ModelScheduledEventMetadataConnection | null,
  scheduledEventMetadatasByUpdatedBy?: ModelScheduledEventMetadataConnection | null,
  scheduledEventHistoriesByExecutedBy?: ModelScheduledEventHistoryConnection | null,
  scheduledHolidayMetadatasByCreatedBy?: ModelScheduledHolidayMetadataConnection | null,
  scheduledHolidayMetadatasByUpdatedBy?: ModelScheduledHolidayMetadataConnection | null,
  productMenuNames?: ModelProductMenuNameConnection | null,
  countTables?: ModelCountTableConnection | null,
  roleId?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type ModelMenuConnection = {
  __typename: "ModelMenuConnection",
  items?:  Array<Menu | null > | null,
  nextToken?: string | null,
};

export type ModelProductMenuConnection = {
  __typename: "ModelProductMenuConnection",
  items?:  Array<ProductMenu | null > | null,
  nextToken?: string | null,
};

export type ProductMenu = {
  __typename: "ProductMenu",
  loginName: string,
  tenant: string,
  landscape: string,
  menuId: string,
  menuNames?: ModelProductMenuNameConnection | null,
  isHome: _Boolean,
  stateKey: string,
  createdAt: string,
  updatedAt: string,
};

export type ModelProductMenuNameConnection = {
  __typename: "ModelProductMenuNameConnection",
  items?:  Array<ProductMenuName | null > | null,
  nextToken?: string | null,
};

export type ModelFlagConnection = {
  __typename: "ModelFlagConnection",
  items?:  Array<Flag | null > | null,
  nextToken?: string | null,
};

export type ModelFavoriteConnection = {
  __typename: "ModelFavoriteConnection",
  items?:  Array<Favorite | null > | null,
  nextToken?: string | null,
};

export type Favorite = {
  __typename: "Favorite",
  sort: number,
  menuId: string,
  loginName: string,
  tenant: string,
  landscape: string,
  createdAt: string,
  updatedAt: string,
};

export type ModelNotificationConnection = {
  __typename: "ModelNotificationConnection",
  items?:  Array<Notification | null > | null,
  nextToken?: string | null,
};

export type Notification = {
  __typename: "Notification",
  loginName: string,
  tenant: string,
  landscape: string,
  tenantLandscapeLoginName: string,
  product: Product,
  notificationId: string,
  content: string,
  iconType?: string | null,
  onClickAction: string,
  extraActions?:  Array<NotificationActions > | null,
  displayStartDate: number,
  displayEndDate?: number | null,
  isRead: _Boolean,
  isFinished: _Boolean,
  createdAt: string,
  updatedAt: string,
};

export type NotificationActions = {
  __typename: "NotificationActions",
  actionName: string,
  onClickAction: string,
};

export type ModelUserAnnouncementConnection = {
  __typename: "ModelUserAnnouncementConnection",
  items?:  Array<UserAnnouncement | null > | null,
  nextToken?: string | null,
};

export type UserAnnouncement = {
  __typename: "UserAnnouncement",
  announcementId: string,
  loginName: string,
  tenant: string,
  landscape: string,
  tenantLandscapeLoginName: string,
  announcement: Announcement,
  displayStartDate: number,
  displayEndDate?: number | null,
  isProcessed: _Boolean,
  isRead: _Boolean,
  isShow: _Boolean,
  createdAt: string,
  updatedAt: string,
};

export type Announcement = {
  __typename: "Announcement",
  id: string,
  tenant: string,
  landscape: string,
  tenantLandscape: string,
  users?: ModelUserAnnouncementConnection | null,
  title: string,
  content: string,
  linkToProductMenu: string,
  isPublic: _Boolean,
  displayStartDate: number,
  displayEndDate?: number | null,
  priorityTag: PriorityTag,
  createdAt: string,
  updatedAt?: string | null,
};

export enum PriorityTag {
  High = "High",
  Medium = "Medium",
  Low = "Low",
}


export type ModelScheduledEventMetadataConnection = {
  __typename: "ModelScheduledEventMetadataConnection",
  items?:  Array<ScheduledEventMetadata | null > | null,
  nextToken?: string | null,
};

export type ScheduledEventMetadata = {
  __typename: "ScheduledEventMetadata",
  id: string,
  tenant: string,
  landscape: string,
  tenantLandscape: string,
  title: string,
  description?: string | null,
  jobId: string,
  job?: Job | null,
  repeatType: RepeatType,
  rruleSet: string,
  holidayExecutionType: HolidayExecutionType,
  useCustomHoliday: _Boolean,
  customHolidayLabels?: Array< string > | null,
  eventTriggerType: EventTriggerType,
  createdBy: string,
  updatedBy: string,
  editedAt?: string | null,
  expirationDate?: number | null,
  createdAt: string,
  updatedAt: string,
};

export type Job = {
  __typename: "Job",
  id: string,
  tenant: string,
  landscape: string,
  tenantLandscape: string,
  jobCode: string,
  title: string,
  description?: string | null,
  jobTriggerFilePath?: string | null,
  tasks?: ModelTaskConnection | null,
  hasOutputFile: _Boolean,
  createdAt: string,
  updatedAt: string,
};

export type ModelTaskConnection = {
  __typename: "ModelTaskConnection",
  items?:  Array<Task | null > | null,
  nextToken?: string | null,
};

export type Task = {
  __typename: "Task",
  version: string,
  product: string,
  batch: string,
  batchName: string,
  versionProductBatch: string,
  jobId: string,
  order: number,
  jobIdOrder: string,
  taskMetadata?: TaskMetadata | null,
  title: string,
  args:  Array<TaskArgs >,
  includeInDownload?: _Boolean | null,
  createdAt: string,
  updatedAt: string,
};

export type TaskMetadata = {
  __typename: "TaskMetadata",
  version: string,
  product: string,
  batch: string,
  batchName: string,
  versionProductBatch: string,
  args:  Array<TaskMetadataArgs >,
  requestBodyPropertyTemplates?:  Array<RequestBodyPropertyTemplate | null > | null,
  createdAt: string,
  updatedAt: string,
};

export type TaskMetadataArgs = {
  __typename: "TaskMetadataArgs",
  required: _Boolean,
  default?: string | null,
  display: _Boolean,
  order: number,
  option: string,
  type: TaskMetadataArgsType,
  delimiter?: string | null,
  isMultiple?: _Boolean | null,
  isOutputFile?: _Boolean | null,
  isInputFile?: _Boolean | null,
  isSecret?: _Boolean | null,
  hints?:  Array<TaskMetadataArgsHint | null > | null,
  labels:  Array<TaskMetadataArgsLabel >,
  sampleInput?: string | null,
  isResolvable?: _Boolean | null,
};

export enum TaskMetadataArgsType {
  StringType = "StringType",
}


export type TaskMetadataArgsHint = {
  __typename: "TaskMetadataArgsHint",
  language: Language,
  hint: string,
};

export type TaskMetadataArgsLabel = {
  __typename: "TaskMetadataArgsLabel",
  language: Language,
  label: string,
};

export type RequestBodyPropertyTemplate = {
  __typename: "RequestBodyPropertyTemplate",
  requestBodyProperty: string,
  template: string,
};

export type TaskArgs = {
  __typename: "TaskArgs",
  order: number,
  option: string,
  value: string,
  replaceInFileName?: _Boolean | null,
};

export enum RepeatType {
  NoRepeat = "NoRepeat",
  Daily = "Daily",
  Monthly = "Monthly",
  Weekly = "Weekly",
  FirstDayOfMonth = "FirstDayOfMonth",
  LastDayOfMonth = "LastDayOfMonth",
}


export enum HolidayExecutionType {
  NoChange = "NoChange",
  Skip = "Skip",
  TriggerAfterHoliday = "TriggerAfterHoliday",
  TriggerBeforeHoliday = "TriggerBeforeHoliday",
}


export enum EventTriggerType {
  Scheduled = "Scheduled",
  Immediate = "Immediate",
  Retry = "Retry",
  ThroughAPI = "ThroughAPI",
  ThroughFsync = "ThroughFsync",
}


export type ModelScheduledEventHistoryConnection = {
  __typename: "ModelScheduledEventHistoryConnection",
  items?:  Array<ScheduledEventHistory | null > | null,
  nextToken?: string | null,
};

export type ScheduledEventHistory = {
  __typename: "ScheduledEventHistory",
  id: string,
  tenant: string,
  landscape: string,
  tenantLandscape: string,
  title: string,
  description?: string | null,
  scheduledEventMetadataId: string,
  scheduledEventMetadata?: ScheduledEventMetadata | null,
  eventStartDateTime: number,
  jobId: string,
  job?: Job | null,
  jobExecutionStatus: JobExecutionStatus,
  tasks?: ModelTaskConnection | null,
  taskHistories?: ModelTaskHistoryConnection | null,
  executedBy: string,
  executionArn?: string | null,
  createdAt: string,
  updatedAt: string,
};

export enum JobExecutionStatus {
  NotTriggered = "NotTriggered",
  Running = "Running",
  Succeeded = "Succeeded",
  Failed = "Failed",
  Aborted = "Aborted",
}


export type ModelTaskHistoryConnection = {
  __typename: "ModelTaskHistoryConnection",
  items?:  Array<TaskHistory | null > | null,
  nextToken?: string | null,
};

export type TaskHistory = {
  __typename: "TaskHistory",
  jobIdOrder: string,
  jobId: string,
  order: number,
  scheduledEventHistoryId: string,
  task?: Task | null,
  tenant: string,
  landscape: string,
  tenantLandscape: string,
  taskStartDateTime?: number | null,
  taskEndDateTime?: number | null,
  taskExecutionStatus: TaskExecutionStatus,
  log: string,
  outputFilePath?: string | null,
  includeInDownload?: _Boolean | null,
  taskTitle?: string | null,
  createdAt: string,
  updatedAt: string,
};

export enum TaskExecutionStatus {
  Running = "Running",
  Succeeded = "Succeeded",
  Failed = "Failed",
  Skipped = "Skipped",
}


export type ModelScheduledHolidayMetadataConnection = {
  __typename: "ModelScheduledHolidayMetadataConnection",
  items?:  Array<ScheduledHolidayMetadata | null > | null,
  nextToken?: string | null,
};

export type ScheduledHolidayMetadata = {
  __typename: "ScheduledHolidayMetadata",
  id: string,
  tenant: string,
  landscape: string,
  tenantLandscape: string,
  title: string,
  description?: string | null,
  repeatType: RepeatType,
  rruleSet: string,
  labels: Array< string >,
  createdBy: string,
  updatedBy: string,
  createdAt: string,
  updatedAt: string,
};

export type ModelCountTableConnection = {
  __typename: "ModelCountTableConnection",
  items?:  Array<CountTable | null > | null,
  nextToken?: string | null,
};

export type UpdateUserInput = {
  loginName: string,
  tenant: string,
  landscape: string,
  displaysFavoritePanel?: _Boolean | null,
  isAdmin?: _Boolean | null,
  language?: Language | null,
  name?: string | null,
  affiliation?: string | null,
  csrSchema?: string | null,
  cwsSchema?: string | null,
  cjkSchema?: string | null,
  ctmSchema?: string | null,
  roleId?: string | null,
};

export type DeleteUserInput = {
  loginName: string,
  tenant: string,
  landscape: string,
};

export type CreateNotificationInput = {
  loginName: string,
  tenant: string,
  landscape: string,
  tenantLandscapeLoginName: string,
  product: Product,
  notificationId: string,
  content?: string | null,
  iconType?: string | null,
  onClickAction?: string | null,
  displayEndDate?: number | null,
  isRead?: _Boolean | null,
  isFinished?: _Boolean | null,
  displayStartDate?: number | null,
};

export type ModelNotificationConditionInput = {
  tenantLandscapeLoginName?: ModelStringInput | null,
  product?: ModelProductInput | null,
  content?: ModelStringInput | null,
  iconType?: ModelStringInput | null,
  onClickAction?: ModelStringInput | null,
  displayStartDate?: ModelIntInput | null,
  displayEndDate?: ModelIntInput | null,
  isRead?: Model_BooleanInput | null,
  isFinished?: Model_BooleanInput | null,
  and?: Array< ModelNotificationConditionInput | null > | null,
  or?: Array< ModelNotificationConditionInput | null > | null,
  not?: ModelNotificationConditionInput | null,
};

export type UpdateNotificationInput = {
  loginName: string,
  tenant: string,
  landscape: string,
  tenantLandscapeLoginName?: string | null,
  product?: Product | null,
  notificationId: string,
  content?: string | null,
  iconType?: string | null,
  onClickAction?: string | null,
  extraActions?: Array< NotificationActionsInput > | null,
  displayStartDate?: number | null,
  displayEndDate?: number | null,
  isRead?: _Boolean | null,
  isFinished?: _Boolean | null,
};

export type NotificationActionsInput = {
  actionName: string,
  onClickAction: string,
};

export type CreateCountTableInput = {
  loginName: string,
  tenant: string,
  landscape: string,
  tableName: TableName,
  totalCount: number,
  isUnRead?: number | null,
  isExpired?: number | null,
};

export type DeleteCountTableInput = {
  loginName: string,
  tenant: string,
  landscape: string,
  tableName: TableName,
};

export type CreateAnnouncementInput = {
  id?: string | null,
  tenant: string,
  landscape: string,
  tenantLandscape: string,
  title: string,
  content: string,
  linkToProductMenu: string,
  isPublic: _Boolean,
  displayStartDate: number,
  displayEndDate?: number | null,
  priorityTag: PriorityTag,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type ModelAnnouncementConditionInput = {
  tenant?: ModelStringInput | null,
  landscape?: ModelStringInput | null,
  tenantLandscape?: ModelStringInput | null,
  title?: ModelStringInput | null,
  content?: ModelStringInput | null,
  linkToProductMenu?: ModelStringInput | null,
  isPublic?: Model_BooleanInput | null,
  displayStartDate?: ModelIntInput | null,
  displayEndDate?: ModelIntInput | null,
  priorityTag?: ModelPriorityTagInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelAnnouncementConditionInput | null > | null,
  or?: Array< ModelAnnouncementConditionInput | null > | null,
  not?: ModelAnnouncementConditionInput | null,
};

export type ModelPriorityTagInput = {
  eq?: PriorityTag | null,
  ne?: PriorityTag | null,
};

export type UpdateAnnouncementInput = {
  id: string,
  tenant?: string | null,
  landscape?: string | null,
  tenantLandscape?: string | null,
  title?: string | null,
  content?: string | null,
  linkToProductMenu?: string | null,
  isPublic?: _Boolean | null,
  displayStartDate?: number | null,
  displayEndDate?: number | null,
  priorityTag?: PriorityTag | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type DeleteAnnouncementInput = {
  id?: string | null,
};

export type CreateUserAnnouncementInput = {
  announcementId: string,
  loginName: string,
  tenant: string,
  landscape: string,
  tenantLandscapeLoginName: string,
  displayStartDate: number,
  displayEndDate?: number | null,
  isProcessed: _Boolean,
  isRead: _Boolean,
  isShow: _Boolean,
};

export type ModelUserAnnouncementConditionInput = {
  tenantLandscapeLoginName?: ModelStringInput | null,
  displayStartDate?: ModelIntInput | null,
  displayEndDate?: ModelIntInput | null,
  isProcessed?: Model_BooleanInput | null,
  isRead?: Model_BooleanInput | null,
  isShow?: Model_BooleanInput | null,
  and?: Array< ModelUserAnnouncementConditionInput | null > | null,
  or?: Array< ModelUserAnnouncementConditionInput | null > | null,
  not?: ModelUserAnnouncementConditionInput | null,
};

export type UpdateUserAnnouncementInput = {
  announcementId: string,
  loginName: string,
  tenant: string,
  landscape: string,
  tenantLandscapeLoginName?: string | null,
  displayStartDate?: number | null,
  displayEndDate?: number | null,
  isProcessed?: _Boolean | null,
  isRead?: _Boolean | null,
  isShow?: _Boolean | null,
};

export type DeleteUserAnnouncementInput = {
  loginName: string,
  tenant: string,
  landscape: string,
  announcementId: string,
};

export type CreateFavoriteInput = {
  sort: number,
  menuId: string,
  loginName: string,
  tenant: string,
  landscape: string,
};

export type ModelFavoriteConditionInput = {
  sort?: ModelIntInput | null,
  and?: Array< ModelFavoriteConditionInput | null > | null,
  or?: Array< ModelFavoriteConditionInput | null > | null,
  not?: ModelFavoriteConditionInput | null,
};

export type UpdateFavoriteInput = {
  sort?: number | null,
  menuId: string,
  loginName: string,
  tenant: string,
  landscape: string,
};

export type DeleteFavoriteInput = {
  menuId: string,
  loginName: string,
  tenant: string,
  landscape: string,
};

export type CreateMenuIndexInput = {
  index: string,
  menuId: string,
  product: Product,
  schema: string,
  language: Language,
  tenant: string,
  landscape: string,
};

export type ModelMenuIndexConditionInput = {
  and?: Array< ModelMenuIndexConditionInput | null > | null,
  or?: Array< ModelMenuIndexConditionInput | null > | null,
  not?: ModelMenuIndexConditionInput | null,
};

export type MenuIndex = {
  __typename: "MenuIndex",
  index: string,
  menuId: string,
  product: Product,
  schema: string,
  language: Language,
  tenant: string,
  landscape: string,
  createdAt: string,
  updatedAt: string,
};

export type UpdateMenuIndexInput = {
  index: string,
  menuId: string,
  product: Product,
  schema: string,
  language: Language,
  tenant: string,
  landscape: string,
};

export type DeleteMenuIndexInput = {
  index: string,
  product: Product,
  schema: string,
  menuId: string,
  language: Language,
  tenant: string,
  landscape: string,
};

export type CreateProductMenuInput = {
  loginName: string,
  tenant: string,
  landscape: string,
  menuId: string,
  isHome: _Boolean,
  stateKey: string,
};

export type ModelProductMenuConditionInput = {
  isHome?: Model_BooleanInput | null,
  stateKey?: ModelStringInput | null,
  and?: Array< ModelProductMenuConditionInput | null > | null,
  or?: Array< ModelProductMenuConditionInput | null > | null,
  not?: ModelProductMenuConditionInput | null,
};

export type UpdateProductMenuInput = {
  loginName: string,
  tenant: string,
  landscape: string,
  menuId: string,
  isHome?: _Boolean | null,
  stateKey?: string | null,
};

export type DeleteProductMenuInput = {
  menuId: string,
  loginName: string,
  tenant: string,
  landscape: string,
};

export type CreateGatewayServerInput = {
  tenant: string,
  landscape: string,
  product: Product,
  useInternetAccess: _Boolean,
  isInternalGateWayServer: _Boolean,
  gatewayServerIps?: Array< string | null > | null,
};

export type ModelGatewayServerConditionInput = {
  useInternetAccess?: Model_BooleanInput | null,
  isInternalGateWayServer?: Model_BooleanInput | null,
  gatewayServerIps?: ModelStringInput | null,
  and?: Array< ModelGatewayServerConditionInput | null > | null,
  or?: Array< ModelGatewayServerConditionInput | null > | null,
  not?: ModelGatewayServerConditionInput | null,
};

export type GatewayServer = {
  __typename: "GatewayServer",
  tenant: string,
  landscape: string,
  product: Product,
  useInternetAccess: _Boolean,
  isInternalGateWayServer: _Boolean,
  gatewayServerIps?: Array< string | null > | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateGatewayServerInput = {
  tenant: string,
  landscape: string,
  product: Product,
  useInternetAccess?: _Boolean | null,
  isInternalGateWayServer?: _Boolean | null,
  gatewayServerIps?: Array< string | null > | null,
};

export type DeleteGatewayServerInput = {
  tenant: string,
  landscape: string,
  product: Product,
};

export type CreateCognitoInfoInput = {
  tenant: string,
  landscape: string,
  identityPoolId: string,
  region: string,
  userPoolId: string,
  userPoolWebClientId: string,
  identityProvider: string,
  amazonCognitoDomain: string,
};

export type ModelCognitoInfoConditionInput = {
  identityPoolId?: ModelStringInput | null,
  region?: ModelStringInput | null,
  userPoolId?: ModelStringInput | null,
  userPoolWebClientId?: ModelStringInput | null,
  identityProvider?: ModelStringInput | null,
  amazonCognitoDomain?: ModelStringInput | null,
  and?: Array< ModelCognitoInfoConditionInput | null > | null,
  or?: Array< ModelCognitoInfoConditionInput | null > | null,
  not?: ModelCognitoInfoConditionInput | null,
};

export type CognitoInfo = {
  __typename: "CognitoInfo",
  tenant: string,
  landscape: string,
  identityPoolId: string,
  region: string,
  userPoolId: string,
  userPoolWebClientId: string,
  identityProvider: string,
  amazonCognitoDomain: string,
  createdAt: string,
  updatedAt: string,
};

export type UpdateCognitoInfoInput = {
  tenant: string,
  landscape: string,
  identityPoolId?: string | null,
  region?: string | null,
  userPoolId?: string | null,
  userPoolWebClientId?: string | null,
  identityProvider?: string | null,
  amazonCognitoDomain?: string | null,
};

export type DeleteCognitoInfoInput = {
  tenant: string,
  landscape: string,
};

export type CreateAPIGatewayInfoInput = {
  tenant: string,
  landscape: string,
  endpoint: string,
};

export type ModelAPIGatewayInfoConditionInput = {
  endpoint?: ModelStringInput | null,
  and?: Array< ModelAPIGatewayInfoConditionInput | null > | null,
  or?: Array< ModelAPIGatewayInfoConditionInput | null > | null,
  not?: ModelAPIGatewayInfoConditionInput | null,
};

export type APIGatewayInfo = {
  __typename: "APIGatewayInfo",
  tenant: string,
  landscape: string,
  endpoint: string,
  createdAt: string,
  updatedAt: string,
};

export type UpdateAPIGatewayInfoInput = {
  tenant: string,
  landscape: string,
  endpoint?: string | null,
};

export type DeleteAPIGatewayInfoInput = {
  tenant: string,
  landscape: string,
};

export type CreateBackendInfoInput = {
  tenant: string,
  landscape: string,
};

export type ModelBackendInfoConditionInput = {
  and?: Array< ModelBackendInfoConditionInput | null > | null,
  or?: Array< ModelBackendInfoConditionInput | null > | null,
  not?: ModelBackendInfoConditionInput | null,
};

export type BackendInfo = {
  __typename: "BackendInfo",
  tenant: string,
  landscape: string,
  apiGatewayInfo?: APIGatewayInfo | null,
  cognitoInfo?: CognitoInfo | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateBackendInfoInput = {
  tenant: string,
  landscape: string,
};

export type DeleteBackendInfoInput = {
  tenant: string,
  landscape: string,
};

export type CreateAuthQueryInput = {
  tenant: string,
  landscape: string,
  identityProvider: string,
  product: Product,
  additionalQuery: string,
};

export type ModelAuthQueryConditionInput = {
  additionalQuery?: ModelStringInput | null,
  and?: Array< ModelAuthQueryConditionInput | null > | null,
  or?: Array< ModelAuthQueryConditionInput | null > | null,
  not?: ModelAuthQueryConditionInput | null,
};

export type AuthQuery = {
  __typename: "AuthQuery",
  tenant: string,
  landscape: string,
  identityProvider: string,
  product: Product,
  additionalQuery: string,
  createdAt: string,
  updatedAt: string,
};

export type UpdateAuthQueryInput = {
  tenant: string,
  landscape: string,
  identityProvider: string,
  product: Product,
  additionalQuery?: string | null,
};

export type DeleteAuthQueryInput = {
  tenant: string,
  landscape: string,
  identityProvider: string,
  product: Product,
};

export type CreateSystemSettingInfoInput = {
  tenant: string,
  landscape: string,
  isMultilanguageEnabled?: _Boolean | null,
  isNotificationEnabled?: _Boolean | null,
  isJobSchedulerEnabled?: _Boolean | null,
  isPortalEnabled?: _Boolean | null,
  announcementSetting?: AnnouncementSetting | null,
};

export enum AnnouncementSetting {
  NotUse = "NotUse",
  UseV1 = "UseV1",
  UseV2 = "UseV2",
}


export type ModelSystemSettingInfoConditionInput = {
  isMultilanguageEnabled?: Model_BooleanInput | null,
  isNotificationEnabled?: Model_BooleanInput | null,
  isJobSchedulerEnabled?: Model_BooleanInput | null,
  isPortalEnabled?: Model_BooleanInput | null,
  announcementSetting?: ModelAnnouncementSettingInput | null,
  and?: Array< ModelSystemSettingInfoConditionInput | null > | null,
  or?: Array< ModelSystemSettingInfoConditionInput | null > | null,
  not?: ModelSystemSettingInfoConditionInput | null,
};

export type ModelAnnouncementSettingInput = {
  eq?: AnnouncementSetting | null,
  ne?: AnnouncementSetting | null,
};

export type SystemSettingInfo = {
  __typename: "SystemSettingInfo",
  tenant: string,
  landscape: string,
  isMultilanguageEnabled?: _Boolean | null,
  isNotificationEnabled?: _Boolean | null,
  isJobSchedulerEnabled?: _Boolean | null,
  isPortalEnabled?: _Boolean | null,
  announcementSetting?: AnnouncementSetting | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateSystemSettingInfoInput = {
  tenant: string,
  landscape: string,
  isMultilanguageEnabled?: _Boolean | null,
  isNotificationEnabled?: _Boolean | null,
  isJobSchedulerEnabled?: _Boolean | null,
  isPortalEnabled?: _Boolean | null,
  announcementSetting?: AnnouncementSetting | null,
};

export type DeleteSystemSettingInfoInput = {
  tenant: string,
  landscape: string,
};

export type CreateCustomerCompanyVersionInput = {
  id?: string | null,
  tenant: string,
  landscape: string,
  tenantLandscape: string,
  version: string,
  product: string,
  applyDateTime: string,
};

export type ModelCustomerCompanyVersionConditionInput = {
  tenant?: ModelStringInput | null,
  landscape?: ModelStringInput | null,
  tenantLandscape?: ModelStringInput | null,
  version?: ModelStringInput | null,
  product?: ModelStringInput | null,
  applyDateTime?: ModelStringInput | null,
  and?: Array< ModelCustomerCompanyVersionConditionInput | null > | null,
  or?: Array< ModelCustomerCompanyVersionConditionInput | null > | null,
  not?: ModelCustomerCompanyVersionConditionInput | null,
};

export type CustomerCompanyVersion = {
  __typename: "CustomerCompanyVersion",
  id: string,
  tenant: string,
  landscape: string,
  tenantLandscape: string,
  version: string,
  product: string,
  applyDateTime: string,
  createdAt: string,
  updatedAt: string,
};

export type UpdateCustomerCompanyVersionInput = {
  id: string,
  tenant?: string | null,
  landscape?: string | null,
  tenantLandscape?: string | null,
  version?: string | null,
  product?: string | null,
  applyDateTime?: string | null,
};

export type DeleteCustomerCompanyVersionInput = {
  id?: string | null,
};

export type CreateTaskMetadataInput = {
  version: string,
  product: string,
  batch: string,
  batchName: string,
  versionProductBatch: string,
  args: Array< TaskMetadataArgsInput >,
  requestBodyPropertyTemplates?: Array< RequestBodyPropertyTemplateInput | null > | null,
};

export type TaskMetadataArgsInput = {
  required: _Boolean,
  default?: string | null,
  display: _Boolean,
  order: number,
  option: string,
  type: TaskMetadataArgsType,
  delimiter?: string | null,
  isMultiple?: _Boolean | null,
  isOutputFile?: _Boolean | null,
  isInputFile?: _Boolean | null,
  isSecret?: _Boolean | null,
  hints?: Array< TaskMetadataArgsHintInput | null > | null,
  labels: Array< TaskMetadataArgsLabelInput >,
  sampleInput?: string | null,
  isResolvable?: _Boolean | null,
};

export type TaskMetadataArgsHintInput = {
  language: Language,
  hint: string,
};

export type TaskMetadataArgsLabelInput = {
  language: Language,
  label: string,
};

export type RequestBodyPropertyTemplateInput = {
  requestBodyProperty: string,
  template: string,
};

export type ModelTaskMetadataConditionInput = {
  version?: ModelStringInput | null,
  product?: ModelStringInput | null,
  batch?: ModelStringInput | null,
  batchName?: ModelStringInput | null,
  and?: Array< ModelTaskMetadataConditionInput | null > | null,
  or?: Array< ModelTaskMetadataConditionInput | null > | null,
  not?: ModelTaskMetadataConditionInput | null,
};

export type UpdateTaskMetadataInput = {
  version?: string | null,
  product?: string | null,
  batch?: string | null,
  batchName?: string | null,
  versionProductBatch: string,
  args?: Array< TaskMetadataArgsInput > | null,
  requestBodyPropertyTemplates?: Array< RequestBodyPropertyTemplateInput | null > | null,
};

export type DeleteTaskMetadataInput = {
  versionProductBatch: string,
};

export type CreateTenantUsingMoveFileTaskInput = {
  tenant: string,
};

export type ModelTenantUsingMoveFileTaskConditionInput = {
  and?: Array< ModelTenantUsingMoveFileTaskConditionInput | null > | null,
  or?: Array< ModelTenantUsingMoveFileTaskConditionInput | null > | null,
  not?: ModelTenantUsingMoveFileTaskConditionInput | null,
};

export type TenantUsingMoveFileTask = {
  __typename: "TenantUsingMoveFileTask",
  tenant: string,
  createdAt: string,
  updatedAt: string,
};

export type UpdateTenantUsingMoveFileTaskInput = {
  tenant: string,
};

export type DeleteTenantUsingMoveFileTaskInput = {
  tenant: string,
};

export type CreateJobInput = {
  id?: string | null,
  tenant: string,
  landscape: string,
  tenantLandscape: string,
  jobCode: string,
  title: string,
  description?: string | null,
  jobTriggerFilePath?: string | null,
  hasOutputFile: _Boolean,
};

export type ModelJobConditionInput = {
  tenant?: ModelStringInput | null,
  landscape?: ModelStringInput | null,
  tenantLandscape?: ModelStringInput | null,
  jobCode?: ModelStringInput | null,
  title?: ModelStringInput | null,
  description?: ModelStringInput | null,
  jobTriggerFilePath?: ModelStringInput | null,
  hasOutputFile?: Model_BooleanInput | null,
  and?: Array< ModelJobConditionInput | null > | null,
  or?: Array< ModelJobConditionInput | null > | null,
  not?: ModelJobConditionInput | null,
};

export type UpdateJobInput = {
  id: string,
  tenant?: string | null,
  landscape?: string | null,
  tenantLandscape?: string | null,
  jobCode?: string | null,
  title?: string | null,
  description?: string | null,
  jobTriggerFilePath?: string | null,
  hasOutputFile?: _Boolean | null,
};

export type DeleteJobInput = {
  id?: string | null,
};

export type CreateTaskInput = {
  version: string,
  product: string,
  batch: string,
  batchName: string,
  versionProductBatch: string,
  jobId: string,
  order: number,
  jobIdOrder: string,
  title: string,
  args: Array< TaskArgsInput >,
  includeInDownload?: _Boolean | null,
};

export type TaskArgsInput = {
  order: number,
  option: string,
  value: string,
  replaceInFileName?: _Boolean | null,
};

export type ModelTaskConditionInput = {
  version?: ModelStringInput | null,
  product?: ModelStringInput | null,
  batch?: ModelStringInput | null,
  batchName?: ModelStringInput | null,
  versionProductBatch?: ModelStringInput | null,
  jobId?: ModelIDInput | null,
  order?: ModelIntInput | null,
  title?: ModelStringInput | null,
  includeInDownload?: Model_BooleanInput | null,
  and?: Array< ModelTaskConditionInput | null > | null,
  or?: Array< ModelTaskConditionInput | null > | null,
  not?: ModelTaskConditionInput | null,
};

export type UpdateTaskInput = {
  version?: string | null,
  product?: string | null,
  batch?: string | null,
  batchName?: string | null,
  versionProductBatch?: string | null,
  jobId?: string | null,
  order?: number | null,
  jobIdOrder: string,
  title?: string | null,
  args?: Array< TaskArgsInput > | null,
  includeInDownload?: _Boolean | null,
};

export type DeleteTaskInput = {
  jobIdOrder: string,
};

export type CreateScheduledEventMetadataInput = {
  id?: string | null,
  tenant: string,
  landscape: string,
  tenantLandscape: string,
  title: string,
  description?: string | null,
  jobId: string,
  repeatType: RepeatType,
  rruleSet: string,
  holidayExecutionType: HolidayExecutionType,
  useCustomHoliday: _Boolean,
  customHolidayLabels?: Array< string > | null,
  eventTriggerType: EventTriggerType,
  createdBy: string,
  updatedBy: string,
  editedAt?: string | null,
  expirationDate?: number | null,
};

export type ModelScheduledEventMetadataConditionInput = {
  tenant?: ModelStringInput | null,
  landscape?: ModelStringInput | null,
  tenantLandscape?: ModelStringInput | null,
  title?: ModelStringInput | null,
  description?: ModelStringInput | null,
  jobId?: ModelIDInput | null,
  repeatType?: ModelRepeatTypeInput | null,
  rruleSet?: ModelStringInput | null,
  holidayExecutionType?: ModelHolidayExecutionTypeInput | null,
  useCustomHoliday?: Model_BooleanInput | null,
  customHolidayLabels?: ModelStringInput | null,
  eventTriggerType?: ModelEventTriggerTypeInput | null,
  createdBy?: ModelStringInput | null,
  updatedBy?: ModelStringInput | null,
  editedAt?: ModelStringInput | null,
  expirationDate?: ModelIntInput | null,
  and?: Array< ModelScheduledEventMetadataConditionInput | null > | null,
  or?: Array< ModelScheduledEventMetadataConditionInput | null > | null,
  not?: ModelScheduledEventMetadataConditionInput | null,
};

export type ModelRepeatTypeInput = {
  eq?: RepeatType | null,
  ne?: RepeatType | null,
};

export type ModelHolidayExecutionTypeInput = {
  eq?: HolidayExecutionType | null,
  ne?: HolidayExecutionType | null,
};

export type ModelEventTriggerTypeInput = {
  eq?: EventTriggerType | null,
  ne?: EventTriggerType | null,
};

export type UpdateScheduledEventMetadataInput = {
  id: string,
  tenant?: string | null,
  landscape?: string | null,
  tenantLandscape?: string | null,
  title?: string | null,
  description?: string | null,
  jobId?: string | null,
  repeatType?: RepeatType | null,
  rruleSet?: string | null,
  holidayExecutionType?: HolidayExecutionType | null,
  useCustomHoliday?: _Boolean | null,
  customHolidayLabels?: Array< string > | null,
  eventTriggerType?: EventTriggerType | null,
  createdBy?: string | null,
  updatedBy?: string | null,
  editedAt?: string | null,
  expirationDate?: number | null,
};

export type DeleteScheduledEventMetadataInput = {
  id?: string | null,
};

export type CreateScheduledEventHistoryInput = {
  id?: string | null,
  tenant: string,
  landscape: string,
  tenantLandscape: string,
  title: string,
  description?: string | null,
  scheduledEventMetadataId: string,
  eventStartDateTime: number,
  jobId: string,
  jobExecutionStatus: JobExecutionStatus,
  executedBy: string,
  executionArn?: string | null,
};

export type ModelScheduledEventHistoryConditionInput = {
  tenant?: ModelStringInput | null,
  landscape?: ModelStringInput | null,
  tenantLandscape?: ModelStringInput | null,
  title?: ModelStringInput | null,
  description?: ModelStringInput | null,
  scheduledEventMetadataId?: ModelIDInput | null,
  eventStartDateTime?: ModelFloatInput | null,
  jobId?: ModelIDInput | null,
  jobExecutionStatus?: ModelJobExecutionStatusInput | null,
  executedBy?: ModelStringInput | null,
  executionArn?: ModelStringInput | null,
  and?: Array< ModelScheduledEventHistoryConditionInput | null > | null,
  or?: Array< ModelScheduledEventHistoryConditionInput | null > | null,
  not?: ModelScheduledEventHistoryConditionInput | null,
};

export type ModelFloatInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
};

export type ModelJobExecutionStatusInput = {
  eq?: JobExecutionStatus | null,
  ne?: JobExecutionStatus | null,
};

export type UpdateScheduledEventHistoryInput = {
  id: string,
  tenant?: string | null,
  landscape?: string | null,
  tenantLandscape?: string | null,
  title?: string | null,
  description?: string | null,
  scheduledEventMetadataId?: string | null,
  eventStartDateTime?: number | null,
  jobId?: string | null,
  jobExecutionStatus?: JobExecutionStatus | null,
  executedBy?: string | null,
  executionArn?: string | null,
};

export type DeleteScheduledEventHistoryInput = {
  id?: string | null,
};

export type CreateTaskHistoryInput = {
  jobIdOrder: string,
  jobId: string,
  order: number,
  scheduledEventHistoryId: string,
  tenant: string,
  landscape: string,
  tenantLandscape: string,
  taskStartDateTime?: number | null,
  taskEndDateTime?: number | null,
  taskExecutionStatus: TaskExecutionStatus,
  log: string,
  outputFilePath?: string | null,
  includeInDownload?: _Boolean | null,
  taskTitle?: string | null,
};

export type ModelTaskHistoryConditionInput = {
  jobId?: ModelIDInput | null,
  order?: ModelIntInput | null,
  tenant?: ModelStringInput | null,
  landscape?: ModelStringInput | null,
  tenantLandscape?: ModelStringInput | null,
  taskStartDateTime?: ModelIntInput | null,
  taskEndDateTime?: ModelIntInput | null,
  taskExecutionStatus?: ModelTaskExecutionStatusInput | null,
  log?: ModelStringInput | null,
  outputFilePath?: ModelStringInput | null,
  includeInDownload?: Model_BooleanInput | null,
  taskTitle?: ModelStringInput | null,
  and?: Array< ModelTaskHistoryConditionInput | null > | null,
  or?: Array< ModelTaskHistoryConditionInput | null > | null,
  not?: ModelTaskHistoryConditionInput | null,
};

export type ModelTaskExecutionStatusInput = {
  eq?: TaskExecutionStatus | null,
  ne?: TaskExecutionStatus | null,
};

export type UpdateTaskHistoryInput = {
  jobIdOrder: string,
  jobId?: string | null,
  order?: number | null,
  scheduledEventHistoryId: string,
  tenant?: string | null,
  landscape?: string | null,
  tenantLandscape?: string | null,
  taskStartDateTime?: number | null,
  taskEndDateTime?: number | null,
  taskExecutionStatus?: TaskExecutionStatus | null,
  log?: string | null,
  outputFilePath?: string | null,
  includeInDownload?: _Boolean | null,
  taskTitle?: string | null,
};

export type DeleteTaskHistoryInput = {
  scheduledEventHistoryId: string,
  jobIdOrder: string,
};

export type CreateScheduledHolidayMetadataInput = {
  id?: string | null,
  tenant: string,
  landscape: string,
  tenantLandscape: string,
  title: string,
  description?: string | null,
  repeatType: RepeatType,
  rruleSet: string,
  labels: Array< string >,
  createdBy: string,
  updatedBy: string,
};

export type ModelScheduledHolidayMetadataConditionInput = {
  tenant?: ModelStringInput | null,
  landscape?: ModelStringInput | null,
  tenantLandscape?: ModelStringInput | null,
  title?: ModelStringInput | null,
  description?: ModelStringInput | null,
  repeatType?: ModelRepeatTypeInput | null,
  rruleSet?: ModelStringInput | null,
  labels?: ModelStringInput | null,
  createdBy?: ModelStringInput | null,
  updatedBy?: ModelStringInput | null,
  and?: Array< ModelScheduledHolidayMetadataConditionInput | null > | null,
  or?: Array< ModelScheduledHolidayMetadataConditionInput | null > | null,
  not?: ModelScheduledHolidayMetadataConditionInput | null,
};

export type UpdateScheduledHolidayMetadataInput = {
  id: string,
  tenant?: string | null,
  landscape?: string | null,
  tenantLandscape?: string | null,
  title?: string | null,
  description?: string | null,
  repeatType?: RepeatType | null,
  rruleSet?: string | null,
  labels?: Array< string > | null,
  createdBy?: string | null,
  updatedBy?: string | null,
};

export type DeleteScheduledHolidayMetadataInput = {
  id?: string | null,
};

export type CreatePublicHolidayInput = {
  startDate: string,
  language: Language,
  title: string,
  label: string,
};

export type ModelPublicHolidayConditionInput = {
  title?: ModelStringInput | null,
  label?: ModelStringInput | null,
  and?: Array< ModelPublicHolidayConditionInput | null > | null,
  or?: Array< ModelPublicHolidayConditionInput | null > | null,
  not?: ModelPublicHolidayConditionInput | null,
};

export type PublicHoliday = {
  __typename: "PublicHoliday",
  startDate: string,
  language: Language,
  title: string,
  label: string,
  createdAt: string,
  updatedAt: string,
};

export type UpdatePublicHolidayInput = {
  startDate: string,
  language: Language,
  title?: string | null,
  label?: string | null,
};

export type DeletePublicHolidayInput = {
  startDate: string,
  language: Language,
};

export type CreateWebsocketConnectionInput = {
  connectionId: string,
  endpoint: string,
  tenant: string,
  landscape: string,
  hostname: string,
};

export type ModelWebsocketConnectionConditionInput = {
  endpoint?: ModelStringInput | null,
  tenant?: ModelStringInput | null,
  landscape?: ModelStringInput | null,
  hostname?: ModelStringInput | null,
  and?: Array< ModelWebsocketConnectionConditionInput | null > | null,
  or?: Array< ModelWebsocketConnectionConditionInput | null > | null,
  not?: ModelWebsocketConnectionConditionInput | null,
};

export type WebsocketConnection = {
  __typename: "WebsocketConnection",
  connectionId: string,
  endpoint: string,
  tenant: string,
  landscape: string,
  hostname: string,
  createdAt: string,
  updatedAt: string,
};

export type UpdateWebsocketConnectionInput = {
  connectionId: string,
  endpoint?: string | null,
  tenant?: string | null,
  landscape?: string | null,
  hostname?: string | null,
};

export type DeleteWebsocketConnectionInput = {
  connectionId: string,
};

export type CreateWebsocketWaitingResponseInput = {
  parentId: string,
  connectionId: string,
  messageType: ResponseExpectedMessageTypes,
  receivedAt: string,
  timeoutAt: string,
};

export enum ResponseExpectedMessageTypes {
  uploadFile = "uploadFile",
  downloadFile = "downloadFile",
  updateConfiguration = "updateConfiguration",
}


export type ModelWebsocketWaitingResponseConditionInput = {
  connectionId?: ModelStringInput | null,
  messageType?: ModelResponseExpectedMessageTypesInput | null,
  receivedAt?: ModelStringInput | null,
  timeoutAt?: ModelStringInput | null,
  and?: Array< ModelWebsocketWaitingResponseConditionInput | null > | null,
  or?: Array< ModelWebsocketWaitingResponseConditionInput | null > | null,
  not?: ModelWebsocketWaitingResponseConditionInput | null,
};

export type ModelResponseExpectedMessageTypesInput = {
  eq?: ResponseExpectedMessageTypes | null,
  ne?: ResponseExpectedMessageTypes | null,
};

export type WebsocketWaitingResponse = {
  __typename: "WebsocketWaitingResponse",
  parentId: string,
  connectionId: string,
  messageType: ResponseExpectedMessageTypes,
  receivedAt: string,
  timeoutAt: string,
  createdAt: string,
  updatedAt: string,
};

export type UpdateWebsocketWaitingResponseInput = {
  parentId: string,
  connectionId?: string | null,
  messageType?: ResponseExpectedMessageTypes | null,
  receivedAt?: string | null,
  timeoutAt?: string | null,
};

export type DeleteWebsocketWaitingResponseInput = {
  parentId: string,
};

export type CreateRoleInput = {
  id?: string | null,
  name: string,
  description?: string | null,
  isDefault: boolean,
  systemType: SystemType,
  tenant: string,
  landscape: string,
  permissions: string,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export enum SystemType {
  FBS = "FBS",
  PORTAL = "PORTAL",
}


export type ModelRoleConditionInput = {
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  isDefault?: ModelBooleanInput | null,
  systemType?: ModelSystemTypeInput | null,
  tenant?: ModelStringInput | null,
  landscape?: ModelStringInput | null,
  permissions?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelRoleConditionInput | null > | null,
  or?: Array< ModelRoleConditionInput | null > | null,
  not?: ModelRoleConditionInput | null,
};

export type ModelBooleanInput = {
  ne?: boolean | null,
  eq?: boolean | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
};

export type ModelSystemTypeInput = {
  eq?: SystemType | null,
  ne?: SystemType | null,
};

export type Role = {
  __typename: "Role",
  id: string,
  name: string,
  description?: string | null,
  isDefault: boolean,
  systemType: SystemType,
  tenant: string,
  landscape: string,
  permissions: string,
  createdAt: string,
  updatedAt: string,
};

export type UpdateRoleInput = {
  id: string,
  name?: string | null,
  description?: string | null,
  isDefault?: boolean | null,
  systemType?: SystemType | null,
  tenant?: string | null,
  landscape?: string | null,
  permissions?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type DeleteRoleInput = {
  id: string,
};

export type Context = {
  __typename: "Context",
  sourceIp?: Array< string | null > | null,
  xForwardedFor?: string | null,
};

export type ModelEventPrimaryCompositeKeyConditionInput = {
  eq?: ModelEventPrimaryCompositeKeyInput | null,
  le?: ModelEventPrimaryCompositeKeyInput | null,
  lt?: ModelEventPrimaryCompositeKeyInput | null,
  ge?: ModelEventPrimaryCompositeKeyInput | null,
  gt?: ModelEventPrimaryCompositeKeyInput | null,
  between?: Array< ModelEventPrimaryCompositeKeyInput | null > | null,
  beginsWith?: ModelEventPrimaryCompositeKeyInput | null,
};

export type ModelEventPrimaryCompositeKeyInput = {
  tenant?: string | null,
  landscape?: string | null,
};

export type ModelEventFilterInput = {
  html?: ModelStringInput | null,
  loginName?: ModelStringInput | null,
  tenant?: ModelStringInput | null,
  landscape?: ModelStringInput | null,
  and?: Array< ModelEventFilterInput | null > | null,
  or?: Array< ModelEventFilterInput | null > | null,
  not?: ModelEventFilterInput | null,
};

export enum ModelSortDirection {
  ASC = "ASC",
  DESC = "DESC",
}


export type ModelEventConnection = {
  __typename: "ModelEventConnection",
  items?:  Array<Event | null > | null,
  nextToken?: string | null,
};

export type ModelLinkFilterInput = {
  id?: ModelIDInput | null,
  url?: ModelStringInput | null,
  tenant?: ModelStringInput | null,
  landscape?: ModelStringInput | null,
  sort?: ModelIntInput | null,
  and?: Array< ModelLinkFilterInput | null > | null,
  or?: Array< ModelLinkFilterInput | null > | null,
  not?: ModelLinkFilterInput | null,
};

export type ModelLinkConnection = {
  __typename: "ModelLinkConnection",
  items?:  Array<Link | null > | null,
  nextToken?: string | null,
};

export type ModelMenuPrimaryCompositeKeyConditionInput = {
  eq?: ModelMenuPrimaryCompositeKeyInput | null,
  le?: ModelMenuPrimaryCompositeKeyInput | null,
  lt?: ModelMenuPrimaryCompositeKeyInput | null,
  ge?: ModelMenuPrimaryCompositeKeyInput | null,
  gt?: ModelMenuPrimaryCompositeKeyInput | null,
  between?: Array< ModelMenuPrimaryCompositeKeyInput | null > | null,
  beginsWith?: ModelMenuPrimaryCompositeKeyInput | null,
};

export type ModelMenuPrimaryCompositeKeyInput = {
  loginName?: string | null,
  tenant?: string | null,
  landscape?: string | null,
};

export type ModelMenuFilterInput = {
  menuId?: ModelStringInput | null,
  parentMenuId?: ModelStringInput | null,
  url?: ModelStringInput | null,
  isCategory?: Model_BooleanInput | null,
  product?: ModelProductInput | null,
  schemaId?: ModelStringInput | null,
  loginName?: ModelStringInput | null,
  tenant?: ModelStringInput | null,
  landscape?: ModelStringInput | null,
  tenantLandscapeLoginName?: ModelStringInput | null,
  accessedTimeStamp?: ModelIntInput | null,
  sort?: ModelIntInput | null,
  canUseFromExtra?: Model_BooleanInput | null,
  menuIconFont?: ModelStringInput | null,
  and?: Array< ModelMenuFilterInput | null > | null,
  or?: Array< ModelMenuFilterInput | null > | null,
  not?: ModelMenuFilterInput | null,
};

export type ModelMenuDescriptionPrimaryCompositeKeyConditionInput = {
  eq?: ModelMenuDescriptionPrimaryCompositeKeyInput | null,
  le?: ModelMenuDescriptionPrimaryCompositeKeyInput | null,
  lt?: ModelMenuDescriptionPrimaryCompositeKeyInput | null,
  ge?: ModelMenuDescriptionPrimaryCompositeKeyInput | null,
  gt?: ModelMenuDescriptionPrimaryCompositeKeyInput | null,
  between?: Array< ModelMenuDescriptionPrimaryCompositeKeyInput | null > | null,
  beginsWith?: ModelMenuDescriptionPrimaryCompositeKeyInput | null,
};

export type ModelMenuDescriptionPrimaryCompositeKeyInput = {
  language?: Language | null,
  tenant?: string | null,
  landscape?: string | null,
  schemaId?: string | null,
};

export type ModelMenuDescriptionFilterInput = {
  language?: ModelLanguageInput | null,
  description?: ModelStringInput | null,
  menuId?: ModelStringInput | null,
  schemaId?: ModelStringInput | null,
  tenant?: ModelStringInput | null,
  landscape?: ModelStringInput | null,
  and?: Array< ModelMenuDescriptionFilterInput | null > | null,
  or?: Array< ModelMenuDescriptionFilterInput | null > | null,
  not?: ModelMenuDescriptionFilterInput | null,
};

export type ModelLinkMenuDescriptionPrimaryCompositeKeyConditionInput = {
  eq?: ModelLinkMenuDescriptionPrimaryCompositeKeyInput | null,
  le?: ModelLinkMenuDescriptionPrimaryCompositeKeyInput | null,
  lt?: ModelLinkMenuDescriptionPrimaryCompositeKeyInput | null,
  ge?: ModelLinkMenuDescriptionPrimaryCompositeKeyInput | null,
  gt?: ModelLinkMenuDescriptionPrimaryCompositeKeyInput | null,
  between?: Array< ModelLinkMenuDescriptionPrimaryCompositeKeyInput | null > | null,
  beginsWith?: ModelLinkMenuDescriptionPrimaryCompositeKeyInput | null,
};

export type ModelLinkMenuDescriptionPrimaryCompositeKeyInput = {
  tenant?: string | null,
  landscape?: string | null,
  language?: Language | null,
};

export type ModelLinkMenuDescriptionFilterInput = {
  language?: ModelLanguageInput | null,
  description?: ModelStringInput | null,
  menuId?: ModelIDInput | null,
  tenant?: ModelStringInput | null,
  landscape?: ModelStringInput | null,
  and?: Array< ModelLinkMenuDescriptionFilterInput | null > | null,
  or?: Array< ModelLinkMenuDescriptionFilterInput | null > | null,
  not?: ModelLinkMenuDescriptionFilterInput | null,
};

export type ModelMenuNamePrimaryCompositeKeyConditionInput = {
  eq?: ModelMenuNamePrimaryCompositeKeyInput | null,
  le?: ModelMenuNamePrimaryCompositeKeyInput | null,
  lt?: ModelMenuNamePrimaryCompositeKeyInput | null,
  ge?: ModelMenuNamePrimaryCompositeKeyInput | null,
  gt?: ModelMenuNamePrimaryCompositeKeyInput | null,
  between?: Array< ModelMenuNamePrimaryCompositeKeyInput | null > | null,
  beginsWith?: ModelMenuNamePrimaryCompositeKeyInput | null,
};

export type ModelMenuNamePrimaryCompositeKeyInput = {
  language?: Language | null,
  tenant?: string | null,
  landscape?: string | null,
  schemaId?: string | null,
};

export type ModelMenuNameFilterInput = {
  language?: ModelLanguageInput | null,
  name?: ModelStringInput | null,
  menuId?: ModelStringInput | null,
  schemaId?: ModelStringInput | null,
  tenant?: ModelStringInput | null,
  landscape?: ModelStringInput | null,
  and?: Array< ModelMenuNameFilterInput | null > | null,
  or?: Array< ModelMenuNameFilterInput | null > | null,
  not?: ModelMenuNameFilterInput | null,
};

export type ModelProductMenuNamePrimaryCompositeKeyConditionInput = {
  eq?: ModelProductMenuNamePrimaryCompositeKeyInput | null,
  le?: ModelProductMenuNamePrimaryCompositeKeyInput | null,
  lt?: ModelProductMenuNamePrimaryCompositeKeyInput | null,
  ge?: ModelProductMenuNamePrimaryCompositeKeyInput | null,
  gt?: ModelProductMenuNamePrimaryCompositeKeyInput | null,
  between?: Array< ModelProductMenuNamePrimaryCompositeKeyInput | null > | null,
  beginsWith?: ModelProductMenuNamePrimaryCompositeKeyInput | null,
};

export type ModelProductMenuNamePrimaryCompositeKeyInput = {
  loginName?: string | null,
  tenant?: string | null,
  landscape?: string | null,
  language?: Language | null,
};

export type ModelProductMenuNameFilterInput = {
  language?: ModelLanguageInput | null,
  name?: ModelStringInput | null,
  menuId?: ModelStringInput | null,
  loginName?: ModelStringInput | null,
  tenant?: ModelStringInput | null,
  landscape?: ModelStringInput | null,
  and?: Array< ModelProductMenuNameFilterInput | null > | null,
  or?: Array< ModelProductMenuNameFilterInput | null > | null,
  not?: ModelProductMenuNameFilterInput | null,
};

export type ModelNoticePrimaryCompositeKeyConditionInput = {
  eq?: ModelNoticePrimaryCompositeKeyInput | null,
  le?: ModelNoticePrimaryCompositeKeyInput | null,
  lt?: ModelNoticePrimaryCompositeKeyInput | null,
  ge?: ModelNoticePrimaryCompositeKeyInput | null,
  gt?: ModelNoticePrimaryCompositeKeyInput | null,
  between?: Array< ModelNoticePrimaryCompositeKeyInput | null > | null,
  beginsWith?: ModelNoticePrimaryCompositeKeyInput | null,
};

export type ModelNoticePrimaryCompositeKeyInput = {
  tenant?: string | null,
  landscape?: string | null,
};

export type ModelNoticeFilterInput = {
  html?: ModelStringInput | null,
  loginName?: ModelStringInput | null,
  tenant?: ModelStringInput | null,
  landscape?: ModelStringInput | null,
  and?: Array< ModelNoticeFilterInput | null > | null,
  or?: Array< ModelNoticeFilterInput | null > | null,
  not?: ModelNoticeFilterInput | null,
};

export type ModelNoticeConnection = {
  __typename: "ModelNoticeConnection",
  items?:  Array<Notice | null > | null,
  nextToken?: string | null,
};

export type ModelFlagPrimaryCompositeKeyConditionInput = {
  eq?: ModelFlagPrimaryCompositeKeyInput | null,
  le?: ModelFlagPrimaryCompositeKeyInput | null,
  lt?: ModelFlagPrimaryCompositeKeyInput | null,
  ge?: ModelFlagPrimaryCompositeKeyInput | null,
  gt?: ModelFlagPrimaryCompositeKeyInput | null,
  between?: Array< ModelFlagPrimaryCompositeKeyInput | null > | null,
  beginsWith?: ModelFlagPrimaryCompositeKeyInput | null,
};

export type ModelFlagPrimaryCompositeKeyInput = {
  tenant?: string | null,
  landscape?: string | null,
  flag?: Target | null,
};

export type ModelFlagFilterInput = {
  flag?: ModelTargetInput | null,
  loginName?: ModelStringInput | null,
  tenant?: ModelStringInput | null,
  landscape?: ModelStringInput | null,
  and?: Array< ModelFlagFilterInput | null > | null,
  or?: Array< ModelFlagFilterInput | null > | null,
  not?: ModelFlagFilterInput | null,
};

export type ModelTargetInput = {
  eq?: Target | null,
  ne?: Target | null,
};

export type ModelUserPrimaryCompositeKeyConditionInput = {
  eq?: ModelUserPrimaryCompositeKeyInput | null,
  le?: ModelUserPrimaryCompositeKeyInput | null,
  lt?: ModelUserPrimaryCompositeKeyInput | null,
  ge?: ModelUserPrimaryCompositeKeyInput | null,
  gt?: ModelUserPrimaryCompositeKeyInput | null,
  between?: Array< ModelUserPrimaryCompositeKeyInput | null > | null,
  beginsWith?: ModelUserPrimaryCompositeKeyInput | null,
};

export type ModelUserPrimaryCompositeKeyInput = {
  tenant?: string | null,
  landscape?: string | null,
};

export type ModelUserFilterInput = {
  loginName?: ModelStringInput | null,
  tenant?: ModelStringInput | null,
  landscape?: ModelStringInput | null,
  displaysFavoritePanel?: Model_BooleanInput | null,
  isAdmin?: Model_BooleanInput | null,
  language?: ModelLanguageInput | null,
  name?: ModelStringInput | null,
  affiliation?: ModelStringInput | null,
  csrSchema?: ModelStringInput | null,
  cwsSchema?: ModelStringInput | null,
  cjkSchema?: ModelStringInput | null,
  ctmSchema?: ModelStringInput | null,
  roleId?: ModelIDInput | null,
  and?: Array< ModelUserFilterInput | null > | null,
  or?: Array< ModelUserFilterInput | null > | null,
  not?: ModelUserFilterInput | null,
};

export type ModelUserConnection = {
  __typename: "ModelUserConnection",
  items?:  Array<User | null > | null,
  nextToken?: string | null,
};

export type ModelNotificationPrimaryCompositeKeyConditionInput = {
  eq?: ModelNotificationPrimaryCompositeKeyInput | null,
  le?: ModelNotificationPrimaryCompositeKeyInput | null,
  lt?: ModelNotificationPrimaryCompositeKeyInput | null,
  ge?: ModelNotificationPrimaryCompositeKeyInput | null,
  gt?: ModelNotificationPrimaryCompositeKeyInput | null,
  between?: Array< ModelNotificationPrimaryCompositeKeyInput | null > | null,
  beginsWith?: ModelNotificationPrimaryCompositeKeyInput | null,
};

export type ModelNotificationPrimaryCompositeKeyInput = {
  loginName?: string | null,
  tenant?: string | null,
  landscape?: string | null,
};

export type ModelNotificationFilterInput = {
  loginName?: ModelStringInput | null,
  tenant?: ModelStringInput | null,
  landscape?: ModelStringInput | null,
  tenantLandscapeLoginName?: ModelStringInput | null,
  product?: ModelProductInput | null,
  notificationId?: ModelStringInput | null,
  content?: ModelStringInput | null,
  iconType?: ModelStringInput | null,
  onClickAction?: ModelStringInput | null,
  displayStartDate?: ModelIntInput | null,
  displayEndDate?: ModelIntInput | null,
  isRead?: Model_BooleanInput | null,
  isFinished?: Model_BooleanInput | null,
  and?: Array< ModelNotificationFilterInput | null > | null,
  or?: Array< ModelNotificationFilterInput | null > | null,
  not?: ModelNotificationFilterInput | null,
};

export type ModelCountTablePrimaryCompositeKeyConditionInput = {
  eq?: ModelCountTablePrimaryCompositeKeyInput | null,
  le?: ModelCountTablePrimaryCompositeKeyInput | null,
  lt?: ModelCountTablePrimaryCompositeKeyInput | null,
  ge?: ModelCountTablePrimaryCompositeKeyInput | null,
  gt?: ModelCountTablePrimaryCompositeKeyInput | null,
  between?: Array< ModelCountTablePrimaryCompositeKeyInput | null > | null,
  beginsWith?: ModelCountTablePrimaryCompositeKeyInput | null,
};

export type ModelCountTablePrimaryCompositeKeyInput = {
  tenant?: string | null,
  landscape?: string | null,
  tableName?: TableName | null,
};

export type ModelCountTableFilterInput = {
  loginName?: ModelStringInput | null,
  tenant?: ModelStringInput | null,
  landscape?: ModelStringInput | null,
  tableName?: ModelTableNameInput | null,
  totalCount?: ModelIntInput | null,
  isUnRead?: ModelIntInput | null,
  isExpired?: ModelIntInput | null,
  and?: Array< ModelCountTableFilterInput | null > | null,
  or?: Array< ModelCountTableFilterInput | null > | null,
  not?: ModelCountTableFilterInput | null,
};

export type ModelTableNameInput = {
  eq?: TableName | null,
  ne?: TableName | null,
};

export type ModelAnnouncementFilterInput = {
  id?: ModelIDInput | null,
  tenant?: ModelStringInput | null,
  landscape?: ModelStringInput | null,
  tenantLandscape?: ModelStringInput | null,
  title?: ModelStringInput | null,
  content?: ModelStringInput | null,
  linkToProductMenu?: ModelStringInput | null,
  isPublic?: Model_BooleanInput | null,
  displayStartDate?: ModelIntInput | null,
  displayEndDate?: ModelIntInput | null,
  priorityTag?: ModelPriorityTagInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelAnnouncementFilterInput | null > | null,
  or?: Array< ModelAnnouncementFilterInput | null > | null,
  not?: ModelAnnouncementFilterInput | null,
};

export type ModelAnnouncementConnection = {
  __typename: "ModelAnnouncementConnection",
  items?:  Array<Announcement | null > | null,
  nextToken?: string | null,
};

export type ModelUserAnnouncementPrimaryCompositeKeyConditionInput = {
  eq?: ModelUserAnnouncementPrimaryCompositeKeyInput | null,
  le?: ModelUserAnnouncementPrimaryCompositeKeyInput | null,
  lt?: ModelUserAnnouncementPrimaryCompositeKeyInput | null,
  ge?: ModelUserAnnouncementPrimaryCompositeKeyInput | null,
  gt?: ModelUserAnnouncementPrimaryCompositeKeyInput | null,
  between?: Array< ModelUserAnnouncementPrimaryCompositeKeyInput | null > | null,
  beginsWith?: ModelUserAnnouncementPrimaryCompositeKeyInput | null,
};

export type ModelUserAnnouncementPrimaryCompositeKeyInput = {
  tenant?: string | null,
  landscape?: string | null,
  announcementId?: string | null,
};

export type ModelUserAnnouncementFilterInput = {
  announcementId?: ModelIDInput | null,
  loginName?: ModelStringInput | null,
  tenant?: ModelStringInput | null,
  landscape?: ModelStringInput | null,
  tenantLandscapeLoginName?: ModelStringInput | null,
  displayStartDate?: ModelIntInput | null,
  displayEndDate?: ModelIntInput | null,
  isProcessed?: Model_BooleanInput | null,
  isRead?: Model_BooleanInput | null,
  isShow?: Model_BooleanInput | null,
  and?: Array< ModelUserAnnouncementFilterInput | null > | null,
  or?: Array< ModelUserAnnouncementFilterInput | null > | null,
  not?: ModelUserAnnouncementFilterInput | null,
};

export type ModelFavoritePrimaryCompositeKeyConditionInput = {
  eq?: ModelFavoritePrimaryCompositeKeyInput | null,
  le?: ModelFavoritePrimaryCompositeKeyInput | null,
  lt?: ModelFavoritePrimaryCompositeKeyInput | null,
  ge?: ModelFavoritePrimaryCompositeKeyInput | null,
  gt?: ModelFavoritePrimaryCompositeKeyInput | null,
  between?: Array< ModelFavoritePrimaryCompositeKeyInput | null > | null,
  beginsWith?: ModelFavoritePrimaryCompositeKeyInput | null,
};

export type ModelFavoritePrimaryCompositeKeyInput = {
  loginName?: string | null,
  tenant?: string | null,
  landscape?: string | null,
};

export type ModelFavoriteFilterInput = {
  sort?: ModelIntInput | null,
  menuId?: ModelStringInput | null,
  loginName?: ModelStringInput | null,
  tenant?: ModelStringInput | null,
  landscape?: ModelStringInput | null,
  and?: Array< ModelFavoriteFilterInput | null > | null,
  or?: Array< ModelFavoriteFilterInput | null > | null,
  not?: ModelFavoriteFilterInput | null,
};

export type ModelMenuIndexPrimaryCompositeKeyConditionInput = {
  eq?: ModelMenuIndexPrimaryCompositeKeyInput | null,
  le?: ModelMenuIndexPrimaryCompositeKeyInput | null,
  lt?: ModelMenuIndexPrimaryCompositeKeyInput | null,
  ge?: ModelMenuIndexPrimaryCompositeKeyInput | null,
  gt?: ModelMenuIndexPrimaryCompositeKeyInput | null,
  between?: Array< ModelMenuIndexPrimaryCompositeKeyInput | null > | null,
  beginsWith?: ModelMenuIndexPrimaryCompositeKeyInput | null,
};

export type ModelMenuIndexPrimaryCompositeKeyInput = {
  product?: Product | null,
  schema?: string | null,
  menuId?: string | null,
  language?: Language | null,
  tenant?: string | null,
  landscape?: string | null,
};

export type ModelMenuIndexFilterInput = {
  index?: ModelStringInput | null,
  menuId?: ModelStringInput | null,
  product?: ModelProductInput | null,
  schema?: ModelStringInput | null,
  language?: ModelLanguageInput | null,
  tenant?: ModelStringInput | null,
  landscape?: ModelStringInput | null,
  and?: Array< ModelMenuIndexFilterInput | null > | null,
  or?: Array< ModelMenuIndexFilterInput | null > | null,
  not?: ModelMenuIndexFilterInput | null,
};

export type ModelMenuIndexConnection = {
  __typename: "ModelMenuIndexConnection",
  items?:  Array<MenuIndex | null > | null,
  nextToken?: string | null,
};

export type ModelProductMenuPrimaryCompositeKeyConditionInput = {
  eq?: ModelProductMenuPrimaryCompositeKeyInput | null,
  le?: ModelProductMenuPrimaryCompositeKeyInput | null,
  lt?: ModelProductMenuPrimaryCompositeKeyInput | null,
  ge?: ModelProductMenuPrimaryCompositeKeyInput | null,
  gt?: ModelProductMenuPrimaryCompositeKeyInput | null,
  between?: Array< ModelProductMenuPrimaryCompositeKeyInput | null > | null,
  beginsWith?: ModelProductMenuPrimaryCompositeKeyInput | null,
};

export type ModelProductMenuPrimaryCompositeKeyInput = {
  loginName?: string | null,
  tenant?: string | null,
  landscape?: string | null,
};

export type ModelProductMenuFilterInput = {
  loginName?: ModelStringInput | null,
  tenant?: ModelStringInput | null,
  landscape?: ModelStringInput | null,
  menuId?: ModelStringInput | null,
  isHome?: Model_BooleanInput | null,
  stateKey?: ModelStringInput | null,
  and?: Array< ModelProductMenuFilterInput | null > | null,
  or?: Array< ModelProductMenuFilterInput | null > | null,
  not?: ModelProductMenuFilterInput | null,
};

export type ModelGatewayServerPrimaryCompositeKeyConditionInput = {
  eq?: ModelGatewayServerPrimaryCompositeKeyInput | null,
  le?: ModelGatewayServerPrimaryCompositeKeyInput | null,
  lt?: ModelGatewayServerPrimaryCompositeKeyInput | null,
  ge?: ModelGatewayServerPrimaryCompositeKeyInput | null,
  gt?: ModelGatewayServerPrimaryCompositeKeyInput | null,
  between?: Array< ModelGatewayServerPrimaryCompositeKeyInput | null > | null,
  beginsWith?: ModelGatewayServerPrimaryCompositeKeyInput | null,
};

export type ModelGatewayServerPrimaryCompositeKeyInput = {
  landscape?: string | null,
  product?: Product | null,
};

export type ModelGatewayServerFilterInput = {
  tenant?: ModelStringInput | null,
  landscape?: ModelStringInput | null,
  product?: ModelProductInput | null,
  useInternetAccess?: Model_BooleanInput | null,
  isInternalGateWayServer?: Model_BooleanInput | null,
  gatewayServerIps?: ModelStringInput | null,
  and?: Array< ModelGatewayServerFilterInput | null > | null,
  or?: Array< ModelGatewayServerFilterInput | null > | null,
  not?: ModelGatewayServerFilterInput | null,
};

export type ModelGatewayServerConnection = {
  __typename: "ModelGatewayServerConnection",
  items?:  Array<GatewayServer | null > | null,
  nextToken?: string | null,
};

export type ModelStringKeyConditionInput = {
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
};

export type ModelCognitoInfoFilterInput = {
  tenant?: ModelStringInput | null,
  landscape?: ModelStringInput | null,
  identityPoolId?: ModelStringInput | null,
  region?: ModelStringInput | null,
  userPoolId?: ModelStringInput | null,
  userPoolWebClientId?: ModelStringInput | null,
  identityProvider?: ModelStringInput | null,
  amazonCognitoDomain?: ModelStringInput | null,
  and?: Array< ModelCognitoInfoFilterInput | null > | null,
  or?: Array< ModelCognitoInfoFilterInput | null > | null,
  not?: ModelCognitoInfoFilterInput | null,
};

export type ModelCognitoInfoConnection = {
  __typename: "ModelCognitoInfoConnection",
  items?:  Array<CognitoInfo | null > | null,
  nextToken?: string | null,
};

export type ModelAPIGatewayInfoFilterInput = {
  tenant?: ModelStringInput | null,
  landscape?: ModelStringInput | null,
  endpoint?: ModelStringInput | null,
  and?: Array< ModelAPIGatewayInfoFilterInput | null > | null,
  or?: Array< ModelAPIGatewayInfoFilterInput | null > | null,
  not?: ModelAPIGatewayInfoFilterInput | null,
};

export type ModelAPIGatewayInfoConnection = {
  __typename: "ModelAPIGatewayInfoConnection",
  items?:  Array<APIGatewayInfo | null > | null,
  nextToken?: string | null,
};

export type ModelBackendInfoFilterInput = {
  tenant?: ModelStringInput | null,
  landscape?: ModelStringInput | null,
  and?: Array< ModelBackendInfoFilterInput | null > | null,
  or?: Array< ModelBackendInfoFilterInput | null > | null,
  not?: ModelBackendInfoFilterInput | null,
};

export type ModelBackendInfoConnection = {
  __typename: "ModelBackendInfoConnection",
  items?:  Array<BackendInfo | null > | null,
  nextToken?: string | null,
};

export type ModelSystemSettingInfoFilterInput = {
  tenant?: ModelStringInput | null,
  landscape?: ModelStringInput | null,
  isMultilanguageEnabled?: Model_BooleanInput | null,
  isNotificationEnabled?: Model_BooleanInput | null,
  isJobSchedulerEnabled?: Model_BooleanInput | null,
  isPortalEnabled?: Model_BooleanInput | null,
  announcementSetting?: ModelAnnouncementSettingInput | null,
  and?: Array< ModelSystemSettingInfoFilterInput | null > | null,
  or?: Array< ModelSystemSettingInfoFilterInput | null > | null,
  not?: ModelSystemSettingInfoFilterInput | null,
};

export type ModelSystemSettingInfoConnection = {
  __typename: "ModelSystemSettingInfoConnection",
  items?:  Array<SystemSettingInfo | null > | null,
  nextToken?: string | null,
};

export type ModelAuthQueryPrimaryCompositeKeyConditionInput = {
  eq?: ModelAuthQueryPrimaryCompositeKeyInput | null,
  le?: ModelAuthQueryPrimaryCompositeKeyInput | null,
  lt?: ModelAuthQueryPrimaryCompositeKeyInput | null,
  ge?: ModelAuthQueryPrimaryCompositeKeyInput | null,
  gt?: ModelAuthQueryPrimaryCompositeKeyInput | null,
  between?: Array< ModelAuthQueryPrimaryCompositeKeyInput | null > | null,
  beginsWith?: ModelAuthQueryPrimaryCompositeKeyInput | null,
};

export type ModelAuthQueryPrimaryCompositeKeyInput = {
  landscape?: string | null,
  identityProvider?: string | null,
  product?: Product | null,
};

export type ModelAuthQueryFilterInput = {
  tenant?: ModelStringInput | null,
  landscape?: ModelStringInput | null,
  identityProvider?: ModelStringInput | null,
  product?: ModelProductInput | null,
  additionalQuery?: ModelStringInput | null,
  and?: Array< ModelAuthQueryFilterInput | null > | null,
  or?: Array< ModelAuthQueryFilterInput | null > | null,
  not?: ModelAuthQueryFilterInput | null,
};

export type ModelAuthQueryConnection = {
  __typename: "ModelAuthQueryConnection",
  items?:  Array<AuthQuery | null > | null,
  nextToken?: string | null,
};

export type ModelCustomerCompanyVersionFilterInput = {
  id?: ModelIDInput | null,
  tenant?: ModelStringInput | null,
  landscape?: ModelStringInput | null,
  tenantLandscape?: ModelStringInput | null,
  version?: ModelStringInput | null,
  product?: ModelStringInput | null,
  applyDateTime?: ModelStringInput | null,
  and?: Array< ModelCustomerCompanyVersionFilterInput | null > | null,
  or?: Array< ModelCustomerCompanyVersionFilterInput | null > | null,
  not?: ModelCustomerCompanyVersionFilterInput | null,
};

export type ModelCustomerCompanyVersionConnection = {
  __typename: "ModelCustomerCompanyVersionConnection",
  items?:  Array<CustomerCompanyVersion | null > | null,
  nextToken?: string | null,
};

export type ModelTaskMetadataFilterInput = {
  version?: ModelStringInput | null,
  product?: ModelStringInput | null,
  batch?: ModelStringInput | null,
  batchName?: ModelStringInput | null,
  versionProductBatch?: ModelStringInput | null,
  and?: Array< ModelTaskMetadataFilterInput | null > | null,
  or?: Array< ModelTaskMetadataFilterInput | null > | null,
  not?: ModelTaskMetadataFilterInput | null,
};

export type ModelTaskMetadataConnection = {
  __typename: "ModelTaskMetadataConnection",
  items?:  Array<TaskMetadata | null > | null,
  nextToken?: string | null,
};

export type ModelTenantUsingMoveFileTaskFilterInput = {
  tenant?: ModelStringInput | null,
  and?: Array< ModelTenantUsingMoveFileTaskFilterInput | null > | null,
  or?: Array< ModelTenantUsingMoveFileTaskFilterInput | null > | null,
  not?: ModelTenantUsingMoveFileTaskFilterInput | null,
};

export type ModelTenantUsingMoveFileTaskConnection = {
  __typename: "ModelTenantUsingMoveFileTaskConnection",
  items?:  Array<TenantUsingMoveFileTask | null > | null,
  nextToken?: string | null,
};

export type ModelJobFilterInput = {
  id?: ModelIDInput | null,
  tenant?: ModelStringInput | null,
  landscape?: ModelStringInput | null,
  tenantLandscape?: ModelStringInput | null,
  jobCode?: ModelStringInput | null,
  title?: ModelStringInput | null,
  description?: ModelStringInput | null,
  jobTriggerFilePath?: ModelStringInput | null,
  hasOutputFile?: Model_BooleanInput | null,
  and?: Array< ModelJobFilterInput | null > | null,
  or?: Array< ModelJobFilterInput | null > | null,
  not?: ModelJobFilterInput | null,
};

export type ModelJobConnection = {
  __typename: "ModelJobConnection",
  items?:  Array<Job | null > | null,
  nextToken?: string | null,
};

export type ModelTaskFilterInput = {
  version?: ModelStringInput | null,
  product?: ModelStringInput | null,
  batch?: ModelStringInput | null,
  batchName?: ModelStringInput | null,
  versionProductBatch?: ModelStringInput | null,
  jobId?: ModelIDInput | null,
  order?: ModelIntInput | null,
  jobIdOrder?: ModelStringInput | null,
  title?: ModelStringInput | null,
  includeInDownload?: Model_BooleanInput | null,
  and?: Array< ModelTaskFilterInput | null > | null,
  or?: Array< ModelTaskFilterInput | null > | null,
  not?: ModelTaskFilterInput | null,
};

export type ModelScheduledEventMetadataFilterInput = {
  id?: ModelIDInput | null,
  tenant?: ModelStringInput | null,
  landscape?: ModelStringInput | null,
  tenantLandscape?: ModelStringInput | null,
  title?: ModelStringInput | null,
  description?: ModelStringInput | null,
  jobId?: ModelIDInput | null,
  repeatType?: ModelRepeatTypeInput | null,
  rruleSet?: ModelStringInput | null,
  holidayExecutionType?: ModelHolidayExecutionTypeInput | null,
  useCustomHoliday?: Model_BooleanInput | null,
  customHolidayLabels?: ModelStringInput | null,
  eventTriggerType?: ModelEventTriggerTypeInput | null,
  createdBy?: ModelStringInput | null,
  updatedBy?: ModelStringInput | null,
  editedAt?: ModelStringInput | null,
  expirationDate?: ModelIntInput | null,
  and?: Array< ModelScheduledEventMetadataFilterInput | null > | null,
  or?: Array< ModelScheduledEventMetadataFilterInput | null > | null,
  not?: ModelScheduledEventMetadataFilterInput | null,
};

export type ModelScheduledEventHistoryFilterInput = {
  id?: ModelIDInput | null,
  tenant?: ModelStringInput | null,
  landscape?: ModelStringInput | null,
  tenantLandscape?: ModelStringInput | null,
  title?: ModelStringInput | null,
  description?: ModelStringInput | null,
  scheduledEventMetadataId?: ModelIDInput | null,
  eventStartDateTime?: ModelFloatInput | null,
  jobId?: ModelIDInput | null,
  jobExecutionStatus?: ModelJobExecutionStatusInput | null,
  executedBy?: ModelStringInput | null,
  executionArn?: ModelStringInput | null,
  and?: Array< ModelScheduledEventHistoryFilterInput | null > | null,
  or?: Array< ModelScheduledEventHistoryFilterInput | null > | null,
  not?: ModelScheduledEventHistoryFilterInput | null,
};

export type ModelTaskHistoryFilterInput = {
  jobIdOrder?: ModelStringInput | null,
  jobId?: ModelIDInput | null,
  order?: ModelIntInput | null,
  scheduledEventHistoryId?: ModelIDInput | null,
  tenant?: ModelStringInput | null,
  landscape?: ModelStringInput | null,
  tenantLandscape?: ModelStringInput | null,
  taskStartDateTime?: ModelIntInput | null,
  taskEndDateTime?: ModelIntInput | null,
  taskExecutionStatus?: ModelTaskExecutionStatusInput | null,
  log?: ModelStringInput | null,
  outputFilePath?: ModelStringInput | null,
  includeInDownload?: Model_BooleanInput | null,
  taskTitle?: ModelStringInput | null,
  and?: Array< ModelTaskHistoryFilterInput | null > | null,
  or?: Array< ModelTaskHistoryFilterInput | null > | null,
  not?: ModelTaskHistoryFilterInput | null,
};

export type ModelScheduledHolidayMetadataFilterInput = {
  id?: ModelIDInput | null,
  tenant?: ModelStringInput | null,
  landscape?: ModelStringInput | null,
  tenantLandscape?: ModelStringInput | null,
  title?: ModelStringInput | null,
  description?: ModelStringInput | null,
  repeatType?: ModelRepeatTypeInput | null,
  rruleSet?: ModelStringInput | null,
  labels?: ModelStringInput | null,
  createdBy?: ModelStringInput | null,
  updatedBy?: ModelStringInput | null,
  and?: Array< ModelScheduledHolidayMetadataFilterInput | null > | null,
  or?: Array< ModelScheduledHolidayMetadataFilterInput | null > | null,
  not?: ModelScheduledHolidayMetadataFilterInput | null,
};

export type ModelPublicHolidayFilterInput = {
  startDate?: ModelStringInput | null,
  language?: ModelLanguageInput | null,
  title?: ModelStringInput | null,
  label?: ModelStringInput | null,
  and?: Array< ModelPublicHolidayFilterInput | null > | null,
  or?: Array< ModelPublicHolidayFilterInput | null > | null,
  not?: ModelPublicHolidayFilterInput | null,
};

export type ModelPublicHolidayConnection = {
  __typename: "ModelPublicHolidayConnection",
  items?:  Array<PublicHoliday | null > | null,
  nextToken?: string | null,
};

export type ModelWebsocketConnectionFilterInput = {
  connectionId?: ModelStringInput | null,
  endpoint?: ModelStringInput | null,
  tenant?: ModelStringInput | null,
  landscape?: ModelStringInput | null,
  hostname?: ModelStringInput | null,
  and?: Array< ModelWebsocketConnectionFilterInput | null > | null,
  or?: Array< ModelWebsocketConnectionFilterInput | null > | null,
  not?: ModelWebsocketConnectionFilterInput | null,
};

export type ModelWebsocketConnectionConnection = {
  __typename: "ModelWebsocketConnectionConnection",
  items?:  Array<WebsocketConnection | null > | null,
  nextToken?: string | null,
};

export type ModelWebsocketWaitingResponseFilterInput = {
  parentId?: ModelStringInput | null,
  connectionId?: ModelStringInput | null,
  messageType?: ModelResponseExpectedMessageTypesInput | null,
  receivedAt?: ModelStringInput | null,
  timeoutAt?: ModelStringInput | null,
  and?: Array< ModelWebsocketWaitingResponseFilterInput | null > | null,
  or?: Array< ModelWebsocketWaitingResponseFilterInput | null > | null,
  not?: ModelWebsocketWaitingResponseFilterInput | null,
};

export type ModelWebsocketWaitingResponseConnection = {
  __typename: "ModelWebsocketWaitingResponseConnection",
  items?:  Array<WebsocketWaitingResponse | null > | null,
  nextToken?: string | null,
};

export type ModelRoleFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  isDefault?: ModelBooleanInput | null,
  systemType?: ModelSystemTypeInput | null,
  tenant?: ModelStringInput | null,
  landscape?: ModelStringInput | null,
  permissions?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelRoleFilterInput | null > | null,
  or?: Array< ModelRoleFilterInput | null > | null,
  not?: ModelRoleFilterInput | null,
};

export type ModelRoleConnection = {
  __typename: "ModelRoleConnection",
  items?:  Array<Role | null > | null,
  nextToken?: string | null,
};

export type ModelIntKeyConditionInput = {
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
};

export type ModelMenuProductIndexCompositeKeyConditionInput = {
  eq?: ModelMenuProductIndexCompositeKeyInput | null,
  le?: ModelMenuProductIndexCompositeKeyInput | null,
  lt?: ModelMenuProductIndexCompositeKeyInput | null,
  ge?: ModelMenuProductIndexCompositeKeyInput | null,
  gt?: ModelMenuProductIndexCompositeKeyInput | null,
  between?: Array< ModelMenuProductIndexCompositeKeyInput | null > | null,
  beginsWith?: ModelMenuProductIndexCompositeKeyInput | null,
};

export type ModelMenuProductIndexCompositeKeyInput = {
  tenant?: string | null,
  landscape?: string | null,
  product?: Product | null,
};

export type ModelNotificationUserNotificationCompositeKeyConditionInput = {
  eq?: ModelNotificationUserNotificationCompositeKeyInput | null,
  le?: ModelNotificationUserNotificationCompositeKeyInput | null,
  lt?: ModelNotificationUserNotificationCompositeKeyInput | null,
  ge?: ModelNotificationUserNotificationCompositeKeyInput | null,
  gt?: ModelNotificationUserNotificationCompositeKeyInput | null,
  between?: Array< ModelNotificationUserNotificationCompositeKeyInput | null > | null,
  beginsWith?: ModelNotificationUserNotificationCompositeKeyInput | null,
};

export type ModelNotificationUserNotificationCompositeKeyInput = {
  tenant?: string | null,
  landscape?: string | null,
};

export type ModelCountTableTenantLandscapeAndLoginNameIndexCompositeKeyConditionInput = {
  eq?: ModelCountTableTenantLandscapeAndLoginNameIndexCompositeKeyInput | null,
  le?: ModelCountTableTenantLandscapeAndLoginNameIndexCompositeKeyInput | null,
  lt?: ModelCountTableTenantLandscapeAndLoginNameIndexCompositeKeyInput | null,
  ge?: ModelCountTableTenantLandscapeAndLoginNameIndexCompositeKeyInput | null,
  gt?: ModelCountTableTenantLandscapeAndLoginNameIndexCompositeKeyInput | null,
  between?: Array< ModelCountTableTenantLandscapeAndLoginNameIndexCompositeKeyInput | null > | null,
  beginsWith?: ModelCountTableTenantLandscapeAndLoginNameIndexCompositeKeyInput | null,
};

export type ModelCountTableTenantLandscapeAndLoginNameIndexCompositeKeyInput = {
  landscape?: string | null,
  loginName?: string | null,
};

export type ModelUserAnnouncementUserAnnouncementIndexbyUserCompositeKeyConditionInput = {
  eq?: ModelUserAnnouncementUserAnnouncementIndexbyUserCompositeKeyInput | null,
  le?: ModelUserAnnouncementUserAnnouncementIndexbyUserCompositeKeyInput | null,
  lt?: ModelUserAnnouncementUserAnnouncementIndexbyUserCompositeKeyInput | null,
  ge?: ModelUserAnnouncementUserAnnouncementIndexbyUserCompositeKeyInput | null,
  gt?: ModelUserAnnouncementUserAnnouncementIndexbyUserCompositeKeyInput | null,
  between?: Array< ModelUserAnnouncementUserAnnouncementIndexbyUserCompositeKeyInput | null > | null,
  beginsWith?: ModelUserAnnouncementUserAnnouncementIndexbyUserCompositeKeyInput | null,
};

export type ModelUserAnnouncementUserAnnouncementIndexbyUserCompositeKeyInput = {
  tenant?: string | null,
  landscape?: string | null,
};

export type ModelFavoriteSortIndexCompositeKeyConditionInput = {
  eq?: ModelFavoriteSortIndexCompositeKeyInput | null,
  le?: ModelFavoriteSortIndexCompositeKeyInput | null,
  lt?: ModelFavoriteSortIndexCompositeKeyInput | null,
  ge?: ModelFavoriteSortIndexCompositeKeyInput | null,
  gt?: ModelFavoriteSortIndexCompositeKeyInput | null,
  between?: Array< ModelFavoriteSortIndexCompositeKeyInput | null > | null,
  beginsWith?: ModelFavoriteSortIndexCompositeKeyInput | null,
};

export type ModelFavoriteSortIndexCompositeKeyInput = {
  tenant?: string | null,
  landscape?: string | null,
  sort?: number | null,
};

export type ModelFavoriteUserFavoritesCompositeKeyConditionInput = {
  eq?: ModelFavoriteUserFavoritesCompositeKeyInput | null,
  le?: ModelFavoriteUserFavoritesCompositeKeyInput | null,
  lt?: ModelFavoriteUserFavoritesCompositeKeyInput | null,
  ge?: ModelFavoriteUserFavoritesCompositeKeyInput | null,
  gt?: ModelFavoriteUserFavoritesCompositeKeyInput | null,
  between?: Array< ModelFavoriteUserFavoritesCompositeKeyInput | null > | null,
  beginsWith?: ModelFavoriteUserFavoritesCompositeKeyInput | null,
};

export type ModelFavoriteUserFavoritesCompositeKeyInput = {
  tenant?: string | null,
  landscape?: string | null,
};

export type ModelMenuIndexMenuIdIndexCompositeKeyConditionInput = {
  eq?: ModelMenuIndexMenuIdIndexCompositeKeyInput | null,
  le?: ModelMenuIndexMenuIdIndexCompositeKeyInput | null,
  lt?: ModelMenuIndexMenuIdIndexCompositeKeyInput | null,
  ge?: ModelMenuIndexMenuIdIndexCompositeKeyInput | null,
  gt?: ModelMenuIndexMenuIdIndexCompositeKeyInput | null,
  between?: Array< ModelMenuIndexMenuIdIndexCompositeKeyInput | null > | null,
  beginsWith?: ModelMenuIndexMenuIdIndexCompositeKeyInput | null,
};

export type ModelMenuIndexMenuIdIndexCompositeKeyInput = {
  product?: Product | null,
  schema?: string | null,
  language?: Language | null,
  tenant?: string | null,
  landscape?: string | null,
};

export type ModelMenuIndexIndexIndexCompositeKeyConditionInput = {
  eq?: ModelMenuIndexIndexIndexCompositeKeyInput | null,
  le?: ModelMenuIndexIndexIndexCompositeKeyInput | null,
  lt?: ModelMenuIndexIndexIndexCompositeKeyInput | null,
  ge?: ModelMenuIndexIndexIndexCompositeKeyInput | null,
  gt?: ModelMenuIndexIndexIndexCompositeKeyInput | null,
  between?: Array< ModelMenuIndexIndexIndexCompositeKeyInput | null > | null,
  beginsWith?: ModelMenuIndexIndexIndexCompositeKeyInput | null,
};

export type ModelMenuIndexIndexIndexCompositeKeyInput = {
  product?: Product | null,
  schema?: string | null,
  language?: Language | null,
  tenant?: string | null,
  landscape?: string | null,
};

export type ModelIDKeyConditionInput = {
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
};

export type ModelScheduledEventMetadataCreatedByTenantAndLandscapeIndexCompositeKeyConditionInput = {
  eq?: ModelScheduledEventMetadataCreatedByTenantAndLandscapeIndexCompositeKeyInput | null,
  le?: ModelScheduledEventMetadataCreatedByTenantAndLandscapeIndexCompositeKeyInput | null,
  lt?: ModelScheduledEventMetadataCreatedByTenantAndLandscapeIndexCompositeKeyInput | null,
  ge?: ModelScheduledEventMetadataCreatedByTenantAndLandscapeIndexCompositeKeyInput | null,
  gt?: ModelScheduledEventMetadataCreatedByTenantAndLandscapeIndexCompositeKeyInput | null,
  between?: Array< ModelScheduledEventMetadataCreatedByTenantAndLandscapeIndexCompositeKeyInput | null > | null,
  beginsWith?: ModelScheduledEventMetadataCreatedByTenantAndLandscapeIndexCompositeKeyInput | null,
};

export type ModelScheduledEventMetadataCreatedByTenantAndLandscapeIndexCompositeKeyInput = {
  tenant?: string | null,
  landscape?: string | null,
};

export type ModelScheduledEventMetadataUpdatedByTenantAndLandscapeIndexCompositeKeyConditionInput = {
  eq?: ModelScheduledEventMetadataUpdatedByTenantAndLandscapeIndexCompositeKeyInput | null,
  le?: ModelScheduledEventMetadataUpdatedByTenantAndLandscapeIndexCompositeKeyInput | null,
  lt?: ModelScheduledEventMetadataUpdatedByTenantAndLandscapeIndexCompositeKeyInput | null,
  ge?: ModelScheduledEventMetadataUpdatedByTenantAndLandscapeIndexCompositeKeyInput | null,
  gt?: ModelScheduledEventMetadataUpdatedByTenantAndLandscapeIndexCompositeKeyInput | null,
  between?: Array< ModelScheduledEventMetadataUpdatedByTenantAndLandscapeIndexCompositeKeyInput | null > | null,
  beginsWith?: ModelScheduledEventMetadataUpdatedByTenantAndLandscapeIndexCompositeKeyInput | null,
};

export type ModelScheduledEventMetadataUpdatedByTenantAndLandscapeIndexCompositeKeyInput = {
  tenant?: string | null,
  landscape?: string | null,
};

export type ModelFloatKeyConditionInput = {
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
};

export type ModelScheduledEventHistoryExecutedByTenantAndLandscapeIndexCompositeKeyConditionInput = {
  eq?: ModelScheduledEventHistoryExecutedByTenantAndLandscapeIndexCompositeKeyInput | null,
  le?: ModelScheduledEventHistoryExecutedByTenantAndLandscapeIndexCompositeKeyInput | null,
  lt?: ModelScheduledEventHistoryExecutedByTenantAndLandscapeIndexCompositeKeyInput | null,
  ge?: ModelScheduledEventHistoryExecutedByTenantAndLandscapeIndexCompositeKeyInput | null,
  gt?: ModelScheduledEventHistoryExecutedByTenantAndLandscapeIndexCompositeKeyInput | null,
  between?: Array< ModelScheduledEventHistoryExecutedByTenantAndLandscapeIndexCompositeKeyInput | null > | null,
  beginsWith?: ModelScheduledEventHistoryExecutedByTenantAndLandscapeIndexCompositeKeyInput | null,
};

export type ModelScheduledEventHistoryExecutedByTenantAndLandscapeIndexCompositeKeyInput = {
  tenant?: string | null,
  landscape?: string | null,
};

export type ModelScheduledHolidayMetadataCreatedByTenantAndLandscapeIndexCompositeKeyConditionInput = {
  eq?: ModelScheduledHolidayMetadataCreatedByTenantAndLandscapeIndexCompositeKeyInput | null,
  le?: ModelScheduledHolidayMetadataCreatedByTenantAndLandscapeIndexCompositeKeyInput | null,
  lt?: ModelScheduledHolidayMetadataCreatedByTenantAndLandscapeIndexCompositeKeyInput | null,
  ge?: ModelScheduledHolidayMetadataCreatedByTenantAndLandscapeIndexCompositeKeyInput | null,
  gt?: ModelScheduledHolidayMetadataCreatedByTenantAndLandscapeIndexCompositeKeyInput | null,
  between?: Array< ModelScheduledHolidayMetadataCreatedByTenantAndLandscapeIndexCompositeKeyInput | null > | null,
  beginsWith?: ModelScheduledHolidayMetadataCreatedByTenantAndLandscapeIndexCompositeKeyInput | null,
};

export type ModelScheduledHolidayMetadataCreatedByTenantAndLandscapeIndexCompositeKeyInput = {
  tenant?: string | null,
  landscape?: string | null,
};

export type ModelScheduledHolidayMetadataUpdatedByTenantAndLandscapeIndexCompositeKeyConditionInput = {
  eq?: ModelScheduledHolidayMetadataUpdatedByTenantAndLandscapeIndexCompositeKeyInput | null,
  le?: ModelScheduledHolidayMetadataUpdatedByTenantAndLandscapeIndexCompositeKeyInput | null,
  lt?: ModelScheduledHolidayMetadataUpdatedByTenantAndLandscapeIndexCompositeKeyInput | null,
  ge?: ModelScheduledHolidayMetadataUpdatedByTenantAndLandscapeIndexCompositeKeyInput | null,
  gt?: ModelScheduledHolidayMetadataUpdatedByTenantAndLandscapeIndexCompositeKeyInput | null,
  between?: Array< ModelScheduledHolidayMetadataUpdatedByTenantAndLandscapeIndexCompositeKeyInput | null > | null,
  beginsWith?: ModelScheduledHolidayMetadataUpdatedByTenantAndLandscapeIndexCompositeKeyInput | null,
};

export type ModelScheduledHolidayMetadataUpdatedByTenantAndLandscapeIndexCompositeKeyInput = {
  tenant?: string | null,
  landscape?: string | null,
};

export type UpdateMenuNameWithoutUpdatedAtMutationVariables = {
  input: UpdateMenuNameInput,
  condition?: ModelMenuNameConditionInput | null,
};

export type UpdateMenuNameWithoutUpdatedAtMutation = {
  updateMenuNameWithoutUpdatedAt?:  {
    __typename: "MenuName",
    language: Language,
    name?: string | null,
    menuId: string,
    schemaId: string,
    tenant: string,
    landscape: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateMenuDescriptionWithoutUpdatedAtMutationVariables = {
  input: UpdateMenuDescriptionInput,
  condition?: ModelMenuDescriptionConditionInput | null,
};

export type UpdateMenuDescriptionWithoutUpdatedAtMutation = {
  updateMenuDescriptionWithoutUpdatedAt?:  {
    __typename: "MenuDescription",
    language: Language,
    description?: string | null,
    menuId: string,
    schemaId: string,
    tenant: string,
    landscape: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateCountTableWithIncrementMutationVariables = {
  input: UpdateCountTableInput,
  condition?: ModelCountTableConditionInput | null,
};

export type UpdateCountTableWithIncrementMutation = {
  updateCountTableWithIncrement?:  {
    __typename: "CountTable",
    loginName: string,
    tenant: string,
    landscape: string,
    tableName: TableName,
    totalCount: number,
    isUnRead?: number | null,
    isExpired?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateEventMutationVariables = {
  input: CreateEventInput,
  condition?: ModelEventConditionInput | null,
};

export type CreateEventMutation = {
  createEvent?:  {
    __typename: "Event",
    html?: string | null,
    loginName: string,
    tenant: string,
    landscape: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateEventMutationVariables = {
  input: UpdateEventInput,
  condition?: ModelEventConditionInput | null,
};

export type UpdateEventMutation = {
  updateEvent?:  {
    __typename: "Event",
    html?: string | null,
    loginName: string,
    tenant: string,
    landscape: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteEventMutationVariables = {
  input: DeleteEventInput,
  condition?: ModelEventConditionInput | null,
};

export type DeleteEventMutation = {
  deleteEvent?:  {
    __typename: "Event",
    html?: string | null,
    loginName: string,
    tenant: string,
    landscape: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateLinkMutationVariables = {
  input: CreateLinkInput,
  condition?: ModelLinkConditionInput | null,
};

export type CreateLinkMutation = {
  createLink?:  {
    __typename: "Link",
    id: string,
    menuDescriptions?:  {
      __typename: "ModelLinkMenuDescriptionConnection",
      nextToken?: string | null,
    } | null,
    url: string,
    tenant: string,
    landscape: string,
    sort: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateLinkMutationVariables = {
  input: UpdateLinkInput,
  condition?: ModelLinkConditionInput | null,
};

export type UpdateLinkMutation = {
  updateLink?:  {
    __typename: "Link",
    id: string,
    menuDescriptions?:  {
      __typename: "ModelLinkMenuDescriptionConnection",
      nextToken?: string | null,
    } | null,
    url: string,
    tenant: string,
    landscape: string,
    sort: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteLinkMutationVariables = {
  input: DeleteLinkInput,
  condition?: ModelLinkConditionInput | null,
};

export type DeleteLinkMutation = {
  deleteLink?:  {
    __typename: "Link",
    id: string,
    menuDescriptions?:  {
      __typename: "ModelLinkMenuDescriptionConnection",
      nextToken?: string | null,
    } | null,
    url: string,
    tenant: string,
    landscape: string,
    sort: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateMenuMutationVariables = {
  input: CreateMenuInput,
  condition?: ModelMenuConditionInput | null,
};

export type CreateMenuMutation = {
  createMenu?:  {
    __typename: "Menu",
    menuId: string,
    parentMenuId: string,
    menuNames?:  {
      __typename: "ModelMenuNameConnection",
      nextToken?: string | null,
    } | null,
    menuDescriptions?:  {
      __typename: "ModelMenuDescriptionConnection",
      nextToken?: string | null,
    } | null,
    url?: string | null,
    isCategory: _Boolean,
    product: Product,
    schemaId: string,
    loginName: string,
    tenant: string,
    landscape: string,
    tenantLandscapeLoginName: string,
    accessedTimeStamp?: number | null,
    sort: number,
    canUseFromExtra: _Boolean,
    menuIconFont?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateMenuMutationVariables = {
  input: UpdateMenuInput,
  condition?: ModelMenuConditionInput | null,
};

export type UpdateMenuMutation = {
  updateMenu?:  {
    __typename: "Menu",
    menuId: string,
    parentMenuId: string,
    menuNames?:  {
      __typename: "ModelMenuNameConnection",
      nextToken?: string | null,
    } | null,
    menuDescriptions?:  {
      __typename: "ModelMenuDescriptionConnection",
      nextToken?: string | null,
    } | null,
    url?: string | null,
    isCategory: _Boolean,
    product: Product,
    schemaId: string,
    loginName: string,
    tenant: string,
    landscape: string,
    tenantLandscapeLoginName: string,
    accessedTimeStamp?: number | null,
    sort: number,
    canUseFromExtra: _Boolean,
    menuIconFont?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteMenuMutationVariables = {
  input: DeleteMenuInput,
  condition?: ModelMenuConditionInput | null,
};

export type DeleteMenuMutation = {
  deleteMenu?:  {
    __typename: "Menu",
    menuId: string,
    parentMenuId: string,
    menuNames?:  {
      __typename: "ModelMenuNameConnection",
      nextToken?: string | null,
    } | null,
    menuDescriptions?:  {
      __typename: "ModelMenuDescriptionConnection",
      nextToken?: string | null,
    } | null,
    url?: string | null,
    isCategory: _Boolean,
    product: Product,
    schemaId: string,
    loginName: string,
    tenant: string,
    landscape: string,
    tenantLandscapeLoginName: string,
    accessedTimeStamp?: number | null,
    sort: number,
    canUseFromExtra: _Boolean,
    menuIconFont?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateMenuDescriptionMutationVariables = {
  input: CreateMenuDescriptionInput,
  condition?: ModelMenuDescriptionConditionInput | null,
};

export type CreateMenuDescriptionMutation = {
  createMenuDescription?:  {
    __typename: "MenuDescription",
    language: Language,
    description?: string | null,
    menuId: string,
    schemaId: string,
    tenant: string,
    landscape: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateMenuDescriptionMutationVariables = {
  input: UpdateMenuDescriptionInput,
  condition?: ModelMenuDescriptionConditionInput | null,
};

export type UpdateMenuDescriptionMutation = {
  updateMenuDescription?:  {
    __typename: "MenuDescription",
    language: Language,
    description?: string | null,
    menuId: string,
    schemaId: string,
    tenant: string,
    landscape: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteMenuDescriptionMutationVariables = {
  input: DeleteMenuDescriptionInput,
  condition?: ModelMenuDescriptionConditionInput | null,
};

export type DeleteMenuDescriptionMutation = {
  deleteMenuDescription?:  {
    __typename: "MenuDescription",
    language: Language,
    description?: string | null,
    menuId: string,
    schemaId: string,
    tenant: string,
    landscape: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateLinkMenuDescriptionMutationVariables = {
  input: CreateLinkMenuDescriptionInput,
  condition?: ModelLinkMenuDescriptionConditionInput | null,
};

export type CreateLinkMenuDescriptionMutation = {
  createLinkMenuDescription?:  {
    __typename: "LinkMenuDescription",
    language: Language,
    description: string,
    menuId: string,
    tenant: string,
    landscape: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateLinkMenuDescriptionMutationVariables = {
  input: UpdateLinkMenuDescriptionInput,
  condition?: ModelLinkMenuDescriptionConditionInput | null,
};

export type UpdateLinkMenuDescriptionMutation = {
  updateLinkMenuDescription?:  {
    __typename: "LinkMenuDescription",
    language: Language,
    description: string,
    menuId: string,
    tenant: string,
    landscape: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteLinkMenuDescriptionMutationVariables = {
  input: DeleteLinkMenuDescriptionInput,
  condition?: ModelLinkMenuDescriptionConditionInput | null,
};

export type DeleteLinkMenuDescriptionMutation = {
  deleteLinkMenuDescription?:  {
    __typename: "LinkMenuDescription",
    language: Language,
    description: string,
    menuId: string,
    tenant: string,
    landscape: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateMenuNameMutationVariables = {
  input: CreateMenuNameInput,
  condition?: ModelMenuNameConditionInput | null,
};

export type CreateMenuNameMutation = {
  createMenuName?:  {
    __typename: "MenuName",
    language: Language,
    name?: string | null,
    menuId: string,
    schemaId: string,
    tenant: string,
    landscape: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateMenuNameMutationVariables = {
  input: UpdateMenuNameInput,
  condition?: ModelMenuNameConditionInput | null,
};

export type UpdateMenuNameMutation = {
  updateMenuName?:  {
    __typename: "MenuName",
    language: Language,
    name?: string | null,
    menuId: string,
    schemaId: string,
    tenant: string,
    landscape: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteMenuNameMutationVariables = {
  input: DeleteMenuNameInput,
  condition?: ModelMenuNameConditionInput | null,
};

export type DeleteMenuNameMutation = {
  deleteMenuName?:  {
    __typename: "MenuName",
    language: Language,
    name?: string | null,
    menuId: string,
    schemaId: string,
    tenant: string,
    landscape: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateProductMenuNameMutationVariables = {
  input: CreateProductMenuNameInput,
  condition?: ModelProductMenuNameConditionInput | null,
};

export type CreateProductMenuNameMutation = {
  createProductMenuName?:  {
    __typename: "ProductMenuName",
    language: Language,
    name: string,
    menuId: string,
    loginName: string,
    tenant: string,
    landscape: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateProductMenuNameMutationVariables = {
  input: UpdateProductMenuNameInput,
  condition?: ModelProductMenuNameConditionInput | null,
};

export type UpdateProductMenuNameMutation = {
  updateProductMenuName?:  {
    __typename: "ProductMenuName",
    language: Language,
    name: string,
    menuId: string,
    loginName: string,
    tenant: string,
    landscape: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteProductMenuNameMutationVariables = {
  input: DeleteProductMenuNameInput,
  condition?: ModelProductMenuNameConditionInput | null,
};

export type DeleteProductMenuNameMutation = {
  deleteProductMenuName?:  {
    __typename: "ProductMenuName",
    language: Language,
    name: string,
    menuId: string,
    loginName: string,
    tenant: string,
    landscape: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateNoticeMutationVariables = {
  input: CreateNoticeInput,
  condition?: ModelNoticeConditionInput | null,
};

export type CreateNoticeMutation = {
  createNotice?:  {
    __typename: "Notice",
    html?: string | null,
    loginName: string,
    tenant: string,
    landscape: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateNoticeMutationVariables = {
  input: UpdateNoticeInput,
  condition?: ModelNoticeConditionInput | null,
};

export type UpdateNoticeMutation = {
  updateNotice?:  {
    __typename: "Notice",
    html?: string | null,
    loginName: string,
    tenant: string,
    landscape: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteNoticeMutationVariables = {
  input: DeleteNoticeInput,
  condition?: ModelNoticeConditionInput | null,
};

export type DeleteNoticeMutation = {
  deleteNotice?:  {
    __typename: "Notice",
    html?: string | null,
    loginName: string,
    tenant: string,
    landscape: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateFlagMutationVariables = {
  input: CreateFlagInput,
  condition?: ModelFlagConditionInput | null,
};

export type CreateFlagMutation = {
  createFlag?:  {
    __typename: "Flag",
    flag: Target,
    loginName: string,
    tenant: string,
    landscape: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateFlagMutationVariables = {
  input: UpdateFlagInput,
  condition?: ModelFlagConditionInput | null,
};

export type UpdateFlagMutation = {
  updateFlag?:  {
    __typename: "Flag",
    flag: Target,
    loginName: string,
    tenant: string,
    landscape: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteFlagMutationVariables = {
  input: DeleteFlagInput,
  condition?: ModelFlagConditionInput | null,
};

export type DeleteFlagMutation = {
  deleteFlag?:  {
    __typename: "Flag",
    flag: Target,
    loginName: string,
    tenant: string,
    landscape: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateUserMutationVariables = {
  input: CreateUserInput,
  condition?: ModelUserConditionInput | null,
};

export type CreateUserMutation = {
  createUser?:  {
    __typename: "User",
    loginName: string,
    tenant: string,
    landscape: string,
    displaysFavoritePanel: _Boolean,
    isAdmin: _Boolean,
    language: Language,
    name?: string | null,
    affiliation?: string | null,
    csrSchema?: string | null,
    cwsSchema?: string | null,
    cjkSchema?: string | null,
    ctmSchema?: string | null,
    event?:  {
      __typename: "Event",
      html?: string | null,
      loginName: string,
      tenant: string,
      landscape: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    notice?:  {
      __typename: "Notice",
      html?: string | null,
      loginName: string,
      tenant: string,
      landscape: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    menus?:  {
      __typename: "ModelMenuConnection",
      nextToken?: string | null,
    } | null,
    productMenus?:  {
      __typename: "ModelProductMenuConnection",
      nextToken?: string | null,
    } | null,
    flags?:  {
      __typename: "ModelFlagConnection",
      nextToken?: string | null,
    } | null,
    favorites?:  {
      __typename: "ModelFavoriteConnection",
      nextToken?: string | null,
    } | null,
    notifications?:  {
      __typename: "ModelNotificationConnection",
      nextToken?: string | null,
    } | null,
    announcements?:  {
      __typename: "ModelUserAnnouncementConnection",
      nextToken?: string | null,
    } | null,
    scheduledEventMetadatasByCreatedBy?:  {
      __typename: "ModelScheduledEventMetadataConnection",
      nextToken?: string | null,
    } | null,
    scheduledEventMetadatasByUpdatedBy?:  {
      __typename: "ModelScheduledEventMetadataConnection",
      nextToken?: string | null,
    } | null,
    scheduledEventHistoriesByExecutedBy?:  {
      __typename: "ModelScheduledEventHistoryConnection",
      nextToken?: string | null,
    } | null,
    scheduledHolidayMetadatasByCreatedBy?:  {
      __typename: "ModelScheduledHolidayMetadataConnection",
      nextToken?: string | null,
    } | null,
    scheduledHolidayMetadatasByUpdatedBy?:  {
      __typename: "ModelScheduledHolidayMetadataConnection",
      nextToken?: string | null,
    } | null,
    productMenuNames?:  {
      __typename: "ModelProductMenuNameConnection",
      nextToken?: string | null,
    } | null,
    countTables?:  {
      __typename: "ModelCountTableConnection",
      nextToken?: string | null,
    } | null,
    roleId?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateUserMutationVariables = {
  input: UpdateUserInput,
  condition?: ModelUserConditionInput | null,
};

export type UpdateUserMutation = {
  updateUser?:  {
    __typename: "User",
    loginName: string,
    tenant: string,
    landscape: string,
    displaysFavoritePanel: _Boolean,
    isAdmin: _Boolean,
    language: Language,
    name?: string | null,
    affiliation?: string | null,
    csrSchema?: string | null,
    cwsSchema?: string | null,
    cjkSchema?: string | null,
    ctmSchema?: string | null,
    event?:  {
      __typename: "Event",
      html?: string | null,
      loginName: string,
      tenant: string,
      landscape: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    notice?:  {
      __typename: "Notice",
      html?: string | null,
      loginName: string,
      tenant: string,
      landscape: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    menus?:  {
      __typename: "ModelMenuConnection",
      nextToken?: string | null,
    } | null,
    productMenus?:  {
      __typename: "ModelProductMenuConnection",
      nextToken?: string | null,
    } | null,
    flags?:  {
      __typename: "ModelFlagConnection",
      nextToken?: string | null,
    } | null,
    favorites?:  {
      __typename: "ModelFavoriteConnection",
      nextToken?: string | null,
    } | null,
    notifications?:  {
      __typename: "ModelNotificationConnection",
      nextToken?: string | null,
    } | null,
    announcements?:  {
      __typename: "ModelUserAnnouncementConnection",
      nextToken?: string | null,
    } | null,
    scheduledEventMetadatasByCreatedBy?:  {
      __typename: "ModelScheduledEventMetadataConnection",
      nextToken?: string | null,
    } | null,
    scheduledEventMetadatasByUpdatedBy?:  {
      __typename: "ModelScheduledEventMetadataConnection",
      nextToken?: string | null,
    } | null,
    scheduledEventHistoriesByExecutedBy?:  {
      __typename: "ModelScheduledEventHistoryConnection",
      nextToken?: string | null,
    } | null,
    scheduledHolidayMetadatasByCreatedBy?:  {
      __typename: "ModelScheduledHolidayMetadataConnection",
      nextToken?: string | null,
    } | null,
    scheduledHolidayMetadatasByUpdatedBy?:  {
      __typename: "ModelScheduledHolidayMetadataConnection",
      nextToken?: string | null,
    } | null,
    productMenuNames?:  {
      __typename: "ModelProductMenuNameConnection",
      nextToken?: string | null,
    } | null,
    countTables?:  {
      __typename: "ModelCountTableConnection",
      nextToken?: string | null,
    } | null,
    roleId?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteUserMutationVariables = {
  input: DeleteUserInput,
  condition?: ModelUserConditionInput | null,
};

export type DeleteUserMutation = {
  deleteUser?:  {
    __typename: "User",
    loginName: string,
    tenant: string,
    landscape: string,
    displaysFavoritePanel: _Boolean,
    isAdmin: _Boolean,
    language: Language,
    name?: string | null,
    affiliation?: string | null,
    csrSchema?: string | null,
    cwsSchema?: string | null,
    cjkSchema?: string | null,
    ctmSchema?: string | null,
    event?:  {
      __typename: "Event",
      html?: string | null,
      loginName: string,
      tenant: string,
      landscape: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    notice?:  {
      __typename: "Notice",
      html?: string | null,
      loginName: string,
      tenant: string,
      landscape: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    menus?:  {
      __typename: "ModelMenuConnection",
      nextToken?: string | null,
    } | null,
    productMenus?:  {
      __typename: "ModelProductMenuConnection",
      nextToken?: string | null,
    } | null,
    flags?:  {
      __typename: "ModelFlagConnection",
      nextToken?: string | null,
    } | null,
    favorites?:  {
      __typename: "ModelFavoriteConnection",
      nextToken?: string | null,
    } | null,
    notifications?:  {
      __typename: "ModelNotificationConnection",
      nextToken?: string | null,
    } | null,
    announcements?:  {
      __typename: "ModelUserAnnouncementConnection",
      nextToken?: string | null,
    } | null,
    scheduledEventMetadatasByCreatedBy?:  {
      __typename: "ModelScheduledEventMetadataConnection",
      nextToken?: string | null,
    } | null,
    scheduledEventMetadatasByUpdatedBy?:  {
      __typename: "ModelScheduledEventMetadataConnection",
      nextToken?: string | null,
    } | null,
    scheduledEventHistoriesByExecutedBy?:  {
      __typename: "ModelScheduledEventHistoryConnection",
      nextToken?: string | null,
    } | null,
    scheduledHolidayMetadatasByCreatedBy?:  {
      __typename: "ModelScheduledHolidayMetadataConnection",
      nextToken?: string | null,
    } | null,
    scheduledHolidayMetadatasByUpdatedBy?:  {
      __typename: "ModelScheduledHolidayMetadataConnection",
      nextToken?: string | null,
    } | null,
    productMenuNames?:  {
      __typename: "ModelProductMenuNameConnection",
      nextToken?: string | null,
    } | null,
    countTables?:  {
      __typename: "ModelCountTableConnection",
      nextToken?: string | null,
    } | null,
    roleId?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateNotificationOnLoginNameMutationVariables = {
  input: CreateNotificationInput,
  condition?: ModelNotificationConditionInput | null,
};

export type CreateNotificationOnLoginNameMutation = {
  createNotificationOnLoginName?:  {
    __typename: "Notification",
    loginName: string,
    tenant: string,
    landscape: string,
    tenantLandscapeLoginName: string,
    product: Product,
    notificationId: string,
    content: string,
    iconType?: string | null,
    onClickAction: string,
    extraActions?:  Array< {
      __typename: "NotificationActions",
      actionName: string,
      onClickAction: string,
    } > | null,
    displayStartDate: number,
    displayEndDate?: number | null,
    isRead: _Boolean,
    isFinished: _Boolean,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateNotificationMutationVariables = {
  input: UpdateNotificationInput,
  condition?: ModelNotificationConditionInput | null,
};

export type UpdateNotificationMutation = {
  updateNotification?:  {
    __typename: "Notification",
    loginName: string,
    tenant: string,
    landscape: string,
    tenantLandscapeLoginName: string,
    product: Product,
    notificationId: string,
    content: string,
    iconType?: string | null,
    onClickAction: string,
    extraActions?:  Array< {
      __typename: "NotificationActions",
      actionName: string,
      onClickAction: string,
    } > | null,
    displayStartDate: number,
    displayEndDate?: number | null,
    isRead: _Boolean,
    isFinished: _Boolean,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateCountTableMutationVariables = {
  input: CreateCountTableInput,
  condition?: ModelCountTableConditionInput | null,
};

export type CreateCountTableMutation = {
  createCountTable?:  {
    __typename: "CountTable",
    loginName: string,
    tenant: string,
    landscape: string,
    tableName: TableName,
    totalCount: number,
    isUnRead?: number | null,
    isExpired?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateCountTableMutationVariables = {
  input: UpdateCountTableInput,
  condition?: ModelCountTableConditionInput | null,
};

export type UpdateCountTableMutation = {
  updateCountTable?:  {
    __typename: "CountTable",
    loginName: string,
    tenant: string,
    landscape: string,
    tableName: TableName,
    totalCount: number,
    isUnRead?: number | null,
    isExpired?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteCountTableMutationVariables = {
  input: DeleteCountTableInput,
  condition?: ModelCountTableConditionInput | null,
};

export type DeleteCountTableMutation = {
  deleteCountTable?:  {
    __typename: "CountTable",
    loginName: string,
    tenant: string,
    landscape: string,
    tableName: TableName,
    totalCount: number,
    isUnRead?: number | null,
    isExpired?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateAnnouncementMutationVariables = {
  input: CreateAnnouncementInput,
  condition?: ModelAnnouncementConditionInput | null,
};

export type CreateAnnouncementMutation = {
  createAnnouncement?:  {
    __typename: "Announcement",
    id: string,
    tenant: string,
    landscape: string,
    tenantLandscape: string,
    users?:  {
      __typename: "ModelUserAnnouncementConnection",
      nextToken?: string | null,
    } | null,
    title: string,
    content: string,
    linkToProductMenu: string,
    isPublic: _Boolean,
    displayStartDate: number,
    displayEndDate?: number | null,
    priorityTag: PriorityTag,
    createdAt: string,
    updatedAt?: string | null,
  } | null,
};

export type UpdateAnnouncementMutationVariables = {
  input: UpdateAnnouncementInput,
  condition?: ModelAnnouncementConditionInput | null,
};

export type UpdateAnnouncementMutation = {
  updateAnnouncement?:  {
    __typename: "Announcement",
    id: string,
    tenant: string,
    landscape: string,
    tenantLandscape: string,
    users?:  {
      __typename: "ModelUserAnnouncementConnection",
      nextToken?: string | null,
    } | null,
    title: string,
    content: string,
    linkToProductMenu: string,
    isPublic: _Boolean,
    displayStartDate: number,
    displayEndDate?: number | null,
    priorityTag: PriorityTag,
    createdAt: string,
    updatedAt?: string | null,
  } | null,
};

export type DeleteAnnouncementMutationVariables = {
  input: DeleteAnnouncementInput,
  condition?: ModelAnnouncementConditionInput | null,
};

export type DeleteAnnouncementMutation = {
  deleteAnnouncement?:  {
    __typename: "Announcement",
    id: string,
    tenant: string,
    landscape: string,
    tenantLandscape: string,
    users?:  {
      __typename: "ModelUserAnnouncementConnection",
      nextToken?: string | null,
    } | null,
    title: string,
    content: string,
    linkToProductMenu: string,
    isPublic: _Boolean,
    displayStartDate: number,
    displayEndDate?: number | null,
    priorityTag: PriorityTag,
    createdAt: string,
    updatedAt?: string | null,
  } | null,
};

export type CreateUserAnnouncementMutationVariables = {
  input: CreateUserAnnouncementInput,
  condition?: ModelUserAnnouncementConditionInput | null,
};

export type CreateUserAnnouncementMutation = {
  createUserAnnouncement?:  {
    __typename: "UserAnnouncement",
    announcementId: string,
    loginName: string,
    tenant: string,
    landscape: string,
    tenantLandscapeLoginName: string,
    announcement:  {
      __typename: "Announcement",
      id: string,
      tenant: string,
      landscape: string,
      tenantLandscape: string,
      title: string,
      content: string,
      linkToProductMenu: string,
      isPublic: _Boolean,
      displayStartDate: number,
      displayEndDate?: number | null,
      priorityTag: PriorityTag,
      createdAt: string,
      updatedAt?: string | null,
    },
    displayStartDate: number,
    displayEndDate?: number | null,
    isProcessed: _Boolean,
    isRead: _Boolean,
    isShow: _Boolean,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateUserAnnouncementMutationVariables = {
  input: UpdateUserAnnouncementInput,
  condition?: ModelUserAnnouncementConditionInput | null,
};

export type UpdateUserAnnouncementMutation = {
  updateUserAnnouncement?:  {
    __typename: "UserAnnouncement",
    announcementId: string,
    loginName: string,
    tenant: string,
    landscape: string,
    tenantLandscapeLoginName: string,
    announcement:  {
      __typename: "Announcement",
      id: string,
      tenant: string,
      landscape: string,
      tenantLandscape: string,
      title: string,
      content: string,
      linkToProductMenu: string,
      isPublic: _Boolean,
      displayStartDate: number,
      displayEndDate?: number | null,
      priorityTag: PriorityTag,
      createdAt: string,
      updatedAt?: string | null,
    },
    displayStartDate: number,
    displayEndDate?: number | null,
    isProcessed: _Boolean,
    isRead: _Boolean,
    isShow: _Boolean,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteUserAnnouncementMutationVariables = {
  input: DeleteUserAnnouncementInput,
  condition?: ModelUserAnnouncementConditionInput | null,
};

export type DeleteUserAnnouncementMutation = {
  deleteUserAnnouncement?:  {
    __typename: "UserAnnouncement",
    announcementId: string,
    loginName: string,
    tenant: string,
    landscape: string,
    tenantLandscapeLoginName: string,
    announcement:  {
      __typename: "Announcement",
      id: string,
      tenant: string,
      landscape: string,
      tenantLandscape: string,
      title: string,
      content: string,
      linkToProductMenu: string,
      isPublic: _Boolean,
      displayStartDate: number,
      displayEndDate?: number | null,
      priorityTag: PriorityTag,
      createdAt: string,
      updatedAt?: string | null,
    },
    displayStartDate: number,
    displayEndDate?: number | null,
    isProcessed: _Boolean,
    isRead: _Boolean,
    isShow: _Boolean,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateFavoriteMutationVariables = {
  input: CreateFavoriteInput,
  condition?: ModelFavoriteConditionInput | null,
};

export type CreateFavoriteMutation = {
  createFavorite?:  {
    __typename: "Favorite",
    sort: number,
    menuId: string,
    loginName: string,
    tenant: string,
    landscape: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateFavoriteMutationVariables = {
  input: UpdateFavoriteInput,
  condition?: ModelFavoriteConditionInput | null,
};

export type UpdateFavoriteMutation = {
  updateFavorite?:  {
    __typename: "Favorite",
    sort: number,
    menuId: string,
    loginName: string,
    tenant: string,
    landscape: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteFavoriteMutationVariables = {
  input: DeleteFavoriteInput,
  condition?: ModelFavoriteConditionInput | null,
};

export type DeleteFavoriteMutation = {
  deleteFavorite?:  {
    __typename: "Favorite",
    sort: number,
    menuId: string,
    loginName: string,
    tenant: string,
    landscape: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateMenuIndexMutationVariables = {
  input: CreateMenuIndexInput,
  condition?: ModelMenuIndexConditionInput | null,
};

export type CreateMenuIndexMutation = {
  createMenuIndex?:  {
    __typename: "MenuIndex",
    index: string,
    menuId: string,
    product: Product,
    schema: string,
    language: Language,
    tenant: string,
    landscape: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateMenuIndexMutationVariables = {
  input: UpdateMenuIndexInput,
  condition?: ModelMenuIndexConditionInput | null,
};

export type UpdateMenuIndexMutation = {
  updateMenuIndex?:  {
    __typename: "MenuIndex",
    index: string,
    menuId: string,
    product: Product,
    schema: string,
    language: Language,
    tenant: string,
    landscape: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteMenuIndexMutationVariables = {
  input: DeleteMenuIndexInput,
  condition?: ModelMenuIndexConditionInput | null,
};

export type DeleteMenuIndexMutation = {
  deleteMenuIndex?:  {
    __typename: "MenuIndex",
    index: string,
    menuId: string,
    product: Product,
    schema: string,
    language: Language,
    tenant: string,
    landscape: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateProductMenuMutationVariables = {
  input: CreateProductMenuInput,
  condition?: ModelProductMenuConditionInput | null,
};

export type CreateProductMenuMutation = {
  createProductMenu?:  {
    __typename: "ProductMenu",
    loginName: string,
    tenant: string,
    landscape: string,
    menuId: string,
    menuNames?:  {
      __typename: "ModelProductMenuNameConnection",
      nextToken?: string | null,
    } | null,
    isHome: _Boolean,
    stateKey: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateProductMenuMutationVariables = {
  input: UpdateProductMenuInput,
  condition?: ModelProductMenuConditionInput | null,
};

export type UpdateProductMenuMutation = {
  updateProductMenu?:  {
    __typename: "ProductMenu",
    loginName: string,
    tenant: string,
    landscape: string,
    menuId: string,
    menuNames?:  {
      __typename: "ModelProductMenuNameConnection",
      nextToken?: string | null,
    } | null,
    isHome: _Boolean,
    stateKey: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteProductMenuMutationVariables = {
  input: DeleteProductMenuInput,
  condition?: ModelProductMenuConditionInput | null,
};

export type DeleteProductMenuMutation = {
  deleteProductMenu?:  {
    __typename: "ProductMenu",
    loginName: string,
    tenant: string,
    landscape: string,
    menuId: string,
    menuNames?:  {
      __typename: "ModelProductMenuNameConnection",
      nextToken?: string | null,
    } | null,
    isHome: _Boolean,
    stateKey: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateGatewayServerMutationVariables = {
  input: CreateGatewayServerInput,
  condition?: ModelGatewayServerConditionInput | null,
};

export type CreateGatewayServerMutation = {
  createGatewayServer?:  {
    __typename: "GatewayServer",
    tenant: string,
    landscape: string,
    product: Product,
    useInternetAccess: _Boolean,
    isInternalGateWayServer: _Boolean,
    gatewayServerIps?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateGatewayServerMutationVariables = {
  input: UpdateGatewayServerInput,
  condition?: ModelGatewayServerConditionInput | null,
};

export type UpdateGatewayServerMutation = {
  updateGatewayServer?:  {
    __typename: "GatewayServer",
    tenant: string,
    landscape: string,
    product: Product,
    useInternetAccess: _Boolean,
    isInternalGateWayServer: _Boolean,
    gatewayServerIps?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteGatewayServerMutationVariables = {
  input: DeleteGatewayServerInput,
  condition?: ModelGatewayServerConditionInput | null,
};

export type DeleteGatewayServerMutation = {
  deleteGatewayServer?:  {
    __typename: "GatewayServer",
    tenant: string,
    landscape: string,
    product: Product,
    useInternetAccess: _Boolean,
    isInternalGateWayServer: _Boolean,
    gatewayServerIps?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateCognitoInfoMutationVariables = {
  input: CreateCognitoInfoInput,
  condition?: ModelCognitoInfoConditionInput | null,
};

export type CreateCognitoInfoMutation = {
  createCognitoInfo?:  {
    __typename: "CognitoInfo",
    tenant: string,
    landscape: string,
    identityPoolId: string,
    region: string,
    userPoolId: string,
    userPoolWebClientId: string,
    identityProvider: string,
    amazonCognitoDomain: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateCognitoInfoMutationVariables = {
  input: UpdateCognitoInfoInput,
  condition?: ModelCognitoInfoConditionInput | null,
};

export type UpdateCognitoInfoMutation = {
  updateCognitoInfo?:  {
    __typename: "CognitoInfo",
    tenant: string,
    landscape: string,
    identityPoolId: string,
    region: string,
    userPoolId: string,
    userPoolWebClientId: string,
    identityProvider: string,
    amazonCognitoDomain: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteCognitoInfoMutationVariables = {
  input: DeleteCognitoInfoInput,
  condition?: ModelCognitoInfoConditionInput | null,
};

export type DeleteCognitoInfoMutation = {
  deleteCognitoInfo?:  {
    __typename: "CognitoInfo",
    tenant: string,
    landscape: string,
    identityPoolId: string,
    region: string,
    userPoolId: string,
    userPoolWebClientId: string,
    identityProvider: string,
    amazonCognitoDomain: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateAPIGatewayInfoMutationVariables = {
  input: CreateAPIGatewayInfoInput,
  condition?: ModelAPIGatewayInfoConditionInput | null,
};

export type CreateAPIGatewayInfoMutation = {
  createAPIGatewayInfo?:  {
    __typename: "APIGatewayInfo",
    tenant: string,
    landscape: string,
    endpoint: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateAPIGatewayInfoMutationVariables = {
  input: UpdateAPIGatewayInfoInput,
  condition?: ModelAPIGatewayInfoConditionInput | null,
};

export type UpdateAPIGatewayInfoMutation = {
  updateAPIGatewayInfo?:  {
    __typename: "APIGatewayInfo",
    tenant: string,
    landscape: string,
    endpoint: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteAPIGatewayInfoMutationVariables = {
  input: DeleteAPIGatewayInfoInput,
  condition?: ModelAPIGatewayInfoConditionInput | null,
};

export type DeleteAPIGatewayInfoMutation = {
  deleteAPIGatewayInfo?:  {
    __typename: "APIGatewayInfo",
    tenant: string,
    landscape: string,
    endpoint: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateBackendInfoMutationVariables = {
  input: CreateBackendInfoInput,
  condition?: ModelBackendInfoConditionInput | null,
};

export type CreateBackendInfoMutation = {
  createBackendInfo?:  {
    __typename: "BackendInfo",
    tenant: string,
    landscape: string,
    apiGatewayInfo?:  {
      __typename: "APIGatewayInfo",
      tenant: string,
      landscape: string,
      endpoint: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    cognitoInfo?:  {
      __typename: "CognitoInfo",
      tenant: string,
      landscape: string,
      identityPoolId: string,
      region: string,
      userPoolId: string,
      userPoolWebClientId: string,
      identityProvider: string,
      amazonCognitoDomain: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateBackendInfoMutationVariables = {
  input: UpdateBackendInfoInput,
  condition?: ModelBackendInfoConditionInput | null,
};

export type UpdateBackendInfoMutation = {
  updateBackendInfo?:  {
    __typename: "BackendInfo",
    tenant: string,
    landscape: string,
    apiGatewayInfo?:  {
      __typename: "APIGatewayInfo",
      tenant: string,
      landscape: string,
      endpoint: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    cognitoInfo?:  {
      __typename: "CognitoInfo",
      tenant: string,
      landscape: string,
      identityPoolId: string,
      region: string,
      userPoolId: string,
      userPoolWebClientId: string,
      identityProvider: string,
      amazonCognitoDomain: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteBackendInfoMutationVariables = {
  input: DeleteBackendInfoInput,
  condition?: ModelBackendInfoConditionInput | null,
};

export type DeleteBackendInfoMutation = {
  deleteBackendInfo?:  {
    __typename: "BackendInfo",
    tenant: string,
    landscape: string,
    apiGatewayInfo?:  {
      __typename: "APIGatewayInfo",
      tenant: string,
      landscape: string,
      endpoint: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    cognitoInfo?:  {
      __typename: "CognitoInfo",
      tenant: string,
      landscape: string,
      identityPoolId: string,
      region: string,
      userPoolId: string,
      userPoolWebClientId: string,
      identityProvider: string,
      amazonCognitoDomain: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateAuthQueryMutationVariables = {
  input: CreateAuthQueryInput,
  condition?: ModelAuthQueryConditionInput | null,
};

export type CreateAuthQueryMutation = {
  createAuthQuery?:  {
    __typename: "AuthQuery",
    tenant: string,
    landscape: string,
    identityProvider: string,
    product: Product,
    additionalQuery: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateAuthQueryMutationVariables = {
  input: UpdateAuthQueryInput,
  condition?: ModelAuthQueryConditionInput | null,
};

export type UpdateAuthQueryMutation = {
  updateAuthQuery?:  {
    __typename: "AuthQuery",
    tenant: string,
    landscape: string,
    identityProvider: string,
    product: Product,
    additionalQuery: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteAuthQueryMutationVariables = {
  input: DeleteAuthQueryInput,
  condition?: ModelAuthQueryConditionInput | null,
};

export type DeleteAuthQueryMutation = {
  deleteAuthQuery?:  {
    __typename: "AuthQuery",
    tenant: string,
    landscape: string,
    identityProvider: string,
    product: Product,
    additionalQuery: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateSystemSettingInfoMutationVariables = {
  input: CreateSystemSettingInfoInput,
  condition?: ModelSystemSettingInfoConditionInput | null,
};

export type CreateSystemSettingInfoMutation = {
  createSystemSettingInfo?:  {
    __typename: "SystemSettingInfo",
    tenant: string,
    landscape: string,
    isMultilanguageEnabled?: _Boolean | null,
    isNotificationEnabled?: _Boolean | null,
    isJobSchedulerEnabled?: _Boolean | null,
    isPortalEnabled?: _Boolean | null,
    announcementSetting?: AnnouncementSetting | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateSystemSettingInfoMutationVariables = {
  input: UpdateSystemSettingInfoInput,
  condition?: ModelSystemSettingInfoConditionInput | null,
};

export type UpdateSystemSettingInfoMutation = {
  updateSystemSettingInfo?:  {
    __typename: "SystemSettingInfo",
    tenant: string,
    landscape: string,
    isMultilanguageEnabled?: _Boolean | null,
    isNotificationEnabled?: _Boolean | null,
    isJobSchedulerEnabled?: _Boolean | null,
    isPortalEnabled?: _Boolean | null,
    announcementSetting?: AnnouncementSetting | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteSystemSettingInfoMutationVariables = {
  input: DeleteSystemSettingInfoInput,
  condition?: ModelSystemSettingInfoConditionInput | null,
};

export type DeleteSystemSettingInfoMutation = {
  deleteSystemSettingInfo?:  {
    __typename: "SystemSettingInfo",
    tenant: string,
    landscape: string,
    isMultilanguageEnabled?: _Boolean | null,
    isNotificationEnabled?: _Boolean | null,
    isJobSchedulerEnabled?: _Boolean | null,
    isPortalEnabled?: _Boolean | null,
    announcementSetting?: AnnouncementSetting | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateCustomerCompanyVersionMutationVariables = {
  input: CreateCustomerCompanyVersionInput,
  condition?: ModelCustomerCompanyVersionConditionInput | null,
};

export type CreateCustomerCompanyVersionMutation = {
  createCustomerCompanyVersion?:  {
    __typename: "CustomerCompanyVersion",
    id: string,
    tenant: string,
    landscape: string,
    tenantLandscape: string,
    version: string,
    product: string,
    applyDateTime: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateCustomerCompanyVersionMutationVariables = {
  input: UpdateCustomerCompanyVersionInput,
  condition?: ModelCustomerCompanyVersionConditionInput | null,
};

export type UpdateCustomerCompanyVersionMutation = {
  updateCustomerCompanyVersion?:  {
    __typename: "CustomerCompanyVersion",
    id: string,
    tenant: string,
    landscape: string,
    tenantLandscape: string,
    version: string,
    product: string,
    applyDateTime: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteCustomerCompanyVersionMutationVariables = {
  input: DeleteCustomerCompanyVersionInput,
  condition?: ModelCustomerCompanyVersionConditionInput | null,
};

export type DeleteCustomerCompanyVersionMutation = {
  deleteCustomerCompanyVersion?:  {
    __typename: "CustomerCompanyVersion",
    id: string,
    tenant: string,
    landscape: string,
    tenantLandscape: string,
    version: string,
    product: string,
    applyDateTime: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateTaskMetadataMutationVariables = {
  input: CreateTaskMetadataInput,
  condition?: ModelTaskMetadataConditionInput | null,
};

export type CreateTaskMetadataMutation = {
  createTaskMetadata?:  {
    __typename: "TaskMetadata",
    version: string,
    product: string,
    batch: string,
    batchName: string,
    versionProductBatch: string,
    args:  Array< {
      __typename: "TaskMetadataArgs",
      required: _Boolean,
      default?: string | null,
      display: _Boolean,
      order: number,
      option: string,
      type: TaskMetadataArgsType,
      delimiter?: string | null,
      isMultiple?: _Boolean | null,
      isOutputFile?: _Boolean | null,
      isInputFile?: _Boolean | null,
      isSecret?: _Boolean | null,
      sampleInput?: string | null,
      isResolvable?: _Boolean | null,
    } >,
    requestBodyPropertyTemplates?:  Array< {
      __typename: "RequestBodyPropertyTemplate",
      requestBodyProperty: string,
      template: string,
    } | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateTaskMetadataMutationVariables = {
  input: UpdateTaskMetadataInput,
  condition?: ModelTaskMetadataConditionInput | null,
};

export type UpdateTaskMetadataMutation = {
  updateTaskMetadata?:  {
    __typename: "TaskMetadata",
    version: string,
    product: string,
    batch: string,
    batchName: string,
    versionProductBatch: string,
    args:  Array< {
      __typename: "TaskMetadataArgs",
      required: _Boolean,
      default?: string | null,
      display: _Boolean,
      order: number,
      option: string,
      type: TaskMetadataArgsType,
      delimiter?: string | null,
      isMultiple?: _Boolean | null,
      isOutputFile?: _Boolean | null,
      isInputFile?: _Boolean | null,
      isSecret?: _Boolean | null,
      sampleInput?: string | null,
      isResolvable?: _Boolean | null,
    } >,
    requestBodyPropertyTemplates?:  Array< {
      __typename: "RequestBodyPropertyTemplate",
      requestBodyProperty: string,
      template: string,
    } | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteTaskMetadataMutationVariables = {
  input: DeleteTaskMetadataInput,
  condition?: ModelTaskMetadataConditionInput | null,
};

export type DeleteTaskMetadataMutation = {
  deleteTaskMetadata?:  {
    __typename: "TaskMetadata",
    version: string,
    product: string,
    batch: string,
    batchName: string,
    versionProductBatch: string,
    args:  Array< {
      __typename: "TaskMetadataArgs",
      required: _Boolean,
      default?: string | null,
      display: _Boolean,
      order: number,
      option: string,
      type: TaskMetadataArgsType,
      delimiter?: string | null,
      isMultiple?: _Boolean | null,
      isOutputFile?: _Boolean | null,
      isInputFile?: _Boolean | null,
      isSecret?: _Boolean | null,
      sampleInput?: string | null,
      isResolvable?: _Boolean | null,
    } >,
    requestBodyPropertyTemplates?:  Array< {
      __typename: "RequestBodyPropertyTemplate",
      requestBodyProperty: string,
      template: string,
    } | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateTenantUsingMoveFileTaskMutationVariables = {
  input: CreateTenantUsingMoveFileTaskInput,
  condition?: ModelTenantUsingMoveFileTaskConditionInput | null,
};

export type CreateTenantUsingMoveFileTaskMutation = {
  createTenantUsingMoveFileTask?:  {
    __typename: "TenantUsingMoveFileTask",
    tenant: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateTenantUsingMoveFileTaskMutationVariables = {
  input: UpdateTenantUsingMoveFileTaskInput,
  condition?: ModelTenantUsingMoveFileTaskConditionInput | null,
};

export type UpdateTenantUsingMoveFileTaskMutation = {
  updateTenantUsingMoveFileTask?:  {
    __typename: "TenantUsingMoveFileTask",
    tenant: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteTenantUsingMoveFileTaskMutationVariables = {
  input: DeleteTenantUsingMoveFileTaskInput,
  condition?: ModelTenantUsingMoveFileTaskConditionInput | null,
};

export type DeleteTenantUsingMoveFileTaskMutation = {
  deleteTenantUsingMoveFileTask?:  {
    __typename: "TenantUsingMoveFileTask",
    tenant: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateJobMutationVariables = {
  input: CreateJobInput,
  condition?: ModelJobConditionInput | null,
};

export type CreateJobMutation = {
  createJob?:  {
    __typename: "Job",
    id: string,
    tenant: string,
    landscape: string,
    tenantLandscape: string,
    jobCode: string,
    title: string,
    description?: string | null,
    jobTriggerFilePath?: string | null,
    tasks?:  {
      __typename: "ModelTaskConnection",
      nextToken?: string | null,
    } | null,
    hasOutputFile: _Boolean,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateJobMutationVariables = {
  input: UpdateJobInput,
  condition?: ModelJobConditionInput | null,
};

export type UpdateJobMutation = {
  updateJob?:  {
    __typename: "Job",
    id: string,
    tenant: string,
    landscape: string,
    tenantLandscape: string,
    jobCode: string,
    title: string,
    description?: string | null,
    jobTriggerFilePath?: string | null,
    tasks?:  {
      __typename: "ModelTaskConnection",
      nextToken?: string | null,
    } | null,
    hasOutputFile: _Boolean,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteJobMutationVariables = {
  input: DeleteJobInput,
  condition?: ModelJobConditionInput | null,
};

export type DeleteJobMutation = {
  deleteJob?:  {
    __typename: "Job",
    id: string,
    tenant: string,
    landscape: string,
    tenantLandscape: string,
    jobCode: string,
    title: string,
    description?: string | null,
    jobTriggerFilePath?: string | null,
    tasks?:  {
      __typename: "ModelTaskConnection",
      nextToken?: string | null,
    } | null,
    hasOutputFile: _Boolean,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateTaskMutationVariables = {
  input: CreateTaskInput,
  condition?: ModelTaskConditionInput | null,
};

export type CreateTaskMutation = {
  createTask?:  {
    __typename: "Task",
    version: string,
    product: string,
    batch: string,
    batchName: string,
    versionProductBatch: string,
    jobId: string,
    order: number,
    jobIdOrder: string,
    taskMetadata?:  {
      __typename: "TaskMetadata",
      version: string,
      product: string,
      batch: string,
      batchName: string,
      versionProductBatch: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    title: string,
    args:  Array< {
      __typename: "TaskArgs",
      order: number,
      option: string,
      value: string,
      replaceInFileName?: _Boolean | null,
    } >,
    includeInDownload?: _Boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateTaskMutationVariables = {
  input: UpdateTaskInput,
  condition?: ModelTaskConditionInput | null,
};

export type UpdateTaskMutation = {
  updateTask?:  {
    __typename: "Task",
    version: string,
    product: string,
    batch: string,
    batchName: string,
    versionProductBatch: string,
    jobId: string,
    order: number,
    jobIdOrder: string,
    taskMetadata?:  {
      __typename: "TaskMetadata",
      version: string,
      product: string,
      batch: string,
      batchName: string,
      versionProductBatch: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    title: string,
    args:  Array< {
      __typename: "TaskArgs",
      order: number,
      option: string,
      value: string,
      replaceInFileName?: _Boolean | null,
    } >,
    includeInDownload?: _Boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteTaskMutationVariables = {
  input: DeleteTaskInput,
  condition?: ModelTaskConditionInput | null,
};

export type DeleteTaskMutation = {
  deleteTask?:  {
    __typename: "Task",
    version: string,
    product: string,
    batch: string,
    batchName: string,
    versionProductBatch: string,
    jobId: string,
    order: number,
    jobIdOrder: string,
    taskMetadata?:  {
      __typename: "TaskMetadata",
      version: string,
      product: string,
      batch: string,
      batchName: string,
      versionProductBatch: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    title: string,
    args:  Array< {
      __typename: "TaskArgs",
      order: number,
      option: string,
      value: string,
      replaceInFileName?: _Boolean | null,
    } >,
    includeInDownload?: _Boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateScheduledEventMetadataMutationVariables = {
  input: CreateScheduledEventMetadataInput,
  condition?: ModelScheduledEventMetadataConditionInput | null,
};

export type CreateScheduledEventMetadataMutation = {
  createScheduledEventMetadata?:  {
    __typename: "ScheduledEventMetadata",
    id: string,
    tenant: string,
    landscape: string,
    tenantLandscape: string,
    title: string,
    description?: string | null,
    jobId: string,
    job?:  {
      __typename: "Job",
      id: string,
      tenant: string,
      landscape: string,
      tenantLandscape: string,
      jobCode: string,
      title: string,
      description?: string | null,
      jobTriggerFilePath?: string | null,
      hasOutputFile: _Boolean,
      createdAt: string,
      updatedAt: string,
    } | null,
    repeatType: RepeatType,
    rruleSet: string,
    holidayExecutionType: HolidayExecutionType,
    useCustomHoliday: _Boolean,
    customHolidayLabels?: Array< string > | null,
    eventTriggerType: EventTriggerType,
    createdBy: string,
    updatedBy: string,
    editedAt?: string | null,
    expirationDate?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateScheduledEventMetadataMutationVariables = {
  input: UpdateScheduledEventMetadataInput,
  condition?: ModelScheduledEventMetadataConditionInput | null,
};

export type UpdateScheduledEventMetadataMutation = {
  updateScheduledEventMetadata?:  {
    __typename: "ScheduledEventMetadata",
    id: string,
    tenant: string,
    landscape: string,
    tenantLandscape: string,
    title: string,
    description?: string | null,
    jobId: string,
    job?:  {
      __typename: "Job",
      id: string,
      tenant: string,
      landscape: string,
      tenantLandscape: string,
      jobCode: string,
      title: string,
      description?: string | null,
      jobTriggerFilePath?: string | null,
      hasOutputFile: _Boolean,
      createdAt: string,
      updatedAt: string,
    } | null,
    repeatType: RepeatType,
    rruleSet: string,
    holidayExecutionType: HolidayExecutionType,
    useCustomHoliday: _Boolean,
    customHolidayLabels?: Array< string > | null,
    eventTriggerType: EventTriggerType,
    createdBy: string,
    updatedBy: string,
    editedAt?: string | null,
    expirationDate?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteScheduledEventMetadataMutationVariables = {
  input: DeleteScheduledEventMetadataInput,
  condition?: ModelScheduledEventMetadataConditionInput | null,
};

export type DeleteScheduledEventMetadataMutation = {
  deleteScheduledEventMetadata?:  {
    __typename: "ScheduledEventMetadata",
    id: string,
    tenant: string,
    landscape: string,
    tenantLandscape: string,
    title: string,
    description?: string | null,
    jobId: string,
    job?:  {
      __typename: "Job",
      id: string,
      tenant: string,
      landscape: string,
      tenantLandscape: string,
      jobCode: string,
      title: string,
      description?: string | null,
      jobTriggerFilePath?: string | null,
      hasOutputFile: _Boolean,
      createdAt: string,
      updatedAt: string,
    } | null,
    repeatType: RepeatType,
    rruleSet: string,
    holidayExecutionType: HolidayExecutionType,
    useCustomHoliday: _Boolean,
    customHolidayLabels?: Array< string > | null,
    eventTriggerType: EventTriggerType,
    createdBy: string,
    updatedBy: string,
    editedAt?: string | null,
    expirationDate?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateScheduledEventHistoryMutationVariables = {
  input: CreateScheduledEventHistoryInput,
  condition?: ModelScheduledEventHistoryConditionInput | null,
};

export type CreateScheduledEventHistoryMutation = {
  createScheduledEventHistory?:  {
    __typename: "ScheduledEventHistory",
    id: string,
    tenant: string,
    landscape: string,
    tenantLandscape: string,
    title: string,
    description?: string | null,
    scheduledEventMetadataId: string,
    scheduledEventMetadata?:  {
      __typename: "ScheduledEventMetadata",
      id: string,
      tenant: string,
      landscape: string,
      tenantLandscape: string,
      title: string,
      description?: string | null,
      jobId: string,
      repeatType: RepeatType,
      rruleSet: string,
      holidayExecutionType: HolidayExecutionType,
      useCustomHoliday: _Boolean,
      customHolidayLabels?: Array< string > | null,
      eventTriggerType: EventTriggerType,
      createdBy: string,
      updatedBy: string,
      editedAt?: string | null,
      expirationDate?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    eventStartDateTime: number,
    jobId: string,
    job?:  {
      __typename: "Job",
      id: string,
      tenant: string,
      landscape: string,
      tenantLandscape: string,
      jobCode: string,
      title: string,
      description?: string | null,
      jobTriggerFilePath?: string | null,
      hasOutputFile: _Boolean,
      createdAt: string,
      updatedAt: string,
    } | null,
    jobExecutionStatus: JobExecutionStatus,
    tasks?:  {
      __typename: "ModelTaskConnection",
      nextToken?: string | null,
    } | null,
    taskHistories?:  {
      __typename: "ModelTaskHistoryConnection",
      nextToken?: string | null,
    } | null,
    executedBy: string,
    executionArn?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateScheduledEventHistoryMutationVariables = {
  input: UpdateScheduledEventHistoryInput,
  condition?: ModelScheduledEventHistoryConditionInput | null,
};

export type UpdateScheduledEventHistoryMutation = {
  updateScheduledEventHistory?:  {
    __typename: "ScheduledEventHistory",
    id: string,
    tenant: string,
    landscape: string,
    tenantLandscape: string,
    title: string,
    description?: string | null,
    scheduledEventMetadataId: string,
    scheduledEventMetadata?:  {
      __typename: "ScheduledEventMetadata",
      id: string,
      tenant: string,
      landscape: string,
      tenantLandscape: string,
      title: string,
      description?: string | null,
      jobId: string,
      repeatType: RepeatType,
      rruleSet: string,
      holidayExecutionType: HolidayExecutionType,
      useCustomHoliday: _Boolean,
      customHolidayLabels?: Array< string > | null,
      eventTriggerType: EventTriggerType,
      createdBy: string,
      updatedBy: string,
      editedAt?: string | null,
      expirationDate?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    eventStartDateTime: number,
    jobId: string,
    job?:  {
      __typename: "Job",
      id: string,
      tenant: string,
      landscape: string,
      tenantLandscape: string,
      jobCode: string,
      title: string,
      description?: string | null,
      jobTriggerFilePath?: string | null,
      hasOutputFile: _Boolean,
      createdAt: string,
      updatedAt: string,
    } | null,
    jobExecutionStatus: JobExecutionStatus,
    tasks?:  {
      __typename: "ModelTaskConnection",
      nextToken?: string | null,
    } | null,
    taskHistories?:  {
      __typename: "ModelTaskHistoryConnection",
      nextToken?: string | null,
    } | null,
    executedBy: string,
    executionArn?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteScheduledEventHistoryMutationVariables = {
  input: DeleteScheduledEventHistoryInput,
  condition?: ModelScheduledEventHistoryConditionInput | null,
};

export type DeleteScheduledEventHistoryMutation = {
  deleteScheduledEventHistory?:  {
    __typename: "ScheduledEventHistory",
    id: string,
    tenant: string,
    landscape: string,
    tenantLandscape: string,
    title: string,
    description?: string | null,
    scheduledEventMetadataId: string,
    scheduledEventMetadata?:  {
      __typename: "ScheduledEventMetadata",
      id: string,
      tenant: string,
      landscape: string,
      tenantLandscape: string,
      title: string,
      description?: string | null,
      jobId: string,
      repeatType: RepeatType,
      rruleSet: string,
      holidayExecutionType: HolidayExecutionType,
      useCustomHoliday: _Boolean,
      customHolidayLabels?: Array< string > | null,
      eventTriggerType: EventTriggerType,
      createdBy: string,
      updatedBy: string,
      editedAt?: string | null,
      expirationDate?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    eventStartDateTime: number,
    jobId: string,
    job?:  {
      __typename: "Job",
      id: string,
      tenant: string,
      landscape: string,
      tenantLandscape: string,
      jobCode: string,
      title: string,
      description?: string | null,
      jobTriggerFilePath?: string | null,
      hasOutputFile: _Boolean,
      createdAt: string,
      updatedAt: string,
    } | null,
    jobExecutionStatus: JobExecutionStatus,
    tasks?:  {
      __typename: "ModelTaskConnection",
      nextToken?: string | null,
    } | null,
    taskHistories?:  {
      __typename: "ModelTaskHistoryConnection",
      nextToken?: string | null,
    } | null,
    executedBy: string,
    executionArn?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateTaskHistoryMutationVariables = {
  input: CreateTaskHistoryInput,
  condition?: ModelTaskHistoryConditionInput | null,
};

export type CreateTaskHistoryMutation = {
  createTaskHistory?:  {
    __typename: "TaskHistory",
    jobIdOrder: string,
    jobId: string,
    order: number,
    scheduledEventHistoryId: string,
    task?:  {
      __typename: "Task",
      version: string,
      product: string,
      batch: string,
      batchName: string,
      versionProductBatch: string,
      jobId: string,
      order: number,
      jobIdOrder: string,
      title: string,
      includeInDownload?: _Boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    tenant: string,
    landscape: string,
    tenantLandscape: string,
    taskStartDateTime?: number | null,
    taskEndDateTime?: number | null,
    taskExecutionStatus: TaskExecutionStatus,
    log: string,
    outputFilePath?: string | null,
    includeInDownload?: _Boolean | null,
    taskTitle?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateTaskHistoryMutationVariables = {
  input: UpdateTaskHistoryInput,
  condition?: ModelTaskHistoryConditionInput | null,
};

export type UpdateTaskHistoryMutation = {
  updateTaskHistory?:  {
    __typename: "TaskHistory",
    jobIdOrder: string,
    jobId: string,
    order: number,
    scheduledEventHistoryId: string,
    task?:  {
      __typename: "Task",
      version: string,
      product: string,
      batch: string,
      batchName: string,
      versionProductBatch: string,
      jobId: string,
      order: number,
      jobIdOrder: string,
      title: string,
      includeInDownload?: _Boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    tenant: string,
    landscape: string,
    tenantLandscape: string,
    taskStartDateTime?: number | null,
    taskEndDateTime?: number | null,
    taskExecutionStatus: TaskExecutionStatus,
    log: string,
    outputFilePath?: string | null,
    includeInDownload?: _Boolean | null,
    taskTitle?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteTaskHistoryMutationVariables = {
  input: DeleteTaskHistoryInput,
  condition?: ModelTaskHistoryConditionInput | null,
};

export type DeleteTaskHistoryMutation = {
  deleteTaskHistory?:  {
    __typename: "TaskHistory",
    jobIdOrder: string,
    jobId: string,
    order: number,
    scheduledEventHistoryId: string,
    task?:  {
      __typename: "Task",
      version: string,
      product: string,
      batch: string,
      batchName: string,
      versionProductBatch: string,
      jobId: string,
      order: number,
      jobIdOrder: string,
      title: string,
      includeInDownload?: _Boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    tenant: string,
    landscape: string,
    tenantLandscape: string,
    taskStartDateTime?: number | null,
    taskEndDateTime?: number | null,
    taskExecutionStatus: TaskExecutionStatus,
    log: string,
    outputFilePath?: string | null,
    includeInDownload?: _Boolean | null,
    taskTitle?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateScheduledHolidayMetadataMutationVariables = {
  input: CreateScheduledHolidayMetadataInput,
  condition?: ModelScheduledHolidayMetadataConditionInput | null,
};

export type CreateScheduledHolidayMetadataMutation = {
  createScheduledHolidayMetadata?:  {
    __typename: "ScheduledHolidayMetadata",
    id: string,
    tenant: string,
    landscape: string,
    tenantLandscape: string,
    title: string,
    description?: string | null,
    repeatType: RepeatType,
    rruleSet: string,
    labels: Array< string >,
    createdBy: string,
    updatedBy: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateScheduledHolidayMetadataMutationVariables = {
  input: UpdateScheduledHolidayMetadataInput,
  condition?: ModelScheduledHolidayMetadataConditionInput | null,
};

export type UpdateScheduledHolidayMetadataMutation = {
  updateScheduledHolidayMetadata?:  {
    __typename: "ScheduledHolidayMetadata",
    id: string,
    tenant: string,
    landscape: string,
    tenantLandscape: string,
    title: string,
    description?: string | null,
    repeatType: RepeatType,
    rruleSet: string,
    labels: Array< string >,
    createdBy: string,
    updatedBy: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteScheduledHolidayMetadataMutationVariables = {
  input: DeleteScheduledHolidayMetadataInput,
  condition?: ModelScheduledHolidayMetadataConditionInput | null,
};

export type DeleteScheduledHolidayMetadataMutation = {
  deleteScheduledHolidayMetadata?:  {
    __typename: "ScheduledHolidayMetadata",
    id: string,
    tenant: string,
    landscape: string,
    tenantLandscape: string,
    title: string,
    description?: string | null,
    repeatType: RepeatType,
    rruleSet: string,
    labels: Array< string >,
    createdBy: string,
    updatedBy: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreatePublicHolidayMutationVariables = {
  input: CreatePublicHolidayInput,
  condition?: ModelPublicHolidayConditionInput | null,
};

export type CreatePublicHolidayMutation = {
  createPublicHoliday?:  {
    __typename: "PublicHoliday",
    startDate: string,
    language: Language,
    title: string,
    label: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdatePublicHolidayMutationVariables = {
  input: UpdatePublicHolidayInput,
  condition?: ModelPublicHolidayConditionInput | null,
};

export type UpdatePublicHolidayMutation = {
  updatePublicHoliday?:  {
    __typename: "PublicHoliday",
    startDate: string,
    language: Language,
    title: string,
    label: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeletePublicHolidayMutationVariables = {
  input: DeletePublicHolidayInput,
  condition?: ModelPublicHolidayConditionInput | null,
};

export type DeletePublicHolidayMutation = {
  deletePublicHoliday?:  {
    __typename: "PublicHoliday",
    startDate: string,
    language: Language,
    title: string,
    label: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateWebsocketConnectionMutationVariables = {
  input: CreateWebsocketConnectionInput,
  condition?: ModelWebsocketConnectionConditionInput | null,
};

export type CreateWebsocketConnectionMutation = {
  createWebsocketConnection?:  {
    __typename: "WebsocketConnection",
    connectionId: string,
    endpoint: string,
    tenant: string,
    landscape: string,
    hostname: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateWebsocketConnectionMutationVariables = {
  input: UpdateWebsocketConnectionInput,
  condition?: ModelWebsocketConnectionConditionInput | null,
};

export type UpdateWebsocketConnectionMutation = {
  updateWebsocketConnection?:  {
    __typename: "WebsocketConnection",
    connectionId: string,
    endpoint: string,
    tenant: string,
    landscape: string,
    hostname: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteWebsocketConnectionMutationVariables = {
  input: DeleteWebsocketConnectionInput,
  condition?: ModelWebsocketConnectionConditionInput | null,
};

export type DeleteWebsocketConnectionMutation = {
  deleteWebsocketConnection?:  {
    __typename: "WebsocketConnection",
    connectionId: string,
    endpoint: string,
    tenant: string,
    landscape: string,
    hostname: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateWebsocketWaitingResponseMutationVariables = {
  input: CreateWebsocketWaitingResponseInput,
  condition?: ModelWebsocketWaitingResponseConditionInput | null,
};

export type CreateWebsocketWaitingResponseMutation = {
  createWebsocketWaitingResponse?:  {
    __typename: "WebsocketWaitingResponse",
    parentId: string,
    connectionId: string,
    messageType: ResponseExpectedMessageTypes,
    receivedAt: string,
    timeoutAt: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateWebsocketWaitingResponseMutationVariables = {
  input: UpdateWebsocketWaitingResponseInput,
  condition?: ModelWebsocketWaitingResponseConditionInput | null,
};

export type UpdateWebsocketWaitingResponseMutation = {
  updateWebsocketWaitingResponse?:  {
    __typename: "WebsocketWaitingResponse",
    parentId: string,
    connectionId: string,
    messageType: ResponseExpectedMessageTypes,
    receivedAt: string,
    timeoutAt: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteWebsocketWaitingResponseMutationVariables = {
  input: DeleteWebsocketWaitingResponseInput,
  condition?: ModelWebsocketWaitingResponseConditionInput | null,
};

export type DeleteWebsocketWaitingResponseMutation = {
  deleteWebsocketWaitingResponse?:  {
    __typename: "WebsocketWaitingResponse",
    parentId: string,
    connectionId: string,
    messageType: ResponseExpectedMessageTypes,
    receivedAt: string,
    timeoutAt: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateRoleMutationVariables = {
  input: CreateRoleInput,
  condition?: ModelRoleConditionInput | null,
};

export type CreateRoleMutation = {
  createRole?:  {
    __typename: "Role",
    id: string,
    name: string,
    description?: string | null,
    isDefault: boolean,
    systemType: SystemType,
    tenant: string,
    landscape: string,
    permissions: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateRoleMutationVariables = {
  input: UpdateRoleInput,
  condition?: ModelRoleConditionInput | null,
};

export type UpdateRoleMutation = {
  updateRole?:  {
    __typename: "Role",
    id: string,
    name: string,
    description?: string | null,
    isDefault: boolean,
    systemType: SystemType,
    tenant: string,
    landscape: string,
    permissions: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteRoleMutationVariables = {
  input: DeleteRoleInput,
  condition?: ModelRoleConditionInput | null,
};

export type DeleteRoleMutation = {
  deleteRole?:  {
    __typename: "Role",
    id: string,
    name: string,
    description?: string | null,
    isDefault: boolean,
    systemType: SystemType,
    tenant: string,
    landscape: string,
    permissions: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type GetSourceIpQueryVariables = {
};

export type GetSourceIpQuery = {
  getSourceIp?:  {
    __typename: "Context",
    sourceIp?: Array< string | null > | null,
    xForwardedFor?: string | null,
  } | null,
};

export type GetEventQueryVariables = {
  loginName: string,
  tenant: string,
  landscape: string,
};

export type GetEventQuery = {
  getEvent?:  {
    __typename: "Event",
    html?: string | null,
    loginName: string,
    tenant: string,
    landscape: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListEventsQueryVariables = {
  loginName?: string | null,
  tenantLandscape?: ModelEventPrimaryCompositeKeyConditionInput | null,
  filter?: ModelEventFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListEventsQuery = {
  listEvents?:  {
    __typename: "ModelEventConnection",
    items?:  Array< {
      __typename: "Event",
      html?: string | null,
      loginName: string,
      tenant: string,
      landscape: string,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type GetLinkQueryVariables = {
  id: string,
};

export type GetLinkQuery = {
  getLink?:  {
    __typename: "Link",
    id: string,
    menuDescriptions?:  {
      __typename: "ModelLinkMenuDescriptionConnection",
      nextToken?: string | null,
    } | null,
    url: string,
    tenant: string,
    landscape: string,
    sort: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListLinksQueryVariables = {
  filter?: ModelLinkFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLinksQuery = {
  listLinks?:  {
    __typename: "ModelLinkConnection",
    items?:  Array< {
      __typename: "Link",
      id: string,
      url: string,
      tenant: string,
      landscape: string,
      sort: number,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type GetMenuQueryVariables = {
  menuId: string,
  loginName: string,
  tenant: string,
  landscape: string,
};

export type GetMenuQuery = {
  getMenu?:  {
    __typename: "Menu",
    menuId: string,
    parentMenuId: string,
    menuNames?:  {
      __typename: "ModelMenuNameConnection",
      nextToken?: string | null,
    } | null,
    menuDescriptions?:  {
      __typename: "ModelMenuDescriptionConnection",
      nextToken?: string | null,
    } | null,
    url?: string | null,
    isCategory: _Boolean,
    product: Product,
    schemaId: string,
    loginName: string,
    tenant: string,
    landscape: string,
    tenantLandscapeLoginName: string,
    accessedTimeStamp?: number | null,
    sort: number,
    canUseFromExtra: _Boolean,
    menuIconFont?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListMenusQueryVariables = {
  menuId?: string | null,
  loginNameTenantLandscape?: ModelMenuPrimaryCompositeKeyConditionInput | null,
  filter?: ModelMenuFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListMenusQuery = {
  listMenus?:  {
    __typename: "ModelMenuConnection",
    items?:  Array< {
      __typename: "Menu",
      menuId: string,
      parentMenuId: string,
      url?: string | null,
      isCategory: _Boolean,
      product: Product,
      schemaId: string,
      loginName: string,
      tenant: string,
      landscape: string,
      tenantLandscapeLoginName: string,
      accessedTimeStamp?: number | null,
      sort: number,
      canUseFromExtra: _Boolean,
      menuIconFont?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type GetMenuDescriptionQueryVariables = {
  menuId: string,
  language: Language,
  tenant: string,
  landscape: string,
  schemaId: string,
};

export type GetMenuDescriptionQuery = {
  getMenuDescription?:  {
    __typename: "MenuDescription",
    language: Language,
    description?: string | null,
    menuId: string,
    schemaId: string,
    tenant: string,
    landscape: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListMenuDescriptionsQueryVariables = {
  menuId?: string | null,
  languageTenantLandscapeSchemaId?: ModelMenuDescriptionPrimaryCompositeKeyConditionInput | null,
  filter?: ModelMenuDescriptionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListMenuDescriptionsQuery = {
  listMenuDescriptions?:  {
    __typename: "ModelMenuDescriptionConnection",
    items?:  Array< {
      __typename: "MenuDescription",
      language: Language,
      description?: string | null,
      menuId: string,
      schemaId: string,
      tenant: string,
      landscape: string,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type GetLinkMenuDescriptionQueryVariables = {
  menuId: string,
  tenant: string,
  landscape: string,
  language: Language,
};

export type GetLinkMenuDescriptionQuery = {
  getLinkMenuDescription?:  {
    __typename: "LinkMenuDescription",
    language: Language,
    description: string,
    menuId: string,
    tenant: string,
    landscape: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListLinkMenuDescriptionsQueryVariables = {
  menuId?: string | null,
  tenantLandscapeLanguage?: ModelLinkMenuDescriptionPrimaryCompositeKeyConditionInput | null,
  filter?: ModelLinkMenuDescriptionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListLinkMenuDescriptionsQuery = {
  listLinkMenuDescriptions?:  {
    __typename: "ModelLinkMenuDescriptionConnection",
    items?:  Array< {
      __typename: "LinkMenuDescription",
      language: Language,
      description: string,
      menuId: string,
      tenant: string,
      landscape: string,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type GetMenuNameQueryVariables = {
  menuId: string,
  language: Language,
  tenant: string,
  landscape: string,
  schemaId: string,
};

export type GetMenuNameQuery = {
  getMenuName?:  {
    __typename: "MenuName",
    language: Language,
    name?: string | null,
    menuId: string,
    schemaId: string,
    tenant: string,
    landscape: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListMenuNamesQueryVariables = {
  menuId?: string | null,
  languageTenantLandscapeSchemaId?: ModelMenuNamePrimaryCompositeKeyConditionInput | null,
  filter?: ModelMenuNameFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListMenuNamesQuery = {
  listMenuNames?:  {
    __typename: "ModelMenuNameConnection",
    items?:  Array< {
      __typename: "MenuName",
      language: Language,
      name?: string | null,
      menuId: string,
      schemaId: string,
      tenant: string,
      landscape: string,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type GetProductMenuNameQueryVariables = {
  menuId: string,
  loginName: string,
  tenant: string,
  landscape: string,
  language: Language,
};

export type GetProductMenuNameQuery = {
  getProductMenuName?:  {
    __typename: "ProductMenuName",
    language: Language,
    name: string,
    menuId: string,
    loginName: string,
    tenant: string,
    landscape: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListProductMenuNamesQueryVariables = {
  menuId?: string | null,
  loginNameTenantLandscapeLanguage?: ModelProductMenuNamePrimaryCompositeKeyConditionInput | null,
  filter?: ModelProductMenuNameFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListProductMenuNamesQuery = {
  listProductMenuNames?:  {
    __typename: "ModelProductMenuNameConnection",
    items?:  Array< {
      __typename: "ProductMenuName",
      language: Language,
      name: string,
      menuId: string,
      loginName: string,
      tenant: string,
      landscape: string,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type GetNoticeQueryVariables = {
  loginName: string,
  tenant: string,
  landscape: string,
};

export type GetNoticeQuery = {
  getNotice?:  {
    __typename: "Notice",
    html?: string | null,
    loginName: string,
    tenant: string,
    landscape: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListNoticesQueryVariables = {
  loginName?: string | null,
  tenantLandscape?: ModelNoticePrimaryCompositeKeyConditionInput | null,
  filter?: ModelNoticeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListNoticesQuery = {
  listNotices?:  {
    __typename: "ModelNoticeConnection",
    items?:  Array< {
      __typename: "Notice",
      html?: string | null,
      loginName: string,
      tenant: string,
      landscape: string,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type GetFlagQueryVariables = {
  loginName: string,
  tenant: string,
  landscape: string,
  flag: Target,
};

export type GetFlagQuery = {
  getFlag?:  {
    __typename: "Flag",
    flag: Target,
    loginName: string,
    tenant: string,
    landscape: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListFlagsQueryVariables = {
  loginName?: string | null,
  tenantLandscapeFlag?: ModelFlagPrimaryCompositeKeyConditionInput | null,
  filter?: ModelFlagFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListFlagsQuery = {
  listFlags?:  {
    __typename: "ModelFlagConnection",
    items?:  Array< {
      __typename: "Flag",
      flag: Target,
      loginName: string,
      tenant: string,
      landscape: string,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type GetUserQueryVariables = {
  loginName: string,
  tenant: string,
  landscape: string,
};

export type GetUserQuery = {
  getUser?:  {
    __typename: "User",
    loginName: string,
    tenant: string,
    landscape: string,
    displaysFavoritePanel: _Boolean,
    isAdmin: _Boolean,
    language: Language,
    name?: string | null,
    affiliation?: string | null,
    csrSchema?: string | null,
    cwsSchema?: string | null,
    cjkSchema?: string | null,
    ctmSchema?: string | null,
    event?:  {
      __typename: "Event",
      html?: string | null,
      loginName: string,
      tenant: string,
      landscape: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    notice?:  {
      __typename: "Notice",
      html?: string | null,
      loginName: string,
      tenant: string,
      landscape: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    menus?:  {
      __typename: "ModelMenuConnection",
      nextToken?: string | null,
    } | null,
    productMenus?:  {
      __typename: "ModelProductMenuConnection",
      nextToken?: string | null,
    } | null,
    flags?:  {
      __typename: "ModelFlagConnection",
      nextToken?: string | null,
    } | null,
    favorites?:  {
      __typename: "ModelFavoriteConnection",
      nextToken?: string | null,
    } | null,
    notifications?:  {
      __typename: "ModelNotificationConnection",
      nextToken?: string | null,
    } | null,
    announcements?:  {
      __typename: "ModelUserAnnouncementConnection",
      nextToken?: string | null,
    } | null,
    scheduledEventMetadatasByCreatedBy?:  {
      __typename: "ModelScheduledEventMetadataConnection",
      nextToken?: string | null,
    } | null,
    scheduledEventMetadatasByUpdatedBy?:  {
      __typename: "ModelScheduledEventMetadataConnection",
      nextToken?: string | null,
    } | null,
    scheduledEventHistoriesByExecutedBy?:  {
      __typename: "ModelScheduledEventHistoryConnection",
      nextToken?: string | null,
    } | null,
    scheduledHolidayMetadatasByCreatedBy?:  {
      __typename: "ModelScheduledHolidayMetadataConnection",
      nextToken?: string | null,
    } | null,
    scheduledHolidayMetadatasByUpdatedBy?:  {
      __typename: "ModelScheduledHolidayMetadataConnection",
      nextToken?: string | null,
    } | null,
    productMenuNames?:  {
      __typename: "ModelProductMenuNameConnection",
      nextToken?: string | null,
    } | null,
    countTables?:  {
      __typename: "ModelCountTableConnection",
      nextToken?: string | null,
    } | null,
    roleId?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListUsersQueryVariables = {
  loginName?: string | null,
  tenantLandscape?: ModelUserPrimaryCompositeKeyConditionInput | null,
  filter?: ModelUserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListUsersQuery = {
  listUsers?:  {
    __typename: "ModelUserConnection",
    items?:  Array< {
      __typename: "User",
      loginName: string,
      tenant: string,
      landscape: string,
      displaysFavoritePanel: _Boolean,
      isAdmin: _Boolean,
      language: Language,
      name?: string | null,
      affiliation?: string | null,
      csrSchema?: string | null,
      cwsSchema?: string | null,
      cjkSchema?: string | null,
      ctmSchema?: string | null,
      roleId?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type GetNotificationQueryVariables = {
  notificationId: string,
  loginName: string,
  tenant: string,
  landscape: string,
};

export type GetNotificationQuery = {
  getNotification?:  {
    __typename: "Notification",
    loginName: string,
    tenant: string,
    landscape: string,
    tenantLandscapeLoginName: string,
    product: Product,
    notificationId: string,
    content: string,
    iconType?: string | null,
    onClickAction: string,
    extraActions?:  Array< {
      __typename: "NotificationActions",
      actionName: string,
      onClickAction: string,
    } > | null,
    displayStartDate: number,
    displayEndDate?: number | null,
    isRead: _Boolean,
    isFinished: _Boolean,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListNotificationsQueryVariables = {
  notificationId?: string | null,
  loginNameTenantLandscape?: ModelNotificationPrimaryCompositeKeyConditionInput | null,
  filter?: ModelNotificationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListNotificationsQuery = {
  listNotifications?:  {
    __typename: "ModelNotificationConnection",
    items?:  Array< {
      __typename: "Notification",
      loginName: string,
      tenant: string,
      landscape: string,
      tenantLandscapeLoginName: string,
      product: Product,
      notificationId: string,
      content: string,
      iconType?: string | null,
      onClickAction: string,
      displayStartDate: number,
      displayEndDate?: number | null,
      isRead: _Boolean,
      isFinished: _Boolean,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type GetCountTableQueryVariables = {
  loginName: string,
  tenant: string,
  landscape: string,
  tableName: TableName,
};

export type GetCountTableQuery = {
  getCountTable?:  {
    __typename: "CountTable",
    loginName: string,
    tenant: string,
    landscape: string,
    tableName: TableName,
    totalCount: number,
    isUnRead?: number | null,
    isExpired?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListCountTablesQueryVariables = {
  loginName?: string | null,
  tenantLandscapeTableName?: ModelCountTablePrimaryCompositeKeyConditionInput | null,
  filter?: ModelCountTableFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListCountTablesQuery = {
  listCountTables?:  {
    __typename: "ModelCountTableConnection",
    items?:  Array< {
      __typename: "CountTable",
      loginName: string,
      tenant: string,
      landscape: string,
      tableName: TableName,
      totalCount: number,
      isUnRead?: number | null,
      isExpired?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type GetAnnouncementQueryVariables = {
  id: string,
};

export type GetAnnouncementQuery = {
  getAnnouncement?:  {
    __typename: "Announcement",
    id: string,
    tenant: string,
    landscape: string,
    tenantLandscape: string,
    users?:  {
      __typename: "ModelUserAnnouncementConnection",
      nextToken?: string | null,
    } | null,
    title: string,
    content: string,
    linkToProductMenu: string,
    isPublic: _Boolean,
    displayStartDate: number,
    displayEndDate?: number | null,
    priorityTag: PriorityTag,
    createdAt: string,
    updatedAt?: string | null,
  } | null,
};

export type ListAnnouncementsQueryVariables = {
  filter?: ModelAnnouncementFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAnnouncementsQuery = {
  listAnnouncements?:  {
    __typename: "ModelAnnouncementConnection",
    items?:  Array< {
      __typename: "Announcement",
      id: string,
      tenant: string,
      landscape: string,
      tenantLandscape: string,
      title: string,
      content: string,
      linkToProductMenu: string,
      isPublic: _Boolean,
      displayStartDate: number,
      displayEndDate?: number | null,
      priorityTag: PriorityTag,
      createdAt: string,
      updatedAt?: string | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type GetUserAnnouncementQueryVariables = {
  loginName: string,
  tenant: string,
  landscape: string,
  announcementId: string,
};

export type GetUserAnnouncementQuery = {
  getUserAnnouncement?:  {
    __typename: "UserAnnouncement",
    announcementId: string,
    loginName: string,
    tenant: string,
    landscape: string,
    tenantLandscapeLoginName: string,
    announcement:  {
      __typename: "Announcement",
      id: string,
      tenant: string,
      landscape: string,
      tenantLandscape: string,
      title: string,
      content: string,
      linkToProductMenu: string,
      isPublic: _Boolean,
      displayStartDate: number,
      displayEndDate?: number | null,
      priorityTag: PriorityTag,
      createdAt: string,
      updatedAt?: string | null,
    },
    displayStartDate: number,
    displayEndDate?: number | null,
    isProcessed: _Boolean,
    isRead: _Boolean,
    isShow: _Boolean,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListUserAnnouncementsQueryVariables = {
  loginName?: string | null,
  tenantLandscapeAnnouncementId?: ModelUserAnnouncementPrimaryCompositeKeyConditionInput | null,
  filter?: ModelUserAnnouncementFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListUserAnnouncementsQuery = {
  listUserAnnouncements?:  {
    __typename: "ModelUserAnnouncementConnection",
    items?:  Array< {
      __typename: "UserAnnouncement",
      announcementId: string,
      loginName: string,
      tenant: string,
      landscape: string,
      tenantLandscapeLoginName: string,
      displayStartDate: number,
      displayEndDate?: number | null,
      isProcessed: _Boolean,
      isRead: _Boolean,
      isShow: _Boolean,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type GetFavoriteQueryVariables = {
  menuId: string,
  loginName: string,
  tenant: string,
  landscape: string,
};

export type GetFavoriteQuery = {
  getFavorite?:  {
    __typename: "Favorite",
    sort: number,
    menuId: string,
    loginName: string,
    tenant: string,
    landscape: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListFavoritesQueryVariables = {
  menuId?: string | null,
  loginNameTenantLandscape?: ModelFavoritePrimaryCompositeKeyConditionInput | null,
  filter?: ModelFavoriteFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListFavoritesQuery = {
  listFavorites?:  {
    __typename: "ModelFavoriteConnection",
    items?:  Array< {
      __typename: "Favorite",
      sort: number,
      menuId: string,
      loginName: string,
      tenant: string,
      landscape: string,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type GetMenuIndexQueryVariables = {
  index: string,
  product: Product,
  schema: string,
  menuId: string,
  language: Language,
  tenant: string,
  landscape: string,
};

export type GetMenuIndexQuery = {
  getMenuIndex?:  {
    __typename: "MenuIndex",
    index: string,
    menuId: string,
    product: Product,
    schema: string,
    language: Language,
    tenant: string,
    landscape: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListMenuIndexsQueryVariables = {
  index?: string | null,
  productSchemaMenuIdLanguageTenantLandscape?: ModelMenuIndexPrimaryCompositeKeyConditionInput | null,
  filter?: ModelMenuIndexFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListMenuIndexsQuery = {
  listMenuIndexs?:  {
    __typename: "ModelMenuIndexConnection",
    items?:  Array< {
      __typename: "MenuIndex",
      index: string,
      menuId: string,
      product: Product,
      schema: string,
      language: Language,
      tenant: string,
      landscape: string,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type GetProductMenuQueryVariables = {
  menuId: string,
  loginName: string,
  tenant: string,
  landscape: string,
};

export type GetProductMenuQuery = {
  getProductMenu?:  {
    __typename: "ProductMenu",
    loginName: string,
    tenant: string,
    landscape: string,
    menuId: string,
    menuNames?:  {
      __typename: "ModelProductMenuNameConnection",
      nextToken?: string | null,
    } | null,
    isHome: _Boolean,
    stateKey: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListProductMenusQueryVariables = {
  menuId?: string | null,
  loginNameTenantLandscape?: ModelProductMenuPrimaryCompositeKeyConditionInput | null,
  filter?: ModelProductMenuFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListProductMenusQuery = {
  listProductMenus?:  {
    __typename: "ModelProductMenuConnection",
    items?:  Array< {
      __typename: "ProductMenu",
      loginName: string,
      tenant: string,
      landscape: string,
      menuId: string,
      isHome: _Boolean,
      stateKey: string,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type GetGatewayServerQueryVariables = {
  tenant: string,
  landscape: string,
  product: Product,
};

export type GetGatewayServerQuery = {
  getGatewayServer?:  {
    __typename: "GatewayServer",
    tenant: string,
    landscape: string,
    product: Product,
    useInternetAccess: _Boolean,
    isInternalGateWayServer: _Boolean,
    gatewayServerIps?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListGatewayServersQueryVariables = {
  tenant?: string | null,
  landscapeProduct?: ModelGatewayServerPrimaryCompositeKeyConditionInput | null,
  filter?: ModelGatewayServerFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListGatewayServersQuery = {
  listGatewayServers?:  {
    __typename: "ModelGatewayServerConnection",
    items?:  Array< {
      __typename: "GatewayServer",
      tenant: string,
      landscape: string,
      product: Product,
      useInternetAccess: _Boolean,
      isInternalGateWayServer: _Boolean,
      gatewayServerIps?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type GetCognitoInfoQueryVariables = {
  tenant: string,
  landscape: string,
};

export type GetCognitoInfoQuery = {
  getCognitoInfo?:  {
    __typename: "CognitoInfo",
    tenant: string,
    landscape: string,
    identityPoolId: string,
    region: string,
    userPoolId: string,
    userPoolWebClientId: string,
    identityProvider: string,
    amazonCognitoDomain: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListCognitoInfosQueryVariables = {
  tenant?: string | null,
  landscape?: ModelStringKeyConditionInput | null,
  filter?: ModelCognitoInfoFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListCognitoInfosQuery = {
  listCognitoInfos?:  {
    __typename: "ModelCognitoInfoConnection",
    items?:  Array< {
      __typename: "CognitoInfo",
      tenant: string,
      landscape: string,
      identityPoolId: string,
      region: string,
      userPoolId: string,
      userPoolWebClientId: string,
      identityProvider: string,
      amazonCognitoDomain: string,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type GetAPIGatewayInfoQueryVariables = {
  tenant: string,
  landscape: string,
};

export type GetAPIGatewayInfoQuery = {
  getAPIGatewayInfo?:  {
    __typename: "APIGatewayInfo",
    tenant: string,
    landscape: string,
    endpoint: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListAPIGatewayInfosQueryVariables = {
  tenant?: string | null,
  landscape?: ModelStringKeyConditionInput | null,
  filter?: ModelAPIGatewayInfoFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListAPIGatewayInfosQuery = {
  listAPIGatewayInfos?:  {
    __typename: "ModelAPIGatewayInfoConnection",
    items?:  Array< {
      __typename: "APIGatewayInfo",
      tenant: string,
      landscape: string,
      endpoint: string,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type GetBackendInfoQueryVariables = {
  tenant: string,
  landscape: string,
};

export type GetBackendInfoQuery = {
  getBackendInfo?:  {
    __typename: "BackendInfo",
    tenant: string,
    landscape: string,
    apiGatewayInfo?:  {
      __typename: "APIGatewayInfo",
      tenant: string,
      landscape: string,
      endpoint: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    cognitoInfo?:  {
      __typename: "CognitoInfo",
      tenant: string,
      landscape: string,
      identityPoolId: string,
      region: string,
      userPoolId: string,
      userPoolWebClientId: string,
      identityProvider: string,
      amazonCognitoDomain: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListBackendInfosQueryVariables = {
  tenant?: string | null,
  landscape?: ModelStringKeyConditionInput | null,
  filter?: ModelBackendInfoFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListBackendInfosQuery = {
  listBackendInfos?:  {
    __typename: "ModelBackendInfoConnection",
    items?:  Array< {
      __typename: "BackendInfo",
      tenant: string,
      landscape: string,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type GetAuthQueryQueryVariables = {
  tenant: string,
  landscape: string,
  identityProvider: string,
  product: Product,
};

export type GetAuthQueryQuery = {
  getAuthQuery?:  {
    __typename: "AuthQuery",
    tenant: string,
    landscape: string,
    identityProvider: string,
    product: Product,
    additionalQuery: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListAuthQuerysQueryVariables = {
  tenant?: string | null,
  landscapeIdentityProviderProduct?: ModelAuthQueryPrimaryCompositeKeyConditionInput | null,
  filter?: ModelAuthQueryFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListSystemSettingInfosQuery = {
  listSystemSettingInfos?:  {
    __typename: "ModelSystemSettingInfoConnection",
    items?:  Array< {
      __typename: "SystemSettingInfo",
      tenant: string,
      landscape: string,
      identityProvider: string,
      product: Product,
      additionalQuery: string,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type GetSystemSettingInfoQueryVariables = {
  tenant: string,
  landscape: string,
};

export type GetSystemSettingInfoQuery = {
  getSystemSettingInfo?:  {
    __typename: "SystemSettingInfo",
    tenant: string,
    landscape: string,
    isMultilanguageEnabled?: _Boolean | null,
    isNotificationEnabled?: _Boolean | null,
    isJobSchedulerEnabled?: _Boolean | null,
    isPortalEnabled?: _Boolean | null,
    announcementSetting?: AnnouncementSetting | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListSystemSettingInfosQueryVariables = {
  tenant?: string | null,
  landscape?: ModelStringKeyConditionInput | null,
  filter?: ModelSystemSettingInfoFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListAuthQuerysQuery = {
  listAuthQuerys?:  {
    __typename: "ModelAuthQueryConnection",
    items?:  Array< {
      __typename: "AuthQuery",
      tenant: string,
      landscape: string,
      isMultilanguageEnabled?: _Boolean | null,
      isNotificationEnabled?: _Boolean | null,
      isJobSchedulerEnabled?: _Boolean | null,
      isPortalEnabled?: _Boolean | null,
      announcementSetting?: AnnouncementSetting | null,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type GetCustomerCompanyVersionQueryVariables = {
  id: string,
};

export type GetCustomerCompanyVersionQuery = {
  getCustomerCompanyVersion?:  {
    __typename: "CustomerCompanyVersion",
    id: string,
    tenant: string,
    landscape: string,
    tenantLandscape: string,
    version: string,
    product: string,
    applyDateTime: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListCustomerCompanyVersionsQueryVariables = {
  filter?: ModelCustomerCompanyVersionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListCustomerCompanyVersionsQuery = {
  listCustomerCompanyVersions?:  {
    __typename: "ModelCustomerCompanyVersionConnection",
    items?:  Array< {
      __typename: "CustomerCompanyVersion",
      id: string,
      tenant: string,
      landscape: string,
      tenantLandscape: string,
      version: string,
      product: string,
      applyDateTime: string,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type GetTaskMetadataQueryVariables = {
  versionProductBatch: string,
};

export type GetTaskMetadataQuery = {
  getTaskMetadata?:  {
    __typename: "TaskMetadata",
    version: string,
    product: string,
    batch: string,
    batchName: string,
    versionProductBatch: string,
    args:  Array< {
      __typename: "TaskMetadataArgs",
      required: _Boolean,
      default?: string | null,
      display: _Boolean,
      order: number,
      option: string,
      type: TaskMetadataArgsType,
      delimiter?: string | null,
      isMultiple?: _Boolean | null,
      isOutputFile?: _Boolean | null,
      isInputFile?: _Boolean | null,
      isSecret?: _Boolean | null,
      sampleInput?: string | null,
      isResolvable?: _Boolean | null,
    } >,
    requestBodyPropertyTemplates?:  Array< {
      __typename: "RequestBodyPropertyTemplate",
      requestBodyProperty: string,
      template: string,
    } | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListTaskMetadatasQueryVariables = {
  versionProductBatch?: string | null,
  filter?: ModelTaskMetadataFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListTaskMetadatasQuery = {
  listTaskMetadatas?:  {
    __typename: "ModelTaskMetadataConnection",
    items?:  Array< {
      __typename: "TaskMetadata",
      version: string,
      product: string,
      batch: string,
      batchName: string,
      versionProductBatch: string,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type GetTenantUsingMoveFileTaskQueryVariables = {
  tenant: string,
};

export type GetTenantUsingMoveFileTaskQuery = {
  getTenantUsingMoveFileTask?:  {
    __typename: "TenantUsingMoveFileTask",
    tenant: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListTenantUsingMoveFileTasksQueryVariables = {
  tenant?: string | null,
  filter?: ModelTenantUsingMoveFileTaskFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListTenantUsingMoveFileTasksQuery = {
  listTenantUsingMoveFileTasks?:  {
    __typename: "ModelTenantUsingMoveFileTaskConnection",
    items?:  Array< {
      __typename: "TenantUsingMoveFileTask",
      tenant: string,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type GetJobQueryVariables = {
  id: string,
};

export type GetJobQuery = {
  getJob?:  {
    __typename: "Job",
    id: string,
    tenant: string,
    landscape: string,
    tenantLandscape: string,
    jobCode: string,
    title: string,
    description?: string | null,
    jobTriggerFilePath?: string | null,
    tasks?:  {
      __typename: "ModelTaskConnection",
      nextToken?: string | null,
    } | null,
    hasOutputFile: _Boolean,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListJobsQueryVariables = {
  filter?: ModelJobFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListJobsQuery = {
  listJobs?:  {
    __typename: "ModelJobConnection",
    items?:  Array< {
      __typename: "Job",
      id: string,
      tenant: string,
      landscape: string,
      tenantLandscape: string,
      jobCode: string,
      title: string,
      description?: string | null,
      jobTriggerFilePath?: string | null,
      hasOutputFile: _Boolean,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type GetTaskQueryVariables = {
  jobIdOrder: string,
};

export type GetTaskQuery = {
  getTask?:  {
    __typename: "Task",
    version: string,
    product: string,
    batch: string,
    batchName: string,
    versionProductBatch: string,
    jobId: string,
    order: number,
    jobIdOrder: string,
    taskMetadata?:  {
      __typename: "TaskMetadata",
      version: string,
      product: string,
      batch: string,
      batchName: string,
      versionProductBatch: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    title: string,
    args:  Array< {
      __typename: "TaskArgs",
      order: number,
      option: string,
      value: string,
      replaceInFileName?: _Boolean | null,
    } >,
    includeInDownload?: _Boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListTasksQueryVariables = {
  jobIdOrder?: string | null,
  filter?: ModelTaskFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListTasksQuery = {
  listTasks?:  {
    __typename: "ModelTaskConnection",
    items?:  Array< {
      __typename: "Task",
      version: string,
      product: string,
      batch: string,
      batchName: string,
      versionProductBatch: string,
      jobId: string,
      order: number,
      jobIdOrder: string,
      title: string,
      includeInDownload?: _Boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type GetScheduledEventMetadataQueryVariables = {
  id: string,
};

export type GetScheduledEventMetadataQuery = {
  getScheduledEventMetadata?:  {
    __typename: "ScheduledEventMetadata",
    id: string,
    tenant: string,
    landscape: string,
    tenantLandscape: string,
    title: string,
    description?: string | null,
    jobId: string,
    job?:  {
      __typename: "Job",
      id: string,
      tenant: string,
      landscape: string,
      tenantLandscape: string,
      jobCode: string,
      title: string,
      description?: string | null,
      jobTriggerFilePath?: string | null,
      hasOutputFile: _Boolean,
      createdAt: string,
      updatedAt: string,
    } | null,
    repeatType: RepeatType,
    rruleSet: string,
    holidayExecutionType: HolidayExecutionType,
    useCustomHoliday: _Boolean,
    customHolidayLabels?: Array< string > | null,
    eventTriggerType: EventTriggerType,
    createdBy: string,
    updatedBy: string,
    editedAt?: string | null,
    expirationDate?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListScheduledEventMetadatasQueryVariables = {
  filter?: ModelScheduledEventMetadataFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListScheduledEventMetadatasQuery = {
  listScheduledEventMetadatas?:  {
    __typename: "ModelScheduledEventMetadataConnection",
    items?:  Array< {
      __typename: "ScheduledEventMetadata",
      id: string,
      tenant: string,
      landscape: string,
      tenantLandscape: string,
      title: string,
      description?: string | null,
      jobId: string,
      repeatType: RepeatType,
      rruleSet: string,
      holidayExecutionType: HolidayExecutionType,
      useCustomHoliday: _Boolean,
      customHolidayLabels?: Array< string > | null,
      eventTriggerType: EventTriggerType,
      createdBy: string,
      updatedBy: string,
      editedAt?: string | null,
      expirationDate?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type GetScheduledEventHistoryQueryVariables = {
  id: string,
};

export type GetScheduledEventHistoryQuery = {
  getScheduledEventHistory?:  {
    __typename: "ScheduledEventHistory",
    id: string,
    tenant: string,
    landscape: string,
    tenantLandscape: string,
    title: string,
    description?: string | null,
    scheduledEventMetadataId: string,
    scheduledEventMetadata?:  {
      __typename: "ScheduledEventMetadata",
      id: string,
      tenant: string,
      landscape: string,
      tenantLandscape: string,
      title: string,
      description?: string | null,
      jobId: string,
      repeatType: RepeatType,
      rruleSet: string,
      holidayExecutionType: HolidayExecutionType,
      useCustomHoliday: _Boolean,
      customHolidayLabels?: Array< string > | null,
      eventTriggerType: EventTriggerType,
      createdBy: string,
      updatedBy: string,
      editedAt?: string | null,
      expirationDate?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    eventStartDateTime: number,
    jobId: string,
    job?:  {
      __typename: "Job",
      id: string,
      tenant: string,
      landscape: string,
      tenantLandscape: string,
      jobCode: string,
      title: string,
      description?: string | null,
      jobTriggerFilePath?: string | null,
      hasOutputFile: _Boolean,
      createdAt: string,
      updatedAt: string,
    } | null,
    jobExecutionStatus: JobExecutionStatus,
    tasks?:  {
      __typename: "ModelTaskConnection",
      nextToken?: string | null,
    } | null,
    taskHistories?:  {
      __typename: "ModelTaskHistoryConnection",
      nextToken?: string | null,
    } | null,
    executedBy: string,
    executionArn?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListScheduledEventHistorysQueryVariables = {
  filter?: ModelScheduledEventHistoryFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListScheduledEventHistorysQuery = {
  listScheduledEventHistorys?:  {
    __typename: "ModelScheduledEventHistoryConnection",
    items?:  Array< {
      __typename: "ScheduledEventHistory",
      id: string,
      tenant: string,
      landscape: string,
      tenantLandscape: string,
      title: string,
      description?: string | null,
      scheduledEventMetadataId: string,
      eventStartDateTime: number,
      jobId: string,
      jobExecutionStatus: JobExecutionStatus,
      executedBy: string,
      executionArn?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type GetTaskHistoryQueryVariables = {
  scheduledEventHistoryId: string,
  jobIdOrder: string,
};

export type GetTaskHistoryQuery = {
  getTaskHistory?:  {
    __typename: "TaskHistory",
    jobIdOrder: string,
    jobId: string,
    order: number,
    scheduledEventHistoryId: string,
    task?:  {
      __typename: "Task",
      version: string,
      product: string,
      batch: string,
      batchName: string,
      versionProductBatch: string,
      jobId: string,
      order: number,
      jobIdOrder: string,
      title: string,
      includeInDownload?: _Boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    tenant: string,
    landscape: string,
    tenantLandscape: string,
    taskStartDateTime?: number | null,
    taskEndDateTime?: number | null,
    taskExecutionStatus: TaskExecutionStatus,
    log: string,
    outputFilePath?: string | null,
    includeInDownload?: _Boolean | null,
    taskTitle?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListTaskHistorysQueryVariables = {
  scheduledEventHistoryId?: string | null,
  jobIdOrder?: ModelStringKeyConditionInput | null,
  filter?: ModelTaskHistoryFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListTaskHistorysQuery = {
  listTaskHistorys?:  {
    __typename: "ModelTaskHistoryConnection",
    items?:  Array< {
      __typename: "TaskHistory",
      jobIdOrder: string,
      jobId: string,
      order: number,
      scheduledEventHistoryId: string,
      tenant: string,
      landscape: string,
      tenantLandscape: string,
      taskStartDateTime?: number | null,
      taskEndDateTime?: number | null,
      taskExecutionStatus: TaskExecutionStatus,
      log: string,
      outputFilePath?: string | null,
      includeInDownload?: _Boolean | null,
      taskTitle?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type GetScheduledHolidayMetadataQueryVariables = {
  id: string,
};

export type GetScheduledHolidayMetadataQuery = {
  getScheduledHolidayMetadata?:  {
    __typename: "ScheduledHolidayMetadata",
    id: string,
    tenant: string,
    landscape: string,
    tenantLandscape: string,
    title: string,
    description?: string | null,
    repeatType: RepeatType,
    rruleSet: string,
    labels: Array< string >,
    createdBy: string,
    updatedBy: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListScheduledHolidayMetadatasQueryVariables = {
  filter?: ModelScheduledHolidayMetadataFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListScheduledHolidayMetadatasQuery = {
  listScheduledHolidayMetadatas?:  {
    __typename: "ModelScheduledHolidayMetadataConnection",
    items?:  Array< {
      __typename: "ScheduledHolidayMetadata",
      id: string,
      tenant: string,
      landscape: string,
      tenantLandscape: string,
      title: string,
      description?: string | null,
      repeatType: RepeatType,
      rruleSet: string,
      labels: Array< string >,
      createdBy: string,
      updatedBy: string,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type GetPublicHolidayQueryVariables = {
  startDate: string,
  language: Language,
};

export type GetPublicHolidayQuery = {
  getPublicHoliday?:  {
    __typename: "PublicHoliday",
    startDate: string,
    language: Language,
    title: string,
    label: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListPublicHolidaysQueryVariables = {
  startDate?: string | null,
  language?: ModelStringKeyConditionInput | null,
  filter?: ModelPublicHolidayFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListPublicHolidaysQuery = {
  listPublicHolidays?:  {
    __typename: "ModelPublicHolidayConnection",
    items?:  Array< {
      __typename: "PublicHoliday",
      startDate: string,
      language: Language,
      title: string,
      label: string,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type GetWebsocketConnectionQueryVariables = {
  connectionId: string,
};

export type GetWebsocketConnectionQuery = {
  getWebsocketConnection?:  {
    __typename: "WebsocketConnection",
    connectionId: string,
    endpoint: string,
    tenant: string,
    landscape: string,
    hostname: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListWebsocketConnectionsQueryVariables = {
  connectionId?: string | null,
  filter?: ModelWebsocketConnectionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListWebsocketConnectionsQuery = {
  listWebsocketConnections?:  {
    __typename: "ModelWebsocketConnectionConnection",
    items?:  Array< {
      __typename: "WebsocketConnection",
      connectionId: string,
      endpoint: string,
      tenant: string,
      landscape: string,
      hostname: string,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type GetWebsocketWaitingResponseQueryVariables = {
  parentId: string,
};

export type GetWebsocketWaitingResponseQuery = {
  getWebsocketWaitingResponse?:  {
    __typename: "WebsocketWaitingResponse",
    parentId: string,
    connectionId: string,
    messageType: ResponseExpectedMessageTypes,
    receivedAt: string,
    timeoutAt: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListWebsocketWaitingResponsesQueryVariables = {
  parentId?: string | null,
  filter?: ModelWebsocketWaitingResponseFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListWebsocketWaitingResponsesQuery = {
  listWebsocketWaitingResponses?:  {
    __typename: "ModelWebsocketWaitingResponseConnection",
    items?:  Array< {
      __typename: "WebsocketWaitingResponse",
      parentId: string,
      connectionId: string,
      messageType: ResponseExpectedMessageTypes,
      receivedAt: string,
      timeoutAt: string,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type GetRoleQueryVariables = {
  id: string,
};

export type GetRoleQuery = {
  getRole?:  {
    __typename: "Role",
    id: string,
    name: string,
    description?: string | null,
    isDefault: boolean,
    systemType: SystemType,
    tenant: string,
    landscape: string,
    permissions: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListRolesQueryVariables = {
  id?: string | null,
  filter?: ModelRoleFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListRolesQuery = {
  listRoles?:  {
    __typename: "ModelRoleConnection",
    items?:  Array< {
      __typename: "Role",
      id: string,
      name: string,
      description?: string | null,
      isDefault: boolean,
      systemType: SystemType,
      tenant: string,
      landscape: string,
      permissions: string,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type LinkByTenantLandscapeQueryVariables = {
  tenant?: string | null,
  landscape?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLinkFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type LinkByTenantLandscapeQuery = {
  linkByTenantLandscape?:  {
    __typename: "ModelLinkConnection",
    items?:  Array< {
      __typename: "Link",
      id: string,
      url: string,
      tenant: string,
      landscape: string,
      sort: number,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type MenuByAccessedTimeStampQueryVariables = {
  tenantLandscapeLoginName?: string | null,
  accessedTimeStamp?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelMenuFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type MenuByAccessedTimeStampQuery = {
  menuByAccessedTimeStamp?:  {
    __typename: "ModelMenuConnection",
    items?:  Array< {
      __typename: "Menu",
      menuId: string,
      parentMenuId: string,
      url?: string | null,
      isCategory: _Boolean,
      product: Product,
      schemaId: string,
      loginName: string,
      tenant: string,
      landscape: string,
      tenantLandscapeLoginName: string,
      accessedTimeStamp?: number | null,
      sort: number,
      canUseFromExtra: _Boolean,
      menuIconFont?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type MenuByProductQueryVariables = {
  loginName?: string | null,
  tenantLandscapeProduct?: ModelMenuProductIndexCompositeKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelMenuFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type MenuByProductQuery = {
  menuByProduct?:  {
    __typename: "ModelMenuConnection",
    items?:  Array< {
      __typename: "Menu",
      menuId: string,
      parentMenuId: string,
      url?: string | null,
      isCategory: _Boolean,
      product: Product,
      schemaId: string,
      loginName: string,
      tenant: string,
      landscape: string,
      tenantLandscapeLoginName: string,
      accessedTimeStamp?: number | null,
      sort: number,
      canUseFromExtra: _Boolean,
      menuIconFont?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type UserByTenantLandscapeQueryVariables = {
  tenant?: string | null,
  landscape?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelUserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type UserByTenantLandscapeQuery = {
  userByTenantLandscape?:  {
    __typename: "ModelUserConnection",
    items?:  Array< {
      __typename: "User",
      loginName: string,
      tenant: string,
      landscape: string,
      displaysFavoritePanel: _Boolean,
      isAdmin: _Boolean,
      language: Language,
      name?: string | null,
      affiliation?: string | null,
      csrSchema?: string | null,
      cwsSchema?: string | null,
      cjkSchema?: string | null,
      ctmSchema?: string | null,
      roleId?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type UserNotificationQueryVariables = {
  loginName?: string | null,
  tenantLandscape?: ModelNotificationUserNotificationCompositeKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelNotificationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type UserNotificationQuery = {
  userNotification?:  {
    __typename: "ModelNotificationConnection",
    items?:  Array< {
      __typename: "Notification",
      loginName: string,
      tenant: string,
      landscape: string,
      tenantLandscapeLoginName: string,
      product: Product,
      notificationId: string,
      content: string,
      iconType?: string | null,
      onClickAction: string,
      displayStartDate: number,
      displayEndDate?: number | null,
      isRead: _Boolean,
      isFinished: _Boolean,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type NotificationSortedByDisplayStartDateQueryVariables = {
  tenantLandscapeLoginName?: string | null,
  displayStartDate?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelNotificationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type NotificationSortedByDisplayStartDateQuery = {
  notificationSortedByDisplayStartDate?:  {
    __typename: "ModelNotificationConnection",
    items?:  Array< {
      __typename: "Notification",
      loginName: string,
      tenant: string,
      landscape: string,
      tenantLandscapeLoginName: string,
      product: Product,
      notificationId: string,
      content: string,
      iconType?: string | null,
      onClickAction: string,
      displayStartDate: number,
      displayEndDate?: number | null,
      isRead: _Boolean,
      isFinished: _Boolean,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type CountTableByTenantLandscapeAndLoginNameQueryVariables = {
  tenant?: string | null,
  landscapeLoginName?: ModelCountTableTenantLandscapeAndLoginNameIndexCompositeKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelCountTableFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type CountTableByTenantLandscapeAndLoginNameQuery = {
  countTableByTenantLandscapeAndLoginName?:  {
    __typename: "ModelCountTableConnection",
    items?:  Array< {
      __typename: "CountTable",
      loginName: string,
      tenant: string,
      landscape: string,
      tableName: TableName,
      totalCount: number,
      isUnRead?: number | null,
      isExpired?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type AnnouncementByTenantLandscapeQueryVariables = {
  tenantLandscape?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAnnouncementFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type AnnouncementByTenantLandscapeQuery = {
  announcementByTenantLandscape?:  {
    __typename: "ModelAnnouncementConnection",
    items?:  Array< {
      __typename: "Announcement",
      id: string,
      tenant: string,
      landscape: string,
      tenantLandscape: string,
      title: string,
      content: string,
      linkToProductMenu: string,
      isPublic: _Boolean,
      displayStartDate: number,
      displayEndDate?: number | null,
      priorityTag: PriorityTag,
      createdAt: string,
      updatedAt?: string | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type UserAnnouncementsQueryVariables = {
  loginName?: string | null,
  tenantLandscape?: ModelUserAnnouncementUserAnnouncementIndexbyUserCompositeKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelUserAnnouncementFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type UserAnnouncementsQuery = {
  userAnnouncements?:  {
    __typename: "ModelUserAnnouncementConnection",
    items?:  Array< {
      __typename: "UserAnnouncement",
      announcementId: string,
      loginName: string,
      tenant: string,
      landscape: string,
      tenantLandscapeLoginName: string,
      displayStartDate: number,
      displayEndDate?: number | null,
      isProcessed: _Boolean,
      isRead: _Boolean,
      isShow: _Boolean,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type UserAnnouncementsByDisplayStartDateQueryVariables = {
  tenantLandscapeLoginName?: string | null,
  displayStartDate?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelUserAnnouncementFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type UserAnnouncementsByDisplayStartDateQuery = {
  userAnnouncementsByDisplayStartDate?:  {
    __typename: "ModelUserAnnouncementConnection",
    items?:  Array< {
      __typename: "UserAnnouncement",
      announcementId: string,
      loginName: string,
      tenant: string,
      landscape: string,
      tenantLandscapeLoginName: string,
      displayStartDate: number,
      displayEndDate?: number | null,
      isProcessed: _Boolean,
      isRead: _Boolean,
      isShow: _Boolean,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type FavoriteBySortQueryVariables = {
  loginName?: string | null,
  tenantLandscapeSort?: ModelFavoriteSortIndexCompositeKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelFavoriteFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type FavoriteBySortQuery = {
  favoriteBySort?:  {
    __typename: "ModelFavoriteConnection",
    items?:  Array< {
      __typename: "Favorite",
      sort: number,
      menuId: string,
      loginName: string,
      tenant: string,
      landscape: string,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type UserFavoritesQueryVariables = {
  loginName?: string | null,
  tenantLandscape?: ModelFavoriteUserFavoritesCompositeKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelFavoriteFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type UserFavoritesQuery = {
  userFavorites?:  {
    __typename: "ModelFavoriteConnection",
    items?:  Array< {
      __typename: "Favorite",
      sort: number,
      menuId: string,
      loginName: string,
      tenant: string,
      landscape: string,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type MenuIndexByMenuIdQueryVariables = {
  menuId?: string | null,
  productSchemaLanguageTenantLandscape?: ModelMenuIndexMenuIdIndexCompositeKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelMenuIndexFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type MenuIndexByMenuIdQuery = {
  menuIndexByMenuId?:  {
    __typename: "ModelMenuIndexConnection",
    items?:  Array< {
      __typename: "MenuIndex",
      index: string,
      menuId: string,
      product: Product,
      schema: string,
      language: Language,
      tenant: string,
      landscape: string,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type MenuIndexWithoutIndexTargetQueryVariables = {
  index?: string | null,
  productSchemaLanguageTenantLandscape?: ModelMenuIndexIndexIndexCompositeKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelMenuIndexFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type MenuIndexWithoutIndexTargetQuery = {
  menuIndexWithoutIndexTarget?:  {
    __typename: "ModelMenuIndexConnection",
    items?:  Array< {
      __typename: "MenuIndex",
      index: string,
      menuId: string,
      product: Product,
      schema: string,
      language: Language,
      tenant: string,
      landscape: string,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type CognitoInfoByUserPoolIdQueryVariables = {
  userPoolId?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelCognitoInfoFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type CognitoInfoByUserPoolIdQuery = {
  cognitoInfoByUserPoolId?:  {
    __typename: "ModelCognitoInfoConnection",
    items?:  Array< {
      __typename: "CognitoInfo",
      tenant: string,
      landscape: string,
      identityPoolId: string,
      region: string,
      userPoolId: string,
      userPoolWebClientId: string,
      identityProvider: string,
      amazonCognitoDomain: string,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type VersionBytenantLandscapeAndApplyDateTimeQueryVariables = {
  tenantLandscape?: string | null,
  applyDateTime?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelCustomerCompanyVersionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type VersionBytenantLandscapeAndApplyDateTimeQuery = {
  versionBytenantLandscapeAndApplyDateTime?:  {
    __typename: "ModelCustomerCompanyVersionConnection",
    items?:  Array< {
      __typename: "CustomerCompanyVersion",
      id: string,
      tenant: string,
      landscape: string,
      tenantLandscape: string,
      version: string,
      product: string,
      applyDateTime: string,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type TaskMetadatasByVersionQueryVariables = {
  version?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelTaskMetadataFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type TaskMetadatasByVersionQuery = {
  taskMetadatasByVersion?:  {
    __typename: "ModelTaskMetadataConnection",
    items?:  Array< {
      __typename: "TaskMetadata",
      version: string,
      product: string,
      batch: string,
      batchName: string,
      versionProductBatch: string,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type JobsByTenantLandscapeQueryVariables = {
  tenantLandscape?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelJobFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type JobsByTenantLandscapeQuery = {
  jobsByTenantLandscape?:  {
    __typename: "ModelJobConnection",
    items?:  Array< {
      __typename: "Job",
      id: string,
      tenant: string,
      landscape: string,
      tenantLandscape: string,
      jobCode: string,
      title: string,
      description?: string | null,
      jobTriggerFilePath?: string | null,
      hasOutputFile: _Boolean,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type JobsByTenantLandscapeAndIdQueryVariables = {
  tenantLandscape?: string | null,
  id?: ModelIDKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelJobFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type JobsByTenantLandscapeAndIdQuery = {
  jobsByTenantLandscapeAndId?:  {
    __typename: "ModelJobConnection",
    items?:  Array< {
      __typename: "Job",
      id: string,
      tenant: string,
      landscape: string,
      tenantLandscape: string,
      jobCode: string,
      title: string,
      description?: string | null,
      jobTriggerFilePath?: string | null,
      hasOutputFile: _Boolean,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type TasksByJobIdQueryVariables = {
  jobId?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelTaskFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type TasksByJobIdQuery = {
  tasksByJobId?:  {
    __typename: "ModelTaskConnection",
    items?:  Array< {
      __typename: "Task",
      version: string,
      product: string,
      batch: string,
      batchName: string,
      versionProductBatch: string,
      jobId: string,
      order: number,
      jobIdOrder: string,
      title: string,
      includeInDownload?: _Boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type ScheduledEventMetadatasByTenantLandscapeQueryVariables = {
  tenantLandscape?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelScheduledEventMetadataFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ScheduledEventMetadatasByTenantLandscapeQuery = {
  scheduledEventMetadatasByTenantLandscape?:  {
    __typename: "ModelScheduledEventMetadataConnection",
    items?:  Array< {
      __typename: "ScheduledEventMetadata",
      id: string,
      tenant: string,
      landscape: string,
      tenantLandscape: string,
      title: string,
      description?: string | null,
      jobId: string,
      repeatType: RepeatType,
      rruleSet: string,
      holidayExecutionType: HolidayExecutionType,
      useCustomHoliday: _Boolean,
      customHolidayLabels?: Array< string > | null,
      eventTriggerType: EventTriggerType,
      createdBy: string,
      updatedBy: string,
      editedAt?: string | null,
      expirationDate?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type ScheduledEventMetadataByTenantLandscapeAndIdQueryVariables = {
  tenantLandscape?: string | null,
  id?: ModelIDKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelScheduledEventMetadataFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ScheduledEventMetadataByTenantLandscapeAndIdQuery = {
  scheduledEventMetadataByTenantLandscapeAndId?:  {
    __typename: "ModelScheduledEventMetadataConnection",
    items?:  Array< {
      __typename: "ScheduledEventMetadata",
      id: string,
      tenant: string,
      landscape: string,
      tenantLandscape: string,
      title: string,
      description?: string | null,
      jobId: string,
      repeatType: RepeatType,
      rruleSet: string,
      holidayExecutionType: HolidayExecutionType,
      useCustomHoliday: _Boolean,
      customHolidayLabels?: Array< string > | null,
      eventTriggerType: EventTriggerType,
      createdBy: string,
      updatedBy: string,
      editedAt?: string | null,
      expirationDate?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type ScheduledEventMetadatasByTenantLandscapeAndEventTriggerTypeQueryVariables = {
  tenantLandscape?: string | null,
  eventTriggerType?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelScheduledEventMetadataFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ScheduledEventMetadatasByTenantLandscapeAndEventTriggerTypeQuery = {
  scheduledEventMetadatasByTenantLandscapeAndEventTriggerType?:  {
    __typename: "ModelScheduledEventMetadataConnection",
    items?:  Array< {
      __typename: "ScheduledEventMetadata",
      id: string,
      tenant: string,
      landscape: string,
      tenantLandscape: string,
      title: string,
      description?: string | null,
      jobId: string,
      repeatType: RepeatType,
      rruleSet: string,
      holidayExecutionType: HolidayExecutionType,
      useCustomHoliday: _Boolean,
      customHolidayLabels?: Array< string > | null,
      eventTriggerType: EventTriggerType,
      createdBy: string,
      updatedBy: string,
      editedAt?: string | null,
      expirationDate?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type ScheduledEventMetadatasByCreatedByTenantAndLandscapeQueryVariables = {
  createdBy?: string | null,
  tenantLandscape?: ModelScheduledEventMetadataCreatedByTenantAndLandscapeIndexCompositeKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelScheduledEventMetadataFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ScheduledEventMetadatasByCreatedByTenantAndLandscapeQuery = {
  scheduledEventMetadatasByCreatedByTenantAndLandscape?:  {
    __typename: "ModelScheduledEventMetadataConnection",
    items?:  Array< {
      __typename: "ScheduledEventMetadata",
      id: string,
      tenant: string,
      landscape: string,
      tenantLandscape: string,
      title: string,
      description?: string | null,
      jobId: string,
      repeatType: RepeatType,
      rruleSet: string,
      holidayExecutionType: HolidayExecutionType,
      useCustomHoliday: _Boolean,
      customHolidayLabels?: Array< string > | null,
      eventTriggerType: EventTriggerType,
      createdBy: string,
      updatedBy: string,
      editedAt?: string | null,
      expirationDate?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type ScheduledEventMetadatasByUpdatedByTenantAndLandscapeQueryVariables = {
  updatedBy?: string | null,
  tenantLandscape?: ModelScheduledEventMetadataUpdatedByTenantAndLandscapeIndexCompositeKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelScheduledEventMetadataFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ScheduledEventMetadatasByUpdatedByTenantAndLandscapeQuery = {
  scheduledEventMetadatasByUpdatedByTenantAndLandscape?:  {
    __typename: "ModelScheduledEventMetadataConnection",
    items?:  Array< {
      __typename: "ScheduledEventMetadata",
      id: string,
      tenant: string,
      landscape: string,
      tenantLandscape: string,
      title: string,
      description?: string | null,
      jobId: string,
      repeatType: RepeatType,
      rruleSet: string,
      holidayExecutionType: HolidayExecutionType,
      useCustomHoliday: _Boolean,
      customHolidayLabels?: Array< string > | null,
      eventTriggerType: EventTriggerType,
      createdBy: string,
      updatedBy: string,
      editedAt?: string | null,
      expirationDate?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type ScheduledEventHistoriesByTenantLandscapeAndEventStartDateTimeQueryVariables = {
  tenantLandscape?: string | null,
  eventStartDateTime?: ModelFloatKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelScheduledEventHistoryFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ScheduledEventHistoriesByTenantLandscapeAndEventStartDateTimeQuery = {
  scheduledEventHistoriesByTenantLandscapeAndEventStartDateTime?:  {
    __typename: "ModelScheduledEventHistoryConnection",
    items?:  Array< {
      __typename: "ScheduledEventHistory",
      id: string,
      tenant: string,
      landscape: string,
      tenantLandscape: string,
      title: string,
      description?: string | null,
      scheduledEventMetadataId: string,
      eventStartDateTime: number,
      jobId: string,
      jobExecutionStatus: JobExecutionStatus,
      executedBy: string,
      executionArn?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type ScheduledEventHistoriesByTenantLandscapeAndIdQueryVariables = {
  tenantLandscape?: string | null,
  id?: ModelIDKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelScheduledEventHistoryFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ScheduledEventHistoriesByTenantLandscapeAndIdQuery = {
  scheduledEventHistoriesByTenantLandscapeAndId?:  {
    __typename: "ModelScheduledEventHistoryConnection",
    items?:  Array< {
      __typename: "ScheduledEventHistory",
      id: string,
      tenant: string,
      landscape: string,
      tenantLandscape: string,
      title: string,
      description?: string | null,
      scheduledEventMetadataId: string,
      eventStartDateTime: number,
      jobId: string,
      jobExecutionStatus: JobExecutionStatus,
      executedBy: string,
      executionArn?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type ScheduledEventHistoriesByExecutedByTenantAndLandscapeQueryVariables = {
  executedBy?: string | null,
  tenantLandscape?: ModelScheduledEventHistoryExecutedByTenantAndLandscapeIndexCompositeKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelScheduledEventHistoryFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ScheduledEventHistoriesByExecutedByTenantAndLandscapeQuery = {
  scheduledEventHistoriesByExecutedByTenantAndLandscape?:  {
    __typename: "ModelScheduledEventHistoryConnection",
    items?:  Array< {
      __typename: "ScheduledEventHistory",
      id: string,
      tenant: string,
      landscape: string,
      tenantLandscape: string,
      title: string,
      description?: string | null,
      scheduledEventMetadataId: string,
      eventStartDateTime: number,
      jobId: string,
      jobExecutionStatus: JobExecutionStatus,
      executedBy: string,
      executionArn?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type ScheduledHolidayMetadatasByTenantLandscapeQueryVariables = {
  tenantLandscape?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelScheduledHolidayMetadataFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ScheduledHolidayMetadatasByTenantLandscapeQuery = {
  scheduledHolidayMetadatasByTenantLandscape?:  {
    __typename: "ModelScheduledHolidayMetadataConnection",
    items?:  Array< {
      __typename: "ScheduledHolidayMetadata",
      id: string,
      tenant: string,
      landscape: string,
      tenantLandscape: string,
      title: string,
      description?: string | null,
      repeatType: RepeatType,
      rruleSet: string,
      labels: Array< string >,
      createdBy: string,
      updatedBy: string,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type ScheduledHolidayMetadataByTenantLandscapeAndIdQueryVariables = {
  tenantLandscape?: string | null,
  id?: ModelIDKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelScheduledHolidayMetadataFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ScheduledHolidayMetadataByTenantLandscapeAndIdQuery = {
  scheduledHolidayMetadataByTenantLandscapeAndId?:  {
    __typename: "ModelScheduledHolidayMetadataConnection",
    items?:  Array< {
      __typename: "ScheduledHolidayMetadata",
      id: string,
      tenant: string,
      landscape: string,
      tenantLandscape: string,
      title: string,
      description?: string | null,
      repeatType: RepeatType,
      rruleSet: string,
      labels: Array< string >,
      createdBy: string,
      updatedBy: string,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type ScheduledHolidayMetadatasByCreatedByTenantAndLandscapeQueryVariables = {
  createdBy?: string | null,
  tenantLandscape?: ModelScheduledHolidayMetadataCreatedByTenantAndLandscapeIndexCompositeKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelScheduledHolidayMetadataFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ScheduledHolidayMetadatasByCreatedByTenantAndLandscapeQuery = {
  scheduledHolidayMetadatasByCreatedByTenantAndLandscape?:  {
    __typename: "ModelScheduledHolidayMetadataConnection",
    items?:  Array< {
      __typename: "ScheduledHolidayMetadata",
      id: string,
      tenant: string,
      landscape: string,
      tenantLandscape: string,
      title: string,
      description?: string | null,
      repeatType: RepeatType,
      rruleSet: string,
      labels: Array< string >,
      createdBy: string,
      updatedBy: string,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type ScheduledHolidayMetadatasByUpdatedByTenantAndLandscapeQueryVariables = {
  updatedBy?: string | null,
  tenantLandscape?: ModelScheduledHolidayMetadataUpdatedByTenantAndLandscapeIndexCompositeKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelScheduledHolidayMetadataFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ScheduledHolidayMetadatasByUpdatedByTenantAndLandscapeQuery = {
  scheduledHolidayMetadatasByUpdatedByTenantAndLandscape?:  {
    __typename: "ModelScheduledHolidayMetadataConnection",
    items?:  Array< {
      __typename: "ScheduledHolidayMetadata",
      id: string,
      tenant: string,
      landscape: string,
      tenantLandscape: string,
      title: string,
      description?: string | null,
      repeatType: RepeatType,
      rruleSet: string,
      labels: Array< string >,
      createdBy: string,
      updatedBy: string,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type PublicHolidaysByLanguageQueryVariables = {
  language?: Language | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPublicHolidayFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type PublicHolidaysByLanguageQuery = {
  publicHolidaysByLanguage?:  {
    __typename: "ModelPublicHolidayConnection",
    items?:  Array< {
      __typename: "PublicHoliday",
      startDate: string,
      language: Language,
      title: string,
      label: string,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type RoleByTenantLandscapeQueryVariables = {
  tenant?: string | null,
  landscape?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelRoleFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type RoleByTenantLandscapeQuery = {
  roleByTenantLandscape?:  {
    __typename: "ModelRoleConnection",
    items?:  Array< {
      __typename: "Role",
      id: string,
      name: string,
      description?: string | null,
      isDefault: boolean,
      systemType: SystemType,
      tenant: string,
      landscape: string,
      permissions: string,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type OnCreateEventSubscriptionVariables = {
};

export type OnCreateEventSubscription = {
  onCreateEvent?:  {
    __typename: "Event",
    html?: string | null,
    loginName: string,
    tenant: string,
    landscape: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateEventSubscriptionVariables = {
};

export type OnUpdateEventSubscription = {
  onUpdateEvent?:  {
    __typename: "Event",
    html?: string | null,
    loginName: string,
    tenant: string,
    landscape: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteEventSubscriptionVariables = {
};

export type OnDeleteEventSubscription = {
  onDeleteEvent?:  {
    __typename: "Event",
    html?: string | null,
    loginName: string,
    tenant: string,
    landscape: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateLinkSubscriptionVariables = {
};

export type OnCreateLinkSubscription = {
  onCreateLink?:  {
    __typename: "Link",
    id: string,
    menuDescriptions?:  {
      __typename: "ModelLinkMenuDescriptionConnection",
      nextToken?: string | null,
    } | null,
    url: string,
    tenant: string,
    landscape: string,
    sort: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateLinkSubscriptionVariables = {
};

export type OnUpdateLinkSubscription = {
  onUpdateLink?:  {
    __typename: "Link",
    id: string,
    menuDescriptions?:  {
      __typename: "ModelLinkMenuDescriptionConnection",
      nextToken?: string | null,
    } | null,
    url: string,
    tenant: string,
    landscape: string,
    sort: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteLinkSubscriptionVariables = {
};

export type OnDeleteLinkSubscription = {
  onDeleteLink?:  {
    __typename: "Link",
    id: string,
    menuDescriptions?:  {
      __typename: "ModelLinkMenuDescriptionConnection",
      nextToken?: string | null,
    } | null,
    url: string,
    tenant: string,
    landscape: string,
    sort: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateMenuSubscriptionVariables = {
};

export type OnCreateMenuSubscription = {
  onCreateMenu?:  {
    __typename: "Menu",
    menuId: string,
    parentMenuId: string,
    menuNames?:  {
      __typename: "ModelMenuNameConnection",
      nextToken?: string | null,
    } | null,
    menuDescriptions?:  {
      __typename: "ModelMenuDescriptionConnection",
      nextToken?: string | null,
    } | null,
    url?: string | null,
    isCategory: _Boolean,
    product: Product,
    schemaId: string,
    loginName: string,
    tenant: string,
    landscape: string,
    tenantLandscapeLoginName: string,
    accessedTimeStamp?: number | null,
    sort: number,
    canUseFromExtra: _Boolean,
    menuIconFont?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateMenuSubscriptionVariables = {
};

export type OnUpdateMenuSubscription = {
  onUpdateMenu?:  {
    __typename: "Menu",
    menuId: string,
    parentMenuId: string,
    menuNames?:  {
      __typename: "ModelMenuNameConnection",
      nextToken?: string | null,
    } | null,
    menuDescriptions?:  {
      __typename: "ModelMenuDescriptionConnection",
      nextToken?: string | null,
    } | null,
    url?: string | null,
    isCategory: _Boolean,
    product: Product,
    schemaId: string,
    loginName: string,
    tenant: string,
    landscape: string,
    tenantLandscapeLoginName: string,
    accessedTimeStamp?: number | null,
    sort: number,
    canUseFromExtra: _Boolean,
    menuIconFont?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteMenuSubscriptionVariables = {
};

export type OnDeleteMenuSubscription = {
  onDeleteMenu?:  {
    __typename: "Menu",
    menuId: string,
    parentMenuId: string,
    menuNames?:  {
      __typename: "ModelMenuNameConnection",
      nextToken?: string | null,
    } | null,
    menuDescriptions?:  {
      __typename: "ModelMenuDescriptionConnection",
      nextToken?: string | null,
    } | null,
    url?: string | null,
    isCategory: _Boolean,
    product: Product,
    schemaId: string,
    loginName: string,
    tenant: string,
    landscape: string,
    tenantLandscapeLoginName: string,
    accessedTimeStamp?: number | null,
    sort: number,
    canUseFromExtra: _Boolean,
    menuIconFont?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateMenuDescriptionSubscriptionVariables = {
};

export type OnCreateMenuDescriptionSubscription = {
  onCreateMenuDescription?:  {
    __typename: "MenuDescription",
    language: Language,
    description?: string | null,
    menuId: string,
    schemaId: string,
    tenant: string,
    landscape: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateMenuDescriptionSubscriptionVariables = {
};

export type OnUpdateMenuDescriptionSubscription = {
  onUpdateMenuDescription?:  {
    __typename: "MenuDescription",
    language: Language,
    description?: string | null,
    menuId: string,
    schemaId: string,
    tenant: string,
    landscape: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteMenuDescriptionSubscriptionVariables = {
};

export type OnDeleteMenuDescriptionSubscription = {
  onDeleteMenuDescription?:  {
    __typename: "MenuDescription",
    language: Language,
    description?: string | null,
    menuId: string,
    schemaId: string,
    tenant: string,
    landscape: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateLinkMenuDescriptionSubscriptionVariables = {
};

export type OnCreateLinkMenuDescriptionSubscription = {
  onCreateLinkMenuDescription?:  {
    __typename: "LinkMenuDescription",
    language: Language,
    description: string,
    menuId: string,
    tenant: string,
    landscape: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateLinkMenuDescriptionSubscriptionVariables = {
};

export type OnUpdateLinkMenuDescriptionSubscription = {
  onUpdateLinkMenuDescription?:  {
    __typename: "LinkMenuDescription",
    language: Language,
    description: string,
    menuId: string,
    tenant: string,
    landscape: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteLinkMenuDescriptionSubscriptionVariables = {
};

export type OnDeleteLinkMenuDescriptionSubscription = {
  onDeleteLinkMenuDescription?:  {
    __typename: "LinkMenuDescription",
    language: Language,
    description: string,
    menuId: string,
    tenant: string,
    landscape: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateMenuNameSubscriptionVariables = {
};

export type OnCreateMenuNameSubscription = {
  onCreateMenuName?:  {
    __typename: "MenuName",
    language: Language,
    name?: string | null,
    menuId: string,
    schemaId: string,
    tenant: string,
    landscape: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateMenuNameSubscriptionVariables = {
};

export type OnUpdateMenuNameSubscription = {
  onUpdateMenuName?:  {
    __typename: "MenuName",
    language: Language,
    name?: string | null,
    menuId: string,
    schemaId: string,
    tenant: string,
    landscape: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteMenuNameSubscriptionVariables = {
};

export type OnDeleteMenuNameSubscription = {
  onDeleteMenuName?:  {
    __typename: "MenuName",
    language: Language,
    name?: string | null,
    menuId: string,
    schemaId: string,
    tenant: string,
    landscape: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateProductMenuNameSubscriptionVariables = {
};

export type OnCreateProductMenuNameSubscription = {
  onCreateProductMenuName?:  {
    __typename: "ProductMenuName",
    language: Language,
    name: string,
    menuId: string,
    loginName: string,
    tenant: string,
    landscape: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateProductMenuNameSubscriptionVariables = {
};

export type OnUpdateProductMenuNameSubscription = {
  onUpdateProductMenuName?:  {
    __typename: "ProductMenuName",
    language: Language,
    name: string,
    menuId: string,
    loginName: string,
    tenant: string,
    landscape: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteProductMenuNameSubscriptionVariables = {
};

export type OnDeleteProductMenuNameSubscription = {
  onDeleteProductMenuName?:  {
    __typename: "ProductMenuName",
    language: Language,
    name: string,
    menuId: string,
    loginName: string,
    tenant: string,
    landscape: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateNoticeSubscriptionVariables = {
};

export type OnCreateNoticeSubscription = {
  onCreateNotice?:  {
    __typename: "Notice",
    html?: string | null,
    loginName: string,
    tenant: string,
    landscape: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateNoticeSubscriptionVariables = {
};

export type OnUpdateNoticeSubscription = {
  onUpdateNotice?:  {
    __typename: "Notice",
    html?: string | null,
    loginName: string,
    tenant: string,
    landscape: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteNoticeSubscriptionVariables = {
};

export type OnDeleteNoticeSubscription = {
  onDeleteNotice?:  {
    __typename: "Notice",
    html?: string | null,
    loginName: string,
    tenant: string,
    landscape: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateFlagSubscriptionVariables = {
};

export type OnCreateFlagSubscription = {
  onCreateFlag?:  {
    __typename: "Flag",
    flag: Target,
    loginName: string,
    tenant: string,
    landscape: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateFlagSubscriptionVariables = {
};

export type OnUpdateFlagSubscription = {
  onUpdateFlag?:  {
    __typename: "Flag",
    flag: Target,
    loginName: string,
    tenant: string,
    landscape: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteFlagSubscriptionVariables = {
};

export type OnDeleteFlagSubscription = {
  onDeleteFlag?:  {
    __typename: "Flag",
    flag: Target,
    loginName: string,
    tenant: string,
    landscape: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateUserSubscriptionVariables = {
};

export type OnCreateUserSubscription = {
  onCreateUser?:  {
    __typename: "User",
    loginName: string,
    tenant: string,
    landscape: string,
    displaysFavoritePanel: _Boolean,
    isAdmin: _Boolean,
    language: Language,
    name?: string | null,
    affiliation?: string | null,
    csrSchema?: string | null,
    cwsSchema?: string | null,
    cjkSchema?: string | null,
    ctmSchema?: string | null,
    event?:  {
      __typename: "Event",
      html?: string | null,
      loginName: string,
      tenant: string,
      landscape: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    notice?:  {
      __typename: "Notice",
      html?: string | null,
      loginName: string,
      tenant: string,
      landscape: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    menus?:  {
      __typename: "ModelMenuConnection",
      nextToken?: string | null,
    } | null,
    productMenus?:  {
      __typename: "ModelProductMenuConnection",
      nextToken?: string | null,
    } | null,
    flags?:  {
      __typename: "ModelFlagConnection",
      nextToken?: string | null,
    } | null,
    favorites?:  {
      __typename: "ModelFavoriteConnection",
      nextToken?: string | null,
    } | null,
    notifications?:  {
      __typename: "ModelNotificationConnection",
      nextToken?: string | null,
    } | null,
    announcements?:  {
      __typename: "ModelUserAnnouncementConnection",
      nextToken?: string | null,
    } | null,
    scheduledEventMetadatasByCreatedBy?:  {
      __typename: "ModelScheduledEventMetadataConnection",
      nextToken?: string | null,
    } | null,
    scheduledEventMetadatasByUpdatedBy?:  {
      __typename: "ModelScheduledEventMetadataConnection",
      nextToken?: string | null,
    } | null,
    scheduledEventHistoriesByExecutedBy?:  {
      __typename: "ModelScheduledEventHistoryConnection",
      nextToken?: string | null,
    } | null,
    scheduledHolidayMetadatasByCreatedBy?:  {
      __typename: "ModelScheduledHolidayMetadataConnection",
      nextToken?: string | null,
    } | null,
    scheduledHolidayMetadatasByUpdatedBy?:  {
      __typename: "ModelScheduledHolidayMetadataConnection",
      nextToken?: string | null,
    } | null,
    productMenuNames?:  {
      __typename: "ModelProductMenuNameConnection",
      nextToken?: string | null,
    } | null,
    countTables?:  {
      __typename: "ModelCountTableConnection",
      nextToken?: string | null,
    } | null,
    roleId?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateUserSubscriptionVariables = {
};

export type OnUpdateUserSubscription = {
  onUpdateUser?:  {
    __typename: "User",
    loginName: string,
    tenant: string,
    landscape: string,
    displaysFavoritePanel: _Boolean,
    isAdmin: _Boolean,
    language: Language,
    name?: string | null,
    affiliation?: string | null,
    csrSchema?: string | null,
    cwsSchema?: string | null,
    cjkSchema?: string | null,
    ctmSchema?: string | null,
    event?:  {
      __typename: "Event",
      html?: string | null,
      loginName: string,
      tenant: string,
      landscape: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    notice?:  {
      __typename: "Notice",
      html?: string | null,
      loginName: string,
      tenant: string,
      landscape: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    menus?:  {
      __typename: "ModelMenuConnection",
      nextToken?: string | null,
    } | null,
    productMenus?:  {
      __typename: "ModelProductMenuConnection",
      nextToken?: string | null,
    } | null,
    flags?:  {
      __typename: "ModelFlagConnection",
      nextToken?: string | null,
    } | null,
    favorites?:  {
      __typename: "ModelFavoriteConnection",
      nextToken?: string | null,
    } | null,
    notifications?:  {
      __typename: "ModelNotificationConnection",
      nextToken?: string | null,
    } | null,
    announcements?:  {
      __typename: "ModelUserAnnouncementConnection",
      nextToken?: string | null,
    } | null,
    scheduledEventMetadatasByCreatedBy?:  {
      __typename: "ModelScheduledEventMetadataConnection",
      nextToken?: string | null,
    } | null,
    scheduledEventMetadatasByUpdatedBy?:  {
      __typename: "ModelScheduledEventMetadataConnection",
      nextToken?: string | null,
    } | null,
    scheduledEventHistoriesByExecutedBy?:  {
      __typename: "ModelScheduledEventHistoryConnection",
      nextToken?: string | null,
    } | null,
    scheduledHolidayMetadatasByCreatedBy?:  {
      __typename: "ModelScheduledHolidayMetadataConnection",
      nextToken?: string | null,
    } | null,
    scheduledHolidayMetadatasByUpdatedBy?:  {
      __typename: "ModelScheduledHolidayMetadataConnection",
      nextToken?: string | null,
    } | null,
    productMenuNames?:  {
      __typename: "ModelProductMenuNameConnection",
      nextToken?: string | null,
    } | null,
    countTables?:  {
      __typename: "ModelCountTableConnection",
      nextToken?: string | null,
    } | null,
    roleId?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteUserSubscriptionVariables = {
};

export type OnDeleteUserSubscription = {
  onDeleteUser?:  {
    __typename: "User",
    loginName: string,
    tenant: string,
    landscape: string,
    displaysFavoritePanel: _Boolean,
    isAdmin: _Boolean,
    language: Language,
    name?: string | null,
    affiliation?: string | null,
    csrSchema?: string | null,
    cwsSchema?: string | null,
    cjkSchema?: string | null,
    ctmSchema?: string | null,
    event?:  {
      __typename: "Event",
      html?: string | null,
      loginName: string,
      tenant: string,
      landscape: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    notice?:  {
      __typename: "Notice",
      html?: string | null,
      loginName: string,
      tenant: string,
      landscape: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    menus?:  {
      __typename: "ModelMenuConnection",
      nextToken?: string | null,
    } | null,
    productMenus?:  {
      __typename: "ModelProductMenuConnection",
      nextToken?: string | null,
    } | null,
    flags?:  {
      __typename: "ModelFlagConnection",
      nextToken?: string | null,
    } | null,
    favorites?:  {
      __typename: "ModelFavoriteConnection",
      nextToken?: string | null,
    } | null,
    notifications?:  {
      __typename: "ModelNotificationConnection",
      nextToken?: string | null,
    } | null,
    announcements?:  {
      __typename: "ModelUserAnnouncementConnection",
      nextToken?: string | null,
    } | null,
    scheduledEventMetadatasByCreatedBy?:  {
      __typename: "ModelScheduledEventMetadataConnection",
      nextToken?: string | null,
    } | null,
    scheduledEventMetadatasByUpdatedBy?:  {
      __typename: "ModelScheduledEventMetadataConnection",
      nextToken?: string | null,
    } | null,
    scheduledEventHistoriesByExecutedBy?:  {
      __typename: "ModelScheduledEventHistoryConnection",
      nextToken?: string | null,
    } | null,
    scheduledHolidayMetadatasByCreatedBy?:  {
      __typename: "ModelScheduledHolidayMetadataConnection",
      nextToken?: string | null,
    } | null,
    scheduledHolidayMetadatasByUpdatedBy?:  {
      __typename: "ModelScheduledHolidayMetadataConnection",
      nextToken?: string | null,
    } | null,
    productMenuNames?:  {
      __typename: "ModelProductMenuNameConnection",
      nextToken?: string | null,
    } | null,
    countTables?:  {
      __typename: "ModelCountTableConnection",
      nextToken?: string | null,
    } | null,
    roleId?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateNotificationOnLoginNameSubscriptionVariables = {
  loginName: string,
  tenant: string,
  landscape: string,
};

export type OnCreateNotificationOnLoginNameSubscription = {
  onCreateNotificationOnLoginName?:  {
    __typename: "Notification",
    loginName: string,
    tenant: string,
    landscape: string,
    tenantLandscapeLoginName: string,
    product: Product,
    notificationId: string,
    content: string,
    iconType?: string | null,
    onClickAction: string,
    extraActions?:  Array< {
      __typename: "NotificationActions",
      actionName: string,
      onClickAction: string,
    } > | null,
    displayStartDate: number,
    displayEndDate?: number | null,
    isRead: _Boolean,
    isFinished: _Boolean,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateCountTableSubscriptionVariables = {
};

export type OnCreateCountTableSubscription = {
  onCreateCountTable?:  {
    __typename: "CountTable",
    loginName: string,
    tenant: string,
    landscape: string,
    tableName: TableName,
    totalCount: number,
    isUnRead?: number | null,
    isExpired?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateCountTableSubscriptionVariables = {
};

export type OnUpdateCountTableSubscription = {
  onUpdateCountTable?:  {
    __typename: "CountTable",
    loginName: string,
    tenant: string,
    landscape: string,
    tableName: TableName,
    totalCount: number,
    isUnRead?: number | null,
    isExpired?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteCountTableSubscriptionVariables = {
};

export type OnDeleteCountTableSubscription = {
  onDeleteCountTable?:  {
    __typename: "CountTable",
    loginName: string,
    tenant: string,
    landscape: string,
    tableName: TableName,
    totalCount: number,
    isUnRead?: number | null,
    isExpired?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateAnnouncementSubscriptionVariables = {
};

export type OnCreateAnnouncementSubscription = {
  onCreateAnnouncement?:  {
    __typename: "Announcement",
    id: string,
    tenant: string,
    landscape: string,
    tenantLandscape: string,
    users?:  {
      __typename: "ModelUserAnnouncementConnection",
      nextToken?: string | null,
    } | null,
    title: string,
    content: string,
    linkToProductMenu: string,
    isPublic: _Boolean,
    displayStartDate: number,
    displayEndDate?: number | null,
    priorityTag: PriorityTag,
    createdAt: string,
    updatedAt?: string | null,
  } | null,
};

export type OnUpdateAnnouncementSubscriptionVariables = {
};

export type OnUpdateAnnouncementSubscription = {
  onUpdateAnnouncement?:  {
    __typename: "Announcement",
    id: string,
    tenant: string,
    landscape: string,
    tenantLandscape: string,
    users?:  {
      __typename: "ModelUserAnnouncementConnection",
      nextToken?: string | null,
    } | null,
    title: string,
    content: string,
    linkToProductMenu: string,
    isPublic: _Boolean,
    displayStartDate: number,
    displayEndDate?: number | null,
    priorityTag: PriorityTag,
    createdAt: string,
    updatedAt?: string | null,
  } | null,
};

export type OnDeleteAnnouncementSubscriptionVariables = {
};

export type OnDeleteAnnouncementSubscription = {
  onDeleteAnnouncement?:  {
    __typename: "Announcement",
    id: string,
    tenant: string,
    landscape: string,
    tenantLandscape: string,
    users?:  {
      __typename: "ModelUserAnnouncementConnection",
      nextToken?: string | null,
    } | null,
    title: string,
    content: string,
    linkToProductMenu: string,
    isPublic: _Boolean,
    displayStartDate: number,
    displayEndDate?: number | null,
    priorityTag: PriorityTag,
    createdAt: string,
    updatedAt?: string | null,
  } | null,
};

export type OnCreateUserAnnouncementSubscriptionVariables = {
};

export type OnCreateUserAnnouncementSubscription = {
  onCreateUserAnnouncement?:  {
    __typename: "UserAnnouncement",
    announcementId: string,
    loginName: string,
    tenant: string,
    landscape: string,
    tenantLandscapeLoginName: string,
    announcement:  {
      __typename: "Announcement",
      id: string,
      tenant: string,
      landscape: string,
      tenantLandscape: string,
      title: string,
      content: string,
      linkToProductMenu: string,
      isPublic: _Boolean,
      displayStartDate: number,
      displayEndDate?: number | null,
      priorityTag: PriorityTag,
      createdAt: string,
      updatedAt?: string | null,
    },
    displayStartDate: number,
    displayEndDate?: number | null,
    isProcessed: _Boolean,
    isRead: _Boolean,
    isShow: _Boolean,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateUserAnnouncementSubscriptionVariables = {
};

export type OnUpdateUserAnnouncementSubscription = {
  onUpdateUserAnnouncement?:  {
    __typename: "UserAnnouncement",
    announcementId: string,
    loginName: string,
    tenant: string,
    landscape: string,
    tenantLandscapeLoginName: string,
    announcement:  {
      __typename: "Announcement",
      id: string,
      tenant: string,
      landscape: string,
      tenantLandscape: string,
      title: string,
      content: string,
      linkToProductMenu: string,
      isPublic: _Boolean,
      displayStartDate: number,
      displayEndDate?: number | null,
      priorityTag: PriorityTag,
      createdAt: string,
      updatedAt?: string | null,
    },
    displayStartDate: number,
    displayEndDate?: number | null,
    isProcessed: _Boolean,
    isRead: _Boolean,
    isShow: _Boolean,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteUserAnnouncementSubscriptionVariables = {
};

export type OnDeleteUserAnnouncementSubscription = {
  onDeleteUserAnnouncement?:  {
    __typename: "UserAnnouncement",
    announcementId: string,
    loginName: string,
    tenant: string,
    landscape: string,
    tenantLandscapeLoginName: string,
    announcement:  {
      __typename: "Announcement",
      id: string,
      tenant: string,
      landscape: string,
      tenantLandscape: string,
      title: string,
      content: string,
      linkToProductMenu: string,
      isPublic: _Boolean,
      displayStartDate: number,
      displayEndDate?: number | null,
      priorityTag: PriorityTag,
      createdAt: string,
      updatedAt?: string | null,
    },
    displayStartDate: number,
    displayEndDate?: number | null,
    isProcessed: _Boolean,
    isRead: _Boolean,
    isShow: _Boolean,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateFavoriteSubscriptionVariables = {
};

export type OnCreateFavoriteSubscription = {
  onCreateFavorite?:  {
    __typename: "Favorite",
    sort: number,
    menuId: string,
    loginName: string,
    tenant: string,
    landscape: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateFavoriteSubscriptionVariables = {
};

export type OnUpdateFavoriteSubscription = {
  onUpdateFavorite?:  {
    __typename: "Favorite",
    sort: number,
    menuId: string,
    loginName: string,
    tenant: string,
    landscape: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteFavoriteSubscriptionVariables = {
};

export type OnDeleteFavoriteSubscription = {
  onDeleteFavorite?:  {
    __typename: "Favorite",
    sort: number,
    menuId: string,
    loginName: string,
    tenant: string,
    landscape: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateMenuIndexSubscriptionVariables = {
};

export type OnCreateMenuIndexSubscription = {
  onCreateMenuIndex?:  {
    __typename: "MenuIndex",
    index: string,
    menuId: string,
    product: Product,
    schema: string,
    language: Language,
    tenant: string,
    landscape: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateMenuIndexSubscriptionVariables = {
};

export type OnUpdateMenuIndexSubscription = {
  onUpdateMenuIndex?:  {
    __typename: "MenuIndex",
    index: string,
    menuId: string,
    product: Product,
    schema: string,
    language: Language,
    tenant: string,
    landscape: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteMenuIndexSubscriptionVariables = {
};

export type OnDeleteMenuIndexSubscription = {
  onDeleteMenuIndex?:  {
    __typename: "MenuIndex",
    index: string,
    menuId: string,
    product: Product,
    schema: string,
    language: Language,
    tenant: string,
    landscape: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateProductMenuSubscriptionVariables = {
};

export type OnCreateProductMenuSubscription = {
  onCreateProductMenu?:  {
    __typename: "ProductMenu",
    loginName: string,
    tenant: string,
    landscape: string,
    menuId: string,
    menuNames?:  {
      __typename: "ModelProductMenuNameConnection",
      nextToken?: string | null,
    } | null,
    isHome: _Boolean,
    stateKey: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateProductMenuSubscriptionVariables = {
};

export type OnUpdateProductMenuSubscription = {
  onUpdateProductMenu?:  {
    __typename: "ProductMenu",
    loginName: string,
    tenant: string,
    landscape: string,
    menuId: string,
    menuNames?:  {
      __typename: "ModelProductMenuNameConnection",
      nextToken?: string | null,
    } | null,
    isHome: _Boolean,
    stateKey: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteProductMenuSubscriptionVariables = {
};

export type OnDeleteProductMenuSubscription = {
  onDeleteProductMenu?:  {
    __typename: "ProductMenu",
    loginName: string,
    tenant: string,
    landscape: string,
    menuId: string,
    menuNames?:  {
      __typename: "ModelProductMenuNameConnection",
      nextToken?: string | null,
    } | null,
    isHome: _Boolean,
    stateKey: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateGatewayServerSubscriptionVariables = {
};

export type OnCreateGatewayServerSubscription = {
  onCreateGatewayServer?:  {
    __typename: "GatewayServer",
    tenant: string,
    landscape: string,
    product: Product,
    useInternetAccess: _Boolean,
    isInternalGateWayServer: _Boolean,
    gatewayServerIps?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateGatewayServerSubscriptionVariables = {
};

export type OnUpdateGatewayServerSubscription = {
  onUpdateGatewayServer?:  {
    __typename: "GatewayServer",
    tenant: string,
    landscape: string,
    product: Product,
    useInternetAccess: _Boolean,
    isInternalGateWayServer: _Boolean,
    gatewayServerIps?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteGatewayServerSubscriptionVariables = {
};

export type OnDeleteGatewayServerSubscription = {
  onDeleteGatewayServer?:  {
    __typename: "GatewayServer",
    tenant: string,
    landscape: string,
    product: Product,
    useInternetAccess: _Boolean,
    isInternalGateWayServer: _Boolean,
    gatewayServerIps?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateCognitoInfoSubscriptionVariables = {
};

export type OnCreateCognitoInfoSubscription = {
  onCreateCognitoInfo?:  {
    __typename: "CognitoInfo",
    tenant: string,
    landscape: string,
    identityPoolId: string,
    region: string,
    userPoolId: string,
    userPoolWebClientId: string,
    identityProvider: string,
    amazonCognitoDomain: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateCognitoInfoSubscriptionVariables = {
};

export type OnUpdateCognitoInfoSubscription = {
  onUpdateCognitoInfo?:  {
    __typename: "CognitoInfo",
    tenant: string,
    landscape: string,
    identityPoolId: string,
    region: string,
    userPoolId: string,
    userPoolWebClientId: string,
    identityProvider: string,
    amazonCognitoDomain: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteCognitoInfoSubscriptionVariables = {
};

export type OnDeleteCognitoInfoSubscription = {
  onDeleteCognitoInfo?:  {
    __typename: "CognitoInfo",
    tenant: string,
    landscape: string,
    identityPoolId: string,
    region: string,
    userPoolId: string,
    userPoolWebClientId: string,
    identityProvider: string,
    amazonCognitoDomain: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateAPIGatewayInfoSubscriptionVariables = {
};

export type OnCreateAPIGatewayInfoSubscription = {
  onCreateAPIGatewayInfo?:  {
    __typename: "APIGatewayInfo",
    tenant: string,
    landscape: string,
    endpoint: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateAPIGatewayInfoSubscriptionVariables = {
};

export type OnUpdateAPIGatewayInfoSubscription = {
  onUpdateAPIGatewayInfo?:  {
    __typename: "APIGatewayInfo",
    tenant: string,
    landscape: string,
    endpoint: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteAPIGatewayInfoSubscriptionVariables = {
};

export type OnDeleteAPIGatewayInfoSubscription = {
  onDeleteAPIGatewayInfo?:  {
    __typename: "APIGatewayInfo",
    tenant: string,
    landscape: string,
    endpoint: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateBackendInfoSubscriptionVariables = {
};

export type OnCreateBackendInfoSubscription = {
  onCreateBackendInfo?:  {
    __typename: "BackendInfo",
    tenant: string,
    landscape: string,
    apiGatewayInfo?:  {
      __typename: "APIGatewayInfo",
      tenant: string,
      landscape: string,
      endpoint: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    cognitoInfo?:  {
      __typename: "CognitoInfo",
      tenant: string,
      landscape: string,
      identityPoolId: string,
      region: string,
      userPoolId: string,
      userPoolWebClientId: string,
      identityProvider: string,
      amazonCognitoDomain: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateBackendInfoSubscriptionVariables = {
};

export type OnUpdateBackendInfoSubscription = {
  onUpdateBackendInfo?:  {
    __typename: "BackendInfo",
    tenant: string,
    landscape: string,
    apiGatewayInfo?:  {
      __typename: "APIGatewayInfo",
      tenant: string,
      landscape: string,
      endpoint: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    cognitoInfo?:  {
      __typename: "CognitoInfo",
      tenant: string,
      landscape: string,
      identityPoolId: string,
      region: string,
      userPoolId: string,
      userPoolWebClientId: string,
      identityProvider: string,
      amazonCognitoDomain: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteBackendInfoSubscriptionVariables = {
};

export type OnDeleteBackendInfoSubscription = {
  onDeleteBackendInfo?:  {
    __typename: "BackendInfo",
    tenant: string,
    landscape: string,
    apiGatewayInfo?:  {
      __typename: "APIGatewayInfo",
      tenant: string,
      landscape: string,
      endpoint: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    cognitoInfo?:  {
      __typename: "CognitoInfo",
      tenant: string,
      landscape: string,
      identityPoolId: string,
      region: string,
      userPoolId: string,
      userPoolWebClientId: string,
      identityProvider: string,
      amazonCognitoDomain: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateAuthQuerySubscriptionVariables = {
};

export type OnCreateAuthQuerySubscription = {
  onCreateAuthQuery?:  {
    __typename: "AuthQuery",
    tenant: string,
    landscape: string,
    identityProvider: string,
    product: Product,
    additionalQuery: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateAuthQuerySubscriptionVariables = {
};

export type OnUpdateAuthQuerySubscription = {
  onUpdateAuthQuery?:  {
    __typename: "AuthQuery",
    tenant: string,
    landscape: string,
    identityProvider: string,
    product: Product,
    additionalQuery: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteAuthQuerySubscriptionVariables = {
};

export type OnDeleteAuthQuerySubscription = {
  onDeleteAuthQuery?:  {
    __typename: "AuthQuery",
    tenant: string,
    landscape: string,
    identityProvider: string,
    product: Product,
    additionalQuery: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateSystemSettingInfoSubscriptionVariables = {
};

export type OnCreateSystemSettingInfoSubscription = {
  onCreateSystemSettingInfo?:  {
    __typename: "SystemSettingInfo",
    tenant: string,
    landscape: string,
    isMultilanguageEnabled?: _Boolean | null,
    isNotificationEnabled?: _Boolean | null,
    isJobSchedulerEnabled?: _Boolean | null,
    isPortalEnabled?: _Boolean | null,
    announcementSetting?: AnnouncementSetting | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateSystemSettingInfoSubscriptionVariables = {
};

export type OnUpdateSystemSettingInfoSubscription = {
  onUpdateSystemSettingInfo?:  {
    __typename: "SystemSettingInfo",
    tenant: string,
    landscape: string,
    isMultilanguageEnabled?: _Boolean | null,
    isNotificationEnabled?: _Boolean | null,
    isJobSchedulerEnabled?: _Boolean | null,
    isPortalEnabled?: _Boolean | null,
    announcementSetting?: AnnouncementSetting | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteSystemSettingInfoSubscriptionVariables = {
};

export type OnDeleteSystemSettingInfoSubscription = {
  onDeleteSystemSettingInfo?:  {
    __typename: "SystemSettingInfo",
    tenant: string,
    landscape: string,
    isMultilanguageEnabled?: _Boolean | null,
    isNotificationEnabled?: _Boolean | null,
    isJobSchedulerEnabled?: _Boolean | null,
    isPortalEnabled?: _Boolean | null,
    announcementSetting?: AnnouncementSetting | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateCustomerCompanyVersionSubscriptionVariables = {
};

export type OnCreateCustomerCompanyVersionSubscription = {
  onCreateCustomerCompanyVersion?:  {
    __typename: "CustomerCompanyVersion",
    id: string,
    tenant: string,
    landscape: string,
    tenantLandscape: string,
    version: string,
    product: string,
    applyDateTime: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateCustomerCompanyVersionSubscriptionVariables = {
};

export type OnUpdateCustomerCompanyVersionSubscription = {
  onUpdateCustomerCompanyVersion?:  {
    __typename: "CustomerCompanyVersion",
    id: string,
    tenant: string,
    landscape: string,
    tenantLandscape: string,
    version: string,
    product: string,
    applyDateTime: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteCustomerCompanyVersionSubscriptionVariables = {
};

export type OnDeleteCustomerCompanyVersionSubscription = {
  onDeleteCustomerCompanyVersion?:  {
    __typename: "CustomerCompanyVersion",
    id: string,
    tenant: string,
    landscape: string,
    tenantLandscape: string,
    version: string,
    product: string,
    applyDateTime: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateTaskMetadataSubscriptionVariables = {
};

export type OnCreateTaskMetadataSubscription = {
  onCreateTaskMetadata?:  {
    __typename: "TaskMetadata",
    version: string,
    product: string,
    batch: string,
    batchName: string,
    versionProductBatch: string,
    args:  Array< {
      __typename: "TaskMetadataArgs",
      required: _Boolean,
      default?: string | null,
      display: _Boolean,
      order: number,
      option: string,
      type: TaskMetadataArgsType,
      delimiter?: string | null,
      isMultiple?: _Boolean | null,
      isOutputFile?: _Boolean | null,
      isInputFile?: _Boolean | null,
      isSecret?: _Boolean | null,
      sampleInput?: string | null,
      isResolvable?: _Boolean | null,
    } >,
    requestBodyPropertyTemplates?:  Array< {
      __typename: "RequestBodyPropertyTemplate",
      requestBodyProperty: string,
      template: string,
    } | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateTaskMetadataSubscriptionVariables = {
};

export type OnUpdateTaskMetadataSubscription = {
  onUpdateTaskMetadata?:  {
    __typename: "TaskMetadata",
    version: string,
    product: string,
    batch: string,
    batchName: string,
    versionProductBatch: string,
    args:  Array< {
      __typename: "TaskMetadataArgs",
      required: _Boolean,
      default?: string | null,
      display: _Boolean,
      order: number,
      option: string,
      type: TaskMetadataArgsType,
      delimiter?: string | null,
      isMultiple?: _Boolean | null,
      isOutputFile?: _Boolean | null,
      isInputFile?: _Boolean | null,
      isSecret?: _Boolean | null,
      sampleInput?: string | null,
      isResolvable?: _Boolean | null,
    } >,
    requestBodyPropertyTemplates?:  Array< {
      __typename: "RequestBodyPropertyTemplate",
      requestBodyProperty: string,
      template: string,
    } | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteTaskMetadataSubscriptionVariables = {
};

export type OnDeleteTaskMetadataSubscription = {
  onDeleteTaskMetadata?:  {
    __typename: "TaskMetadata",
    version: string,
    product: string,
    batch: string,
    batchName: string,
    versionProductBatch: string,
    args:  Array< {
      __typename: "TaskMetadataArgs",
      required: _Boolean,
      default?: string | null,
      display: _Boolean,
      order: number,
      option: string,
      type: TaskMetadataArgsType,
      delimiter?: string | null,
      isMultiple?: _Boolean | null,
      isOutputFile?: _Boolean | null,
      isInputFile?: _Boolean | null,
      isSecret?: _Boolean | null,
      sampleInput?: string | null,
      isResolvable?: _Boolean | null,
    } >,
    requestBodyPropertyTemplates?:  Array< {
      __typename: "RequestBodyPropertyTemplate",
      requestBodyProperty: string,
      template: string,
    } | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateTenantUsingMoveFileTaskSubscriptionVariables = {
};

export type OnCreateTenantUsingMoveFileTaskSubscription = {
  onCreateTenantUsingMoveFileTask?:  {
    __typename: "TenantUsingMoveFileTask",
    tenant: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateTenantUsingMoveFileTaskSubscriptionVariables = {
};

export type OnUpdateTenantUsingMoveFileTaskSubscription = {
  onUpdateTenantUsingMoveFileTask?:  {
    __typename: "TenantUsingMoveFileTask",
    tenant: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteTenantUsingMoveFileTaskSubscriptionVariables = {
};

export type OnDeleteTenantUsingMoveFileTaskSubscription = {
  onDeleteTenantUsingMoveFileTask?:  {
    __typename: "TenantUsingMoveFileTask",
    tenant: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateJobSubscriptionVariables = {
};

export type OnCreateJobSubscription = {
  onCreateJob?:  {
    __typename: "Job",
    id: string,
    tenant: string,
    landscape: string,
    tenantLandscape: string,
    jobCode: string,
    title: string,
    description?: string | null,
    jobTriggerFilePath?: string | null,
    tasks?:  {
      __typename: "ModelTaskConnection",
      nextToken?: string | null,
    } | null,
    hasOutputFile: _Boolean,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateJobSubscriptionVariables = {
};

export type OnUpdateJobSubscription = {
  onUpdateJob?:  {
    __typename: "Job",
    id: string,
    tenant: string,
    landscape: string,
    tenantLandscape: string,
    jobCode: string,
    title: string,
    description?: string | null,
    jobTriggerFilePath?: string | null,
    tasks?:  {
      __typename: "ModelTaskConnection",
      nextToken?: string | null,
    } | null,
    hasOutputFile: _Boolean,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteJobSubscriptionVariables = {
};

export type OnDeleteJobSubscription = {
  onDeleteJob?:  {
    __typename: "Job",
    id: string,
    tenant: string,
    landscape: string,
    tenantLandscape: string,
    jobCode: string,
    title: string,
    description?: string | null,
    jobTriggerFilePath?: string | null,
    tasks?:  {
      __typename: "ModelTaskConnection",
      nextToken?: string | null,
    } | null,
    hasOutputFile: _Boolean,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateTaskSubscriptionVariables = {
};

export type OnCreateTaskSubscription = {
  onCreateTask?:  {
    __typename: "Task",
    version: string,
    product: string,
    batch: string,
    batchName: string,
    versionProductBatch: string,
    jobId: string,
    order: number,
    jobIdOrder: string,
    taskMetadata?:  {
      __typename: "TaskMetadata",
      version: string,
      product: string,
      batch: string,
      batchName: string,
      versionProductBatch: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    title: string,
    args:  Array< {
      __typename: "TaskArgs",
      order: number,
      option: string,
      value: string,
      replaceInFileName?: _Boolean | null,
    } >,
    includeInDownload?: _Boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateTaskSubscriptionVariables = {
};

export type OnUpdateTaskSubscription = {
  onUpdateTask?:  {
    __typename: "Task",
    version: string,
    product: string,
    batch: string,
    batchName: string,
    versionProductBatch: string,
    jobId: string,
    order: number,
    jobIdOrder: string,
    taskMetadata?:  {
      __typename: "TaskMetadata",
      version: string,
      product: string,
      batch: string,
      batchName: string,
      versionProductBatch: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    title: string,
    args:  Array< {
      __typename: "TaskArgs",
      order: number,
      option: string,
      value: string,
      replaceInFileName?: _Boolean | null,
    } >,
    includeInDownload?: _Boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteTaskSubscriptionVariables = {
};

export type OnDeleteTaskSubscription = {
  onDeleteTask?:  {
    __typename: "Task",
    version: string,
    product: string,
    batch: string,
    batchName: string,
    versionProductBatch: string,
    jobId: string,
    order: number,
    jobIdOrder: string,
    taskMetadata?:  {
      __typename: "TaskMetadata",
      version: string,
      product: string,
      batch: string,
      batchName: string,
      versionProductBatch: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    title: string,
    args:  Array< {
      __typename: "TaskArgs",
      order: number,
      option: string,
      value: string,
      replaceInFileName?: _Boolean | null,
    } >,
    includeInDownload?: _Boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateScheduledEventMetadataSubscriptionVariables = {
};

export type OnCreateScheduledEventMetadataSubscription = {
  onCreateScheduledEventMetadata?:  {
    __typename: "ScheduledEventMetadata",
    id: string,
    tenant: string,
    landscape: string,
    tenantLandscape: string,
    title: string,
    description?: string | null,
    jobId: string,
    job?:  {
      __typename: "Job",
      id: string,
      tenant: string,
      landscape: string,
      tenantLandscape: string,
      jobCode: string,
      title: string,
      description?: string | null,
      jobTriggerFilePath?: string | null,
      hasOutputFile: _Boolean,
      createdAt: string,
      updatedAt: string,
    } | null,
    repeatType: RepeatType,
    rruleSet: string,
    holidayExecutionType: HolidayExecutionType,
    useCustomHoliday: _Boolean,
    customHolidayLabels?: Array< string > | null,
    eventTriggerType: EventTriggerType,
    createdBy: string,
    updatedBy: string,
    editedAt?: string | null,
    expirationDate?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateScheduledEventMetadataSubscriptionVariables = {
};

export type OnUpdateScheduledEventMetadataSubscription = {
  onUpdateScheduledEventMetadata?:  {
    __typename: "ScheduledEventMetadata",
    id: string,
    tenant: string,
    landscape: string,
    tenantLandscape: string,
    title: string,
    description?: string | null,
    jobId: string,
    job?:  {
      __typename: "Job",
      id: string,
      tenant: string,
      landscape: string,
      tenantLandscape: string,
      jobCode: string,
      title: string,
      description?: string | null,
      jobTriggerFilePath?: string | null,
      hasOutputFile: _Boolean,
      createdAt: string,
      updatedAt: string,
    } | null,
    repeatType: RepeatType,
    rruleSet: string,
    holidayExecutionType: HolidayExecutionType,
    useCustomHoliday: _Boolean,
    customHolidayLabels?: Array< string > | null,
    eventTriggerType: EventTriggerType,
    createdBy: string,
    updatedBy: string,
    editedAt?: string | null,
    expirationDate?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteScheduledEventMetadataSubscriptionVariables = {
};

export type OnDeleteScheduledEventMetadataSubscription = {
  onDeleteScheduledEventMetadata?:  {
    __typename: "ScheduledEventMetadata",
    id: string,
    tenant: string,
    landscape: string,
    tenantLandscape: string,
    title: string,
    description?: string | null,
    jobId: string,
    job?:  {
      __typename: "Job",
      id: string,
      tenant: string,
      landscape: string,
      tenantLandscape: string,
      jobCode: string,
      title: string,
      description?: string | null,
      jobTriggerFilePath?: string | null,
      hasOutputFile: _Boolean,
      createdAt: string,
      updatedAt: string,
    } | null,
    repeatType: RepeatType,
    rruleSet: string,
    holidayExecutionType: HolidayExecutionType,
    useCustomHoliday: _Boolean,
    customHolidayLabels?: Array< string > | null,
    eventTriggerType: EventTriggerType,
    createdBy: string,
    updatedBy: string,
    editedAt?: string | null,
    expirationDate?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateScheduledEventHistorySubscriptionVariables = {
};

export type OnCreateScheduledEventHistorySubscription = {
  onCreateScheduledEventHistory?:  {
    __typename: "ScheduledEventHistory",
    id: string,
    tenant: string,
    landscape: string,
    tenantLandscape: string,
    title: string,
    description?: string | null,
    scheduledEventMetadataId: string,
    scheduledEventMetadata?:  {
      __typename: "ScheduledEventMetadata",
      id: string,
      tenant: string,
      landscape: string,
      tenantLandscape: string,
      title: string,
      description?: string | null,
      jobId: string,
      repeatType: RepeatType,
      rruleSet: string,
      holidayExecutionType: HolidayExecutionType,
      useCustomHoliday: _Boolean,
      customHolidayLabels?: Array< string > | null,
      eventTriggerType: EventTriggerType,
      createdBy: string,
      updatedBy: string,
      editedAt?: string | null,
      expirationDate?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    eventStartDateTime: number,
    jobId: string,
    job?:  {
      __typename: "Job",
      id: string,
      tenant: string,
      landscape: string,
      tenantLandscape: string,
      jobCode: string,
      title: string,
      description?: string | null,
      jobTriggerFilePath?: string | null,
      hasOutputFile: _Boolean,
      createdAt: string,
      updatedAt: string,
    } | null,
    jobExecutionStatus: JobExecutionStatus,
    tasks?:  {
      __typename: "ModelTaskConnection",
      nextToken?: string | null,
    } | null,
    taskHistories?:  {
      __typename: "ModelTaskHistoryConnection",
      nextToken?: string | null,
    } | null,
    executedBy: string,
    executionArn?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateScheduledEventHistorySubscriptionVariables = {
};

export type OnUpdateScheduledEventHistorySubscription = {
  onUpdateScheduledEventHistory?:  {
    __typename: "ScheduledEventHistory",
    id: string,
    tenant: string,
    landscape: string,
    tenantLandscape: string,
    title: string,
    description?: string | null,
    scheduledEventMetadataId: string,
    scheduledEventMetadata?:  {
      __typename: "ScheduledEventMetadata",
      id: string,
      tenant: string,
      landscape: string,
      tenantLandscape: string,
      title: string,
      description?: string | null,
      jobId: string,
      repeatType: RepeatType,
      rruleSet: string,
      holidayExecutionType: HolidayExecutionType,
      useCustomHoliday: _Boolean,
      customHolidayLabels?: Array< string > | null,
      eventTriggerType: EventTriggerType,
      createdBy: string,
      updatedBy: string,
      editedAt?: string | null,
      expirationDate?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    eventStartDateTime: number,
    jobId: string,
    job?:  {
      __typename: "Job",
      id: string,
      tenant: string,
      landscape: string,
      tenantLandscape: string,
      jobCode: string,
      title: string,
      description?: string | null,
      jobTriggerFilePath?: string | null,
      hasOutputFile: _Boolean,
      createdAt: string,
      updatedAt: string,
    } | null,
    jobExecutionStatus: JobExecutionStatus,
    tasks?:  {
      __typename: "ModelTaskConnection",
      nextToken?: string | null,
    } | null,
    taskHistories?:  {
      __typename: "ModelTaskHistoryConnection",
      nextToken?: string | null,
    } | null,
    executedBy: string,
    executionArn?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteScheduledEventHistorySubscriptionVariables = {
};

export type OnDeleteScheduledEventHistorySubscription = {
  onDeleteScheduledEventHistory?:  {
    __typename: "ScheduledEventHistory",
    id: string,
    tenant: string,
    landscape: string,
    tenantLandscape: string,
    title: string,
    description?: string | null,
    scheduledEventMetadataId: string,
    scheduledEventMetadata?:  {
      __typename: "ScheduledEventMetadata",
      id: string,
      tenant: string,
      landscape: string,
      tenantLandscape: string,
      title: string,
      description?: string | null,
      jobId: string,
      repeatType: RepeatType,
      rruleSet: string,
      holidayExecutionType: HolidayExecutionType,
      useCustomHoliday: _Boolean,
      customHolidayLabels?: Array< string > | null,
      eventTriggerType: EventTriggerType,
      createdBy: string,
      updatedBy: string,
      editedAt?: string | null,
      expirationDate?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    eventStartDateTime: number,
    jobId: string,
    job?:  {
      __typename: "Job",
      id: string,
      tenant: string,
      landscape: string,
      tenantLandscape: string,
      jobCode: string,
      title: string,
      description?: string | null,
      jobTriggerFilePath?: string | null,
      hasOutputFile: _Boolean,
      createdAt: string,
      updatedAt: string,
    } | null,
    jobExecutionStatus: JobExecutionStatus,
    tasks?:  {
      __typename: "ModelTaskConnection",
      nextToken?: string | null,
    } | null,
    taskHistories?:  {
      __typename: "ModelTaskHistoryConnection",
      nextToken?: string | null,
    } | null,
    executedBy: string,
    executionArn?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateTaskHistorySubscriptionVariables = {
};

export type OnCreateTaskHistorySubscription = {
  onCreateTaskHistory?:  {
    __typename: "TaskHistory",
    jobIdOrder: string,
    jobId: string,
    order: number,
    scheduledEventHistoryId: string,
    task?:  {
      __typename: "Task",
      version: string,
      product: string,
      batch: string,
      batchName: string,
      versionProductBatch: string,
      jobId: string,
      order: number,
      jobIdOrder: string,
      title: string,
      includeInDownload?: _Boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    tenant: string,
    landscape: string,
    tenantLandscape: string,
    taskStartDateTime?: number | null,
    taskEndDateTime?: number | null,
    taskExecutionStatus: TaskExecutionStatus,
    log: string,
    outputFilePath?: string | null,
    includeInDownload?: _Boolean | null,
    taskTitle?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateTaskHistorySubscriptionVariables = {
};

export type OnUpdateTaskHistorySubscription = {
  onUpdateTaskHistory?:  {
    __typename: "TaskHistory",
    jobIdOrder: string,
    jobId: string,
    order: number,
    scheduledEventHistoryId: string,
    task?:  {
      __typename: "Task",
      version: string,
      product: string,
      batch: string,
      batchName: string,
      versionProductBatch: string,
      jobId: string,
      order: number,
      jobIdOrder: string,
      title: string,
      includeInDownload?: _Boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    tenant: string,
    landscape: string,
    tenantLandscape: string,
    taskStartDateTime?: number | null,
    taskEndDateTime?: number | null,
    taskExecutionStatus: TaskExecutionStatus,
    log: string,
    outputFilePath?: string | null,
    includeInDownload?: _Boolean | null,
    taskTitle?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteTaskHistorySubscriptionVariables = {
};

export type OnDeleteTaskHistorySubscription = {
  onDeleteTaskHistory?:  {
    __typename: "TaskHistory",
    jobIdOrder: string,
    jobId: string,
    order: number,
    scheduledEventHistoryId: string,
    task?:  {
      __typename: "Task",
      version: string,
      product: string,
      batch: string,
      batchName: string,
      versionProductBatch: string,
      jobId: string,
      order: number,
      jobIdOrder: string,
      title: string,
      includeInDownload?: _Boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    tenant: string,
    landscape: string,
    tenantLandscape: string,
    taskStartDateTime?: number | null,
    taskEndDateTime?: number | null,
    taskExecutionStatus: TaskExecutionStatus,
    log: string,
    outputFilePath?: string | null,
    includeInDownload?: _Boolean | null,
    taskTitle?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateScheduledHolidayMetadataSubscriptionVariables = {
};

export type OnCreateScheduledHolidayMetadataSubscription = {
  onCreateScheduledHolidayMetadata?:  {
    __typename: "ScheduledHolidayMetadata",
    id: string,
    tenant: string,
    landscape: string,
    tenantLandscape: string,
    title: string,
    description?: string | null,
    repeatType: RepeatType,
    rruleSet: string,
    labels: Array< string >,
    createdBy: string,
    updatedBy: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateScheduledHolidayMetadataSubscriptionVariables = {
};

export type OnUpdateScheduledHolidayMetadataSubscription = {
  onUpdateScheduledHolidayMetadata?:  {
    __typename: "ScheduledHolidayMetadata",
    id: string,
    tenant: string,
    landscape: string,
    tenantLandscape: string,
    title: string,
    description?: string | null,
    repeatType: RepeatType,
    rruleSet: string,
    labels: Array< string >,
    createdBy: string,
    updatedBy: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteScheduledHolidayMetadataSubscriptionVariables = {
};

export type OnDeleteScheduledHolidayMetadataSubscription = {
  onDeleteScheduledHolidayMetadata?:  {
    __typename: "ScheduledHolidayMetadata",
    id: string,
    tenant: string,
    landscape: string,
    tenantLandscape: string,
    title: string,
    description?: string | null,
    repeatType: RepeatType,
    rruleSet: string,
    labels: Array< string >,
    createdBy: string,
    updatedBy: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreatePublicHolidaySubscriptionVariables = {
};

export type OnCreatePublicHolidaySubscription = {
  onCreatePublicHoliday?:  {
    __typename: "PublicHoliday",
    startDate: string,
    language: Language,
    title: string,
    label: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdatePublicHolidaySubscriptionVariables = {
};

export type OnUpdatePublicHolidaySubscription = {
  onUpdatePublicHoliday?:  {
    __typename: "PublicHoliday",
    startDate: string,
    language: Language,
    title: string,
    label: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeletePublicHolidaySubscriptionVariables = {
};

export type OnDeletePublicHolidaySubscription = {
  onDeletePublicHoliday?:  {
    __typename: "PublicHoliday",
    startDate: string,
    language: Language,
    title: string,
    label: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateWebsocketConnectionSubscriptionVariables = {
};

export type OnCreateWebsocketConnectionSubscription = {
  onCreateWebsocketConnection?:  {
    __typename: "WebsocketConnection",
    connectionId: string,
    endpoint: string,
    tenant: string,
    landscape: string,
    hostname: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateWebsocketConnectionSubscriptionVariables = {
};

export type OnUpdateWebsocketConnectionSubscription = {
  onUpdateWebsocketConnection?:  {
    __typename: "WebsocketConnection",
    connectionId: string,
    endpoint: string,
    tenant: string,
    landscape: string,
    hostname: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteWebsocketConnectionSubscriptionVariables = {
};

export type OnDeleteWebsocketConnectionSubscription = {
  onDeleteWebsocketConnection?:  {
    __typename: "WebsocketConnection",
    connectionId: string,
    endpoint: string,
    tenant: string,
    landscape: string,
    hostname: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateWebsocketWaitingResponseSubscriptionVariables = {
};

export type OnCreateWebsocketWaitingResponseSubscription = {
  onCreateWebsocketWaitingResponse?:  {
    __typename: "WebsocketWaitingResponse",
    parentId: string,
    connectionId: string,
    messageType: ResponseExpectedMessageTypes,
    receivedAt: string,
    timeoutAt: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateWebsocketWaitingResponseSubscriptionVariables = {
};

export type OnUpdateWebsocketWaitingResponseSubscription = {
  onUpdateWebsocketWaitingResponse?:  {
    __typename: "WebsocketWaitingResponse",
    parentId: string,
    connectionId: string,
    messageType: ResponseExpectedMessageTypes,
    receivedAt: string,
    timeoutAt: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteWebsocketWaitingResponseSubscriptionVariables = {
};

export type OnDeleteWebsocketWaitingResponseSubscription = {
  onDeleteWebsocketWaitingResponse?:  {
    __typename: "WebsocketWaitingResponse",
    parentId: string,
    connectionId: string,
    messageType: ResponseExpectedMessageTypes,
    receivedAt: string,
    timeoutAt: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateRoleSubscriptionVariables = {
};

export type OnCreateRoleSubscription = {
  onCreateRole?:  {
    __typename: "Role",
    id: string,
    name: string,
    description?: string | null,
    isDefault: boolean,
    systemType: SystemType,
    tenant: string,
    landscape: string,
    permissions: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateRoleSubscriptionVariables = {
};

export type OnUpdateRoleSubscription = {
  onUpdateRole?:  {
    __typename: "Role",
    id: string,
    name: string,
    description?: string | null,
    isDefault: boolean,
    systemType: SystemType,
    tenant: string,
    landscape: string,
    permissions: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteRoleSubscriptionVariables = {
};

export type OnDeleteRoleSubscription = {
  onDeleteRole?:  {
    __typename: "Role",
    id: string,
    name: string,
    description?: string | null,
    isDefault: boolean,
    systemType: SystemType,
    tenant: string,
    landscape: string,
    permissions: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};
